<template>
    <div class="full_content">
        <center :class="{full_width_height : !checkIsFooderHeaderDisplay() }">

            <!-- header start -->
            <div class="full_content_area full" :class="{height_auto : !checkIsFooderHeaderDisplay() }">
                <div class="pane_top_div pane_top_height" :class="{no_header_height : !checkIsFooderHeaderDisplay() }" ref="header_div">

                    <div class="pane_top_logo_div" v-if="checkIsFooderHeaderDisplay()">
                        <a href="/">
                            <img :src="'/files/images/logo/logo.png'" align="absmiddle" class="logo_img" />
                        </a>
                    </div>
                    <div class="pane_top_device max_width">
                        <div class="left_div">

                            <div class="more_div" @click="topShowMoreOpen()">
                            </div>

                            <div class="main_logo pane_top_desktop">
                                <a href="/">
                                    <img :src="'/files/images/logo/logo.png'" align="absmiddle" class="logo_img" />
                                </a>
                            </div>                            

                        </div>
                        <div class="right_div">
                            
                            <div class="basket_btn" @click="$root.openCart()" v-if="checkPaneTopBasketDisplay()">
                                <div class="basket_icon_div"></div>
                                <div class="basket_count_div">
                                    <div class="basket_count">
                                        {{ cartItemCount }}
                                    </div>
                                </div>
                            </div>

                            <div class="window_close_btn" @click="pageCloseWebView()" v-if="!checkIsFooderHeaderDisplay()">
                                <div class="window_close_icon_div"></div>                               
                            </div>
                            
                        </div>
                    </div>
                    <!-- pane_top end -->

                </div>
            </div>
            <!-- header end -->

            <!-- main start -->
            <div class="full_content_area full main_content_div" :class="{noHeader : !checkIsFooderHeaderDisplay(), full_width_height : !checkIsFooderHeaderDisplay() }" v-if="checkBrowser.checking">
                <div ref="main_div" :class="{full_width_height : !checkIsFooderHeaderDisplay() }">
                    <transition name="fade" mode="out-in">
                        <router-view class="view"></router-view>
                    </transition>
                </div>
            </div>
            <div class="full_content_area full main_content_div" v-if="!checkBrowser.checking">   
                <div class="staticpage" v-if="!checkBrowser.version">
                    <div class="staticpage_area">
                        <div class="staticpage_div">
                            <div class="staticpage_inner_area">
                                <div class="staticpage_content" v-html="label['error_browserVersion_msg']"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="staticpage" v-if="!checkBrowser.resolution">
                    <div class="staticpage_area">
                        <div class="staticpage_div">
                            <div class="staticpage_inner_area">
                                <div class="staticpage_content" v-html="label['error_browserResolution_msg']"></div>
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
            <!-- main end -->

            <!-- footer start -->
            <div class="" v-if="!checkIsFooderHeaderDisplay()">
                <div class="" ref="footer_div">
                </div>
            </div>
            <div class="full_content_area full" v-if="checkIsFooderHeaderDisplay()">
                <div class="full_content_area pane_bottom_footer_div pane_bottom_top_border" ref="footer_div">

                    <div class="pane_bottom max_width">

                        <div class="pane_bottom_row_3">

                            <div class="terms_div">

                                <div class="terms_link_div"
                                     v-for="(page, index) in info.staticPages"
                                     :key="index"
                                     @click="$router.push(page.url)">
                                    <div class="text_div">{{ label[page.label] }}</div>
                                </div>

                            </div>

                            <div class="copyright_div">
                                <div class="text_div" v-html="label['footer_text_Copyright_AllRightReserved']"></div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
            <!-- footer end -->

            <!-- more menu start -->
            <transition name="SlideLeftFast">
                <div class="more_menu" v-if="topShowMore == true" :style="{'height':full_screen_height.height_fix}">
                    <div class="more_menu_main_div">

                        <div class="more_menu_header_div">
                            <div class="close_div">
                                <div class="close_btn" @click="topShowMoreClose()"></div>
                            </div>
                        </div>

                        <div class="more_menu_content_div">

                            <div class="inner_content_div" v-if="cart.member == null">
                                <div class="login_btn_div" @click="LoginBtnClick()">
                                    <div class="login_btn">{{label['sidemenu_login_btn_text']}}</div>
                                </div>

                                <div class="inner_content_row cursor" @click="$root.CommonAppDownloadPage()">
                                    <div class="inner_content_row_heightlight_text_div">{{label['sidemenu_not_member_register_text']}}</div>
                                </div>
                            </div>

                            <div class="inner_content_div" v-if="cart.member != null">

                                <div class="inner_content_row cursor account" @click="MemberProfileClick()">
                                    <div class="inner_content_row_icon"></div>
                                    <div class="inner_content_row_text_div">
                                        <div class="inner_content_row_text">{{label['sidemenu_account_text']}}</div>
                                        <div class="inner_content_row_subtext">{{cart.member.name}}</div>
                                    </div>
                                </div>

                                <div class="inner_content_row cursor my_order" @click="MemberMyOrderClick()">
                                    <div class="inner_content_row_icon"></div>
                                    <div class="inner_content_row_text_div">
                                        <div class="inner_content_row_text">{{label['sidemenu_my_order_text']}}</div>
                                    </div>
                                </div>

                                <div class="inner_content_row cursor address" @click="MemberProfileClick()">
                                    <div class="inner_content_row_icon"></div>
                                    <div class="inner_content_row_text_div">
                                        <div class="inner_content_row_text">{{label['sidemenu_my_address_text']}}</div>
                                    </div>
                                </div>

                                <div class="inner_content_row cursor logout" @click="LogoutBtnClick()" v-if="checkIsFooderHeaderDisplay()">
                                    <div class="inner_content_row_icon"></div>
                                    <div class="inner_content_row_text_div">
                                        <div class="inner_content_row_text">{{label['sidemenu_logout_btn_text']}}</div>
                                    </div>
                                </div>

                            </div>

                            <!-- lang_div start -->
                            <div class="lang_div">
                                <div class="lang_list_div">

                                    <div class="lang_tag">
                                        <div class="lang_tag_div"
                                             v-for="(lang, index) in info.langcodes"
                                             :key="index"
                                             @click="setLanguage(lang.code)"
                                             v-if="lang.code != info.lang">
                                            {{ lang.name }}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- lang_div end -->
                            
                        </div>
                    </div>
                </div>
            </transition>
            <!-- more menu end -->

            <!-- common cart list start -->
            <transition name="SlideLeft">
                <div class="common_cart_list" v-if="info.showShopCartList" :key="info.updateCartList" :style="common_cart_list_style_postion_fix">
                    <div class="common_cart_list_area common_cart_list_width" :style="common_cart_list_area_style">
                        <div class="common_cart_list_content_area">

                            <div class="cart_back_area">
                                <div class="back_btn" @click="closeCart()"></div>
                            </div>

                            <div class="cart_top_area" id="cart_top_area">
                                <div class="header_text">{{label['order_cart_header']}}</div>

                                <div class="cart_main_content_div">
                                    
                                    <div class="cart_order_info_div">
                                        <div class="cart_order_info_display_div" @click="OpenOrderInfoEditLayer()">
                                            <div class="cart_order_info_type_icon" :class="info.order_temp_info.order_type"></div>
                                            <div class="cart_order_info_text_div" v-if="info.order_setting.order_time_select">
                                                <div class="cart_order_info_date">{{info.order_temp_info.order_date}}</div>
                                                <div class="cart_order_info_time">{{ info.order_temp_info.order_time == "asap" ? label["order_time_option_asap"] : info.order_temp_info.order_time }}</div>
                                            </div>
                                            <div class="cart_order_info_text_div" v-if="!info.order_setting.order_time_select">
                                                <div class="cart_order_info_date date_only" v-if="$root.getCurrentOrderTypeSubfix == '1'">{{info.order_temp_info.order_date}}</div>
                                                <div class="cart_order_info_date date_only" v-if="$root.getCurrentOrderTypeSubfix == '2'">{{$root.GetOrderModePickupTypeLabel(2)}}</div>
                                                <div class="cart_order_info_date date_only" v-if="$root.getCurrentOrderTypeSubfix == '3'">{{$root.GetOrderModePickupTypeLabel(3)}}</div>
                                            </div>
                                            <div class="cart_order_info_btn" v-if="!info.order_setting.aspa_only" style="display:none;"></div>
                                        </div>
                                    </div>  
                                    
                                    <div class="cart_item_list_div" v-if="cart != null">

                                        <CartListItem v-bind:cart="cart" v-bind:can_update="true">
                                        </CartListItem>

                                    </div>
                                    <!-- cart_item_list_div -->

                                </div>

                                <div class="cart_sub_content_div" v-if="cart != null">

                                    <div class="sub_content_row" v-if="info.order_setting.needCutlery">
                                        <div class="cart_item_info_row">

                                            <div class="cart_cutlery_div">                                                
                                                <div class="cart_cutlery_title" @click="CartNeedCutleryClick()">
                                                    <div class="cart_cutlery_tick_box" :class="{active: cart.needCutlery}"></div>
                                                    <!--<div class="cart_cutlery_icon"></div>-->
                                                    <div class="cart_cutlery_title_text">{{label['order_need_extra_items']}}</div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="sub_content_row" v-if="(cart.amountWithoutDiscount != null)">
                                        <div class="price_text">{{label['amount_label']}}</div>
                                        <div class="price_amount">
                                            <!--<money :price="sumItemListPrice(cart.items)" />-->
                                            <money :price="cart.amountWithoutDiscount" />
                                        </div>
                                    </div>

                                    <div class="sub_content_row isAlert" v-if="(cart.minCharge > 0)">
                                        <div class="price_text">{{label['cart_fit_minCharge_text']}}</div>
                                        <div class="price_amount">
                                            <money :price="cart.minCharge" />
                                        </div>
                                    </div>

                                    <div class="sub_content_row" v-if="(cart.packingCharge != null && cart.packingCharge > 0)">
                                        <div class="price_text">{{label['cart_packingCharge_text']}}</div>
                                        <div class="price_amount">
                                            <money :price="cart.packingCharge" />
                                        </div>
                                    </div>                                    

                                    <!-- load discount item start -->
                                    <div class="sub_content_row"
                                         v-for="(discount, index) in cart.discounts.filter(x => !x.isHide)"
                                         :key="'d'+index">
                                        <div class="price_text">{{discount['name'+getItemSubfix()]}}</div>
                                        <div class="price_amount">
                                            -<money :price="discount.price" />
                                        </div>
                                    </div>
                                    <!-- load discount item end -->

                                    <div class="sub_content_row" v-if="cart.items.length > 0 && cart.deliveryCharge > 0">
                                        <div class="price_text">{{label['cart_deliveryCharge_text']}}</div>
                                        <div class="price_amount">
                                            <money :price="cart.deliveryCharge" />
                                        </div>
                                    </div>

                                    <div class="sub_content_row" v-if="cart.items.length > 0 && cart.usedECash > 0">
                                        <div class="price_text">{{label['checkout_order_use_ecash_text_used_ecash']}}</div>
                                        <div class="price_amount">
                                            -<money :price="cart.usedECash" />
                                        </div>
                                    </div>
                                </div>

                                <!--
                                <div class="cart_coupon_content_div" v-if="info.enableCouponCode">
                                    <div class="cart_coupon_content_row">
                                        <div class="cart_coupon_title_div">{{label["cart_couponCode_title_text"]}}</div>
                                        <div class="cart_coupon_action_icon_div" :class="{active : CheckCartUseCouponCodeOpen()}" @click="CartUseCouponCodeOpen();"></div>
                                    </div>
                                    <transition name="sliderDiv">
                                        <div style="width:100%;" v-if="CheckCartUseCouponCodeOpen()">
                                            <div class="cart_coupon_content_row">
                                                <div class="cart_coupon_div" v-if="info.couponCode.open">
                                                    <div class="coupon_div">
                                                        <div class="coupon_input_div">
                                                            <input type="text"
                                                                   :placeholder="label['cart_couponCode_title_text']"
                                                                   class="form-control"
                                                                   id="cart_couponCode"
                                                                   autocomplete="off"
                                                                   v-model="info.couponCode.value" />
                                                        </div>
                                                        <div class="coupon_btn_div">
                                                            <div class="coupon_btn coupon_use_btn" @click="submitCouponCode();">{{label["cart_couponCode_btn_text_use"]}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="coupon_div error_msg" v-if="info.couponCode.error"><div class="msg_text">{{label["cart_couponCode_error_text"]}}</div></div>
                                                </div>
                                                <div class="cart_coupon_div" v-if="!info.couponCode.open && cart.couponCode">
                                                    <div class="coupon_div">
                                                        <div class="coupon_input_div">{{cart.couponCode}}</div>
                                                        <div class="coupon_btn_div">
                                                            <div class="coupon_btn coupon_use_btn" @click="removeCouponCode();">{{label["cart_couponCode_btn_text_remove"]}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                            
                                        </div>
                                    </transition>
                                                                        
                                </div>
                                -->
                                <!-- cart_total_amount_div for coupon end -->

                            </div>

                            <div class="cart_bottom_area">
                                <!--
                                <div class="sub_content_row bottom_border" v-if="info.order_setting.needCutlery">
                                    <div class="cart_item_info_row">

                                        <div class="cart_cutlery_div">                                                
                                            <div class="cart_cutlery_tick">                                                
                                                <div class="cart_cutlery_tick_text">{{label['order_need_extra_items']}}</div>
                                            </div>
                                            <div class="cart_cutlery_title" @click="CartNeedCutleryClick()">
                                                <div class="cart_cutlery_tick_box" :class="{active: cart.needCutlery}"></div>
                                                <div class="cart_cutlery_icon"></div>
                                                <div class="cart_cutlery_title_text">{{label['order_need_cutlery_title']}}</div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                -->
                                <div class="cart_bottom_amount_div">
                                    <div class="total_price_area">
                                        <div class="total_price_text display_responsive">{{label['item_cart_qty_text_a']}}{{ cartItemCount }}{{label['item_cart_qty_text_b']}}</div>
                                        <div class="total_price_text display_desktop">{{label['total_amount_label']}}</div>
                                        <div class="total_price_amount" v-if="cart.items.length > 0">
                                            <money :price="cart.amount" />
                                        </div>
                                        <div class="total_price_amount" v-if="cart.items.length <= 0">
                                            <money :price="0" />
                                        </div>
                                    </div>
                                    <div class="checkout_btn_area">
                                        <div class="checkout_btn" :class="{active: cartItemCount > 0}" @click="checkout()">{{label['checkout_label']}}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </transition>
            <!-- common cart list end -->


            <!-- modify_address_area start -->
            <transition name="slide-up">
                <div class="modify_address_area" v-if="is_modify_address" :style="{'height':full_screen_height.height_fix}">

                    <div class="modify_address_div">

                        <div class="modify_address_header_area">
                            <!--<div class="modify_address_back_btn display_responsive" @click="modifyAddressClose()"></div>
                            <div class="modify_address_close_btn display_desktop" @click="modifyAddressClose()"></div>-->
                            <div class="modify_address_close_btn" @click="modifyAddressClose()"></div>
                        </div>
                        <!-- modify_address_header_area end -->

                        <div class="modify_address_body_area" :class="{modifyAddress: is_modify_address_edit}">

                            <div class="modify_address_info_area">
                                <div class="modify_address_info_header">{{modify_address_header_text}}</div>
                            </div>
                            <!-- modify_address_info_area end -->

                            <transition name="sliderDiv">
                                <div class="modify_address_display_area" v-if="!is_modify_address_edit">

                                    <div class="modify_address_list_area">

                                        <div class="modify_address_list_row"
                                             v-for="(addObj, index) in modify_address_list"
                                             :key="'madd'+index">
                                            <div class="modify_address_list_div" :class="{isselect : addObj.isSelect}">

                                                <div class="address_text_area">
                                                    <div class="address_text_div" @click="modifyAddressSelectClick(addObj)">
                                                        <div class="addres_contact">
                                                            <span v-if="addObj.address_tag != undefined && addObj.address_tag != ''">{{addObj.address_tag}}．</span>{{addObj.contact_info['name']}}．+{{addObj.contact_info['tel_countryCode']}}-{{addObj.contact_info['tel']}}
                                                        </div>
                                                        <div class="address_text">{{addObj.address['address_full_'+info.lang]}}</div>                                                        
                                                    </div>
                                                    <div class="address_edit_div">
                                                        <div class="address_edit_btn" @click="modifyAddressEditClick(addObj)">{{label['common_text_edit']}}</div>
                                                    </div>

                                                </div>

                                            </div>
                                            <!-- modify_address_list_div -->

                                        </div>
                                        <!-- modify_address_list_row -->

                                    </div>
                                    <!-- modify_address_list_area end -->

                                    <div class="modify_address_new_address_area">

                                        <div class="modify_address_new_address_div">
                                            <div class="new_address_btn_area" @click="modifyAddressEditClick()">
                                                <div class="new_address_btn_div"></div>
                                                <div class="new_address_text_div">{{label['add_address_text']}}</div>
                                            </div>
                                        </div>
                                        <!-- modify_address_new_address_div -->

                                    </div>
                                    <!-- modify_address_new_address_area end -->

                                </div>
                            </transition>
                            <!-- modify_address_display_area -->

                            <transition name="sliderDiv">
                                <div class="modify_address_form_area" v-if="is_modify_address_edit" >
                                    <div class="modify_address_form_div">

                                        <div class="address_form_close_div">
                                            <div class="close_btn" @click="modifyAddressEditClick()"></div>
                                        </div>

                                        <div class="address_form_full_address_div" :key="modify_address_isUpdate">{{modify_address.address['address_full_'+info.lang]}}</div>

                                        <div class="address_form_div">

                                            <div class="map_address_area address_input_div">
                                                <div class="map_location_icon" @click="$root.SearchAddressPositionLL('modify_address_map_location_input','add_modify')"></div>
                                                <div class="map_location_input_div input_area" :class="{inSearch : $root.isSearchAddressFocus}">
                                                    <input autocomplete="off" type="text" class="map_location_input" id="modify_address_map_location_input" value="" :placeholder="label['search_address_building_text']" @keyup="$root.SearchAddressText($event,'add_modify')" @focus="$root.SearchAddressFocus($event,'add_modify')" @blur="$root.SearchAddressBlur($event,'add_modify')" />
                                                </div>
                                                <div class="map_location_cancel_icon_div" v-if="$root.isSearchAddressFocus">
                                                    <div class="map_location_cancel_icon" @click="$root.SearchAddressCancel()"></div>
                                                </div>
                                                <div class="map_location_cancel_icon_div search_icon" v-if="$root.isSearchAddressFocus">
                                                    <div class="map_location_cancel_icon" @click="$root.SearchAddressText($event,'add_modify')"></div>
                                                </div>
                                            </div>

                                            <div class="flat_floor_area">
                                                <div class="block_div">
                                                    <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_block_input" v-model="modify_address.address.block" maxlength="10" :placeholder="label['modify_address_block_text']" @blur="modifyAddressUpdateFullAddress()" />
                                                </div>
                                                <div class="floor_div">
                                                    <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_floor_input" v-model="modify_address.address.floor" maxlength="10" :placeholder="label['modify_address_floor_text']" @blur="modifyAddressUpdateFullAddress()" />
                                                </div>
                                                <div class="flat_div">
                                                    <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_flat_input" v-model="modify_address.address.flat" maxlength="10" :placeholder="label['modify_address_flat_text']" @blur="modifyAddressUpdateFullAddress()" />
                                                </div>
                                            </div>

                                            <div class="receiver_area">
                                                <div class="receiver_header_area">{{label['modify_address_header']}}</div>

                                                <div class="receiver_input_area">                                                    
                                                    <div class="receiver_name_div">
                                                        <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_contact_name_input" v-model="modify_address.contact_info.name" maxlength="50" :placeholder="label['modify_address_name_text']" @blur="modifyAddressUpdateKey()" />
                                                    </div>
                                                    <div class="receiver_tel_div">
                                                        <select class="address_form_input select" id="modify_address_map_location_contact_tel_countryCode_input" v-model="modify_address.contact_info.tel_countryCode">
                                                            <option v-for="(c, index) in countryCodeList" :value="c">
                                                                +{{c}}
                                                            </option>
                                                        </select>
                                                        <input autocomplete="off" type="text" class="address_form_input selectinput" id="modify_address_map_location_contact_tel_input" v-model="modify_address.contact_info.tel" maxlength="20" :placeholder="label['modify_address_tel1_text']" @blur="modifyAddressUpdateKey()" />
                                                    </div>
                                                    <!--<div class="receiver_subtel_div">
                                                        <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_contact_tel2_input" v-model="modify_address.contact_info.tel2" maxlength="20" :placeholder="label['modify_address_tel2_text']" />
                                                    </div>-->
                                                </div>

                                            </div>

                                            <div class="save_address_area">
                                                <div class="save_address_div" :class="{active : modify_address_isSave}" @click="modifyAddressIsSaveClick()">
                                                    <div class="save_addres_tick"></div>
                                                    <div class="save_address_text">{{label['modify_address_save_address_text']}}</div>
                                                </div>
                                                <transition name="sliderDivFastSmall">
                                                    <div class="receiver_name_div" v-if="modify_address_isSave">
                                                        <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_address_tag_input" v-model="modify_address.address_tag" maxlength="50" :placeholder="label['modify_address_tag_text']" />
                                                    </div> 
                                                </transition>
                                            </div>

                                        </div>

                                        <div class="address_form_update_btn_div">
                                            <div class="address_confirm_btn" :class="{active : modifyAddressEditCheckCanSubmit(false)}" @click="modifyAddressEditUpdate()">{{label['modify_address_complete_address_text']}}</div>
                                        </div>

                                    </div>
                                </div>
                            </transition>
                            <!-- modify_address_form_area -->

                        </div>

                        <div class="modify_address_confirm_area" v-if="!is_modify_address_edit">
                            <div class="modify_address_confirm_btn" :class="{active : !is_modify_address_edit}" v-if="!is_modify_address_edit" @click="modifyAddressSelect()">{{label['modify_address_confirm_text']}}</div>
                        </div>
                        <!-- modify_address_confirm_area end -->

                    </div>
                </div>
            </transition>
            <!-- modify_address_area end -->


            <!-- address select div start -->
            <transition name="sliderDivFast">
                <div class="search_address_select_main" ref="search_address_select_main" v-bind:style="search_address_select_main_style" v-if="isSearchAddress">

                    <div class="searching_icon" v-if="isGetSearchAddress == 0">
                        <div class="loading_icon"></div>
                    </div>
                    <div class="search_result_div" v-if="isGetSearchAddress == 2">
                        <div class="search_address_select_row">
                            <div class="search_address_select_text">{{label['search_address_address_not_found']}}</div>
                        </div>
                    </div>
                    <div class="search_result_div" v-if="isGetSearchAddress == 1">
                        <div class="search_address_select_row"
                             v-for="(add, index) in SearchAddressList"
                             :key="index"
                             @click="SearchAddressSelect(add)">
                            <div class="search_address_select_text">{{ add["address_" + info.lang] }}</div>
                        </div>
                    </div>

                </div>
            </transition>
            <!-- address select div end -->


            <!-- order info data layer start -->
            <transition name="slide-up">
                <div class="order_info_data_layer" v-if="showOrderInfoEditLayer" :style="{'height':full_screen_height.height_fix}">

                    <div class="order_info_data_layer_div">

                        <div class="order_info_data_layer_header_area">
                            <div class="order_info_data_layer_close_btn" @click="CloseOrderInfoEditLayer()"></div>
                        </div>
                        <!-- order_info_data_layer_header_area end -->

                        <div class="order_info_data_layer_body_area">

                            <div class="order_info_data_layer_info_area">
                                <div class="order_info_data_layer_info_header">{{label['modify_order_info_select_datetime_title']}}</div>
                            </div>
                            <!-- order_info_data_layer_info_area end -->

                            <div class="order_info_data_layer_display_area">

                                <div class="order_type_title" v-if="!$root.CheckOrderModeIsShopping">{{label['modify_order_info_delivery_method_title']}}</div>
                                <div class="order_type_title" v-if="$root.CheckOrderModeIsShopping">{{label['shopping_mode_delivery_method_title']}}</div>
                                <div class="order_type_tag_div">                        
                                    <div class="order_type_select_tag" v-if="$root.info.order_setting.orderType.indexOf('delivery') >= 0" :class="{active : order_type_layer_temp == 'delivery'}" @click="UpdateOrderInfoTypeLayerTemp('delivery')">{{$root.GetOrderModePickupTypeLabel(1)}}</div>
                                    <div class="order_type_select_tag" v-if="$root.info.order_setting.orderType.indexOf('pickup') >= 0" :class="{active : order_type_layer_temp == 'pickup'}" @click="UpdateOrderInfoTypeLayerTemp('pickup')">{{$root.GetOrderModePickupTypeLabel(2)}}</div>
                                    <div class="order_type_select_tag" v-if="$root.info.order_setting.orderType.indexOf('pickupShop') >= 0" :class="{active : order_type_layer_temp == 'pickupShop'}" @click="UpdateOrderInfoTypeLayerTemp('pickupShop')">{{$root.GetOrderModePickupTypeLabel(3)}}</div>
                                </div>

                                <div class="order_time_div" v-if="order_date_layer_list.length > 1">
                                    <div class="order_time_title">{{label['modify_order_info_select_date_title']}}</div>
                                    <div class="order_time_option_div">
                                        <div class="order_time_option one_tag">
                                            <select class="" @change="UpdateOrderInfoDateLayerTemp($event)">
                                                <option class=""
                                                        v-for="(i, index) in order_date_layer_list"
                                                        :value="i"
                                                        :selected="i == order_date_layer_temp">
                                                    {{ $root.OrderDateTagTextDisplay(i) }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="order_time_div" v-if="info.order_setting.order_time_select">
                                    <div class="order_time_title">{{label['modify_order_info_select_datetime_title']}}</div>
                                    <div class="order_time_option_div">
                                        <div class="order_time_option one_tag">
                                            <select class="" @change="UpdateOrderInfoTimeLayerTemp($event)">
                                                <option class=""
                                                        v-for="(i, index) in order_time_layer_list"
                                                        :value="i"
                                                        :selected="i == order_time_layer_temp">
                                                    {{ i == "asap" ? label["order_time_option_asap"] : i }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <!-- order_info_data_layer_display_area -->

                        </div>

                        <div class="order_info_data_layer_confirm_area">
                            <div class="order_info_data_layer_confirm_btn" :class="{disabled: order_time_layer_temp == '---'}" @click="ClickOrderInfoEditLayerBtn()">{{label['modify_order_info_confirm_text']}}</div>
                        </div>
                        <!-- order_info_data_layer_confirm_area end -->

                    </div>
                </div>
            </transition>
            <!-- order info data layer start -->

        </center>



        <modal v-if="info.alertMsg" @close="info.alertMsg = ''">
            <div slot="body" v-html="info.alertMsg"></div>
            <div slot="footer" class="text-center">
                <button class="close_btn" @click="info.alertMsg = ''">
                    {{ label["alert_close_btn"] }}
                </button>
            </div>
        </modal>

        <modal v-if="info.confirmMsg" @close="info.confirmMsg = ''">
            <div slot="body" v-html="info.confirmMsg"></div>
            <div slot="footer" class="text-center">
                <button class="delete_btn" @click="confirmMsgConfirmClick()">
                    {{ label["alert_confirm_btn"] }}
                </button>

                <button class="close_btn" @click="confirmMsgCancelClick()">
                    {{ label["alert_close_btn"] }}
                </button>
            </div>
        </modal>


        <div class="loading-dialog d-flex justify-content-center" v-if="info.loading">
            <div class="content align-self-center">
                <span class="ic ic-loading"></span>
            </div>
        </div>


        <modal v-if="info.deleteItem" @close="confirmDeleteCancel()">
            <div slot="body" v-html="info.deleteItemMessage"></div>
            <div slot="footer" class="text-center">
                <button class="delete_btn" @click="confirmDelete()">
                    {{label["remove_cart_item_label"]}}
                </button>

                <button class="close_btn" @click="confirmDeleteCancel()">
                    {{ label["alert_close_btn"] }}
                </button>
            </div>
        </modal>

        <modalTop v-if="modalTopMessage != ''" @close="modalTopMessage=''">
            <div slot="body" v-html="modalTopMessage"></div>
            <div slot="footer" class="text-center">
                <button class="close_btn" @click="modalTopMessage=''">
                    {{ label["alert_close_btn"] }}
                </button>
            </div>
        </modalTop>

    </div>
</template>

<script>
    import router from "../router";
    import cart from "../cart";
    import Modal from "../components/Modal.vue";
    import Modal2 from "../components/Modal2.vue";
    import ModalTop from "../components/ModalTop.vue";
    import CartListItem from "../components/CartListItem.vue";
    cart.init();

    export default {
        router,
        data: {
            showHeader: true,
            showFooter: true,
            info: {
                pageMode: null,
                member_id: -1,

                gt_login_page_url: "",
                gt_login_page_url_app: "",
                gt_clientId: "",

                order_setting: {
                    "order_start_date": "today",
                    "order_date_range": 3,
                    "order_start_from_date": 1,
                    "holidayCount": null,
                    "order_time_select": true,
                    "order_time_start_from_mins_delivery": 120,
                    "order_time_start_from_mins_pickup": 60,
                    "order_time_starting_time": "08:00",
                    "order_time_ending_time": "22:00",
                    "order_time_minutes_range": 30,
                    "alow_aspa": true,
                    "aspa_only": false,
                    "location_datetime_modify_redirect": true,
                    "orderType": [],
                    "FitMinCharge": false,
                    "deliveryMinCharge": 0,
                    "pickupMinCharge": 0,
                    "skipZeekShopList": false,
                    "autoShopSelect": false,
                    "pickupShopAreaFilter": false,
                    "itemDetailsDisplayVersion": 1,
                    "needCutlery": true,
                    "needDeliveryRemarks": true,
                    "active": false
                },
                order_temp_info: {
                    home_select_shop: "",
                    temp_default_shop: "",
                    temp_default_shop_isInit: false,
                    temp_default_shop_obj: null,
                    temp_default_item: "",
                    order_device: "web",
                    order_mode: "order", // order, shopping...
                    order_type: "pickup", // delivery, pickup // set default as pickup for nanfung
                    order_type_temp: "pickup", 
                    order_date_list: [],
                    order_time_list: [],
                    order_date: "",
                    order_time: "",
                    order_shop_menu_time: "00:00",
                    order_address_type: "search", // search, member
                    order_address_sample: { "address_full_zh": "", "address_full_en": "", "address_full_sc": "", "address_zh": "", "address_en": "", "address_sc": "", "block":"", "floor":"", "flat":"", "location":"0,0"  },
                    order_contact_info_sample: { "name": "", "tel": "", "tel_countryCode": "852", "tel2": "", "tel2_countryCode": "852", "email":"" },
                    order_address_id: "search",
                    order_address_tag: "",
                    order_address: null,
                    order_contact_info: null,
                },
                memberAddressSaveLimit:3,

                confirmMsg: "",
                confirmMsgConfirmAction: undefined,
                confirmMsgCancelAction: undefined,

                lang: "zh",
                langws: "tc",
                langcodes: [],
                openLangBox: false,
                alertMsg: "",
                wsHost: "",
                wsUrl: "/api",

                currentDomain: window.location.origin,
                currentFullPath: window.location.origin + window.location.pathname,
                showCouponIcon: false,
                canGoBack: window.location.pathname != "/",
                currentPathName: "/",
                loading: false,
                order: undefined,
                orderResult: undefined,
                selectedCoupon: undefined,
                serverTimeDiff: 0,

                browserResolutionSmallChecking: false,
                browserResolutionLargeChecking: false,
                browserResolutionLargeReDirect: "",
                enableCouponCode: false,
				enableDiscountCode: false,
                hideUnavailableItem: true,
                receiveNews: false,
                allowGuestMode: false,
                menuPageDisplayMode: 1,
                readyTimeDays: 0,
                itemSoldOutQty: 0,

                nextLevelAmountAlert: 50,

                disableDiscountBtn: false,

                "iphone_download_url": "",
                "android_download_url": "",
                "app_open_url": "",
                "googleMapLocation": false,

                staticPages: [],
                selectBrand: null,
                selectShop: null,

                core_info: {
                    "logo": "",
                    "description1": "",
                    "description2": "",
                    "social": []
                },

                BrandBanners: [],
                ShopCategoryStatisPage: [],

                showShopCartList: false,
                itemMenuDetailsOpen: false,
                couponCode: {
                    value: "",
                    open: false,
                    error: false,
                },
                couponCode_area_isOpen:false,
                deleteItem: null,
                deleteItemMessage: "",
                updateCartList: 0,

                responsive_width:750,
                display_header: true
            },
            cart: cart,
            goBackAction: undefined,
            exitAction: undefined,
            finishAction: undefined,

            topShowMore: false,

            disableItem: [],
            itemImagePath:"",
            defaultShop: "",

            ga_id: "",
            facebook_pixel_id: "",
            googleTagKey: "",
            isWhatsApp : false,
            whatsappNo: "",
            whatsappLink: "",
            whatsappLinkWeb: "",
            NFExternalAppBrowser: "",
            checkBrowser: { "checking": true, "version": true, "resolution": true },

            "googleLoginID": "",
            "appleLoginID": "",
            "ios_payMethod_openURL": [],
            "android_payMethod_openURL": [],

            common_cart_list: {},
            common_cart_list_init:false,
            common_cart_list_area_style: { "margin-top": `0`, "height": `0` },
            bodyfit_style: { "min-height": "auto" },
            bodyfit_style_start: { "min-height": "auto" },
            common_cart_list_style_postion_fix: {},
            header_div_info: { "height": 0 },
            cart_item_qty_arr_0: [0,1,2,3,4,5,6,7,8,9,10],

            AllShopDistrictList: [],
            shoppingDistrictList: [],
            AllShopList:[],
            AllHolidayList:[],
            currentPositionLL:null,
            LLShopList:[],
            menuIsUpdate: 0,

            is_modify_address: false,
            is_modify_address_edit: false,
            address_list: [],  // search address + member address list { "address_id":"", "address_type":"", "address_tag": "", "address": order_address_sample, "contact_info": order_contact_info_sample, isDefault:false, isSelect:false, isSave:false, isMemberSelect:false }
            modify_address_list: [],
            modify_address: null,
            modify_address_isSave:false,
            modify_address_header_text: null,
            modify_address_isUpdate: 0,

            member_prefer_shop_list: [],
            memberPreferShopList: [],

            isSearchAddress: false,
            isSearchAddressFocus:false,
            SearchAddressPageType:null,
            isGetSearchAddress: 0,
            SearchAddressCurrentText: "",
            SearchAddressDisplayText: "",
            search_address_select_main_style: { "top":`0`, "left": `0` },
            SearchAddressList:[],
            SearchAddressTarget: null,

            showOrderInfoEditLayer: false,
            showOrderInfoEditLayerCallBack: null,
            order_type_layer_temp:'',
            order_date_layer_temp:'',
            order_time_layer_temp:'',
            order_date_layer_list: [],
            order_time_layer_list: [],

            full_screen_height: {
                    height_fix:"100vh"
                },

            page_after_login: "/",

            reorder_temp_data : {
                shop: null,
                items: []
            },

            homeSelectShop: {
                homeSelectShopArea: "",
                homeSelectShopAreaDistrictList: [],
                homeSelectShopDistrict: "",
                homeSelectShopList: [],
                homeSelectedShopList: ""
            },

            fixHomeOptionObj: {
                "isFix": false,
                "orderMode": "",
                "orderType": "",
                "selectAreaDistrict": false
            },

            tempPaymentMethod: {
                code: "-1",
                name1: "",
                name2: "",
                name3: "",
                image: ""
            },

            countryCodeList: ["852"],

            modalTopMessage: ""
        },
        computed: {
            label() {
                return this.getLabel();
            },
            cartItemCount() {
                return cart.itemCount(this.disableItem);
            },
            //setLanguage(lang) {
                //return this.setLanguage(lang);
            //},
            OrderShopTotalQuoteTime() {
                if (this.cart.shop != null && this.LLShopList.length > 0) {
                    var LLshopInfo = this.getLLShopInfo(this.cart.shop.shopCode);
                    if (LLshopInfo != null) {
                        //return LLshopInfo.quoteTime;
                        var q = LLshopInfo.quoteTime;
                        if (LLshopInfo.shopBufferTime > 0) {
                            q = q + LLshopInfo.shopBufferTimeMin;
                        }
                        if (this.cart != null && this.cart.prepareTime > 0) {
                            q = q + this.cart.prepareTimeMin;
                        }
                        return q;
                    }
                    else {
                        return 0
                    }
                } else {
                    return 0;
                }
            },
            OrderDateSelectShopReadyTime() {
                if (this.info.order_temp_info.order_date == "") {
                    return 0;
                }
                else {
                    if (this.info.order_temp_info.order_time == "asap") {
                        return this.OrderShopTotalQuoteTime;
                    } else {
                        return 0;
                    }
                }
            },
            OrderDateSelectRaw() {
                if (this.info.order_temp_info.order_date == "") {
                    return moment();
                }
                else {
                    if (this.info.order_temp_info.order_time == "asap") {
                        return moment();
                    } else {
                        return moment(this.info.order_temp_info.order_date + " " + this.info.order_temp_info.order_time.split('-')[0].replace(/ /g,''));
                    }
                }
            },
            OrderDateSelect() {
                //console.log("OrderDateSelect this.info.order_temp_info.order_date", this.info.order_temp_info.order_date);
                //console.log("OrderDateSelect this.cart.shop", this.cart.shop);
                //console.log("OrderDateSelect this.LLShopList.length", this.LLShopList.length);
                if (this.info.order_temp_info.order_date == "") {
                    return moment();
                }
                else {
                    if (this.info.order_temp_info.order_time == "asap") {
                        if (this.cart.shop != null && this.LLShopList.length > 0) {
                            var LLshopInfo = this.getLLShopInfo(this.cart.shop.shopCode);
                            var select_datetime = moment();
                            if (LLshopInfo != null) {
                                //select_datetime = select_datetime.add(LLshopInfo.quoteTime, 'minutes');
                                select_datetime = select_datetime.add(this.OrderShopTotalQuoteTime, 'minutes');
                            }

                            //if (this.getCurrentOrderTypeSubfix == "1") {
                                //select_datetime = select_datetime.add(shopInfo.quoteTime,'minutes');
                            //}
                            return select_datetime;
                        } else {
                            return moment();
                        }
                    } else {
                        return moment(this.info.order_temp_info.order_date + " " + this.info.order_temp_info.order_time.split('-')[0].replace(/ /g,''));
                    }
                }
            },
            OrderDateSelectEnd() {
                if (this.info.order_temp_info.order_date == "") {
                    return moment();
                }
                else {
                    if (this.info.order_temp_info.order_time == "asap") {
                        if (this.cart.shop != null && this.LLShopList.length > 0) {
                            var LLshopInfo = this.getLLShopInfo(this.cart.shop.shopCode);
                            var select_datetime = moment();
                            if (LLshopInfo != null) {
                                //select_datetime = select_datetime.add(LLshopInfo.quoteTime, 'minutes');
                                select_datetime = select_datetime.add(this.OrderShopTotalQuoteTime, 'minutes');                                
                            }

                            //if (this.getCurrentOrderTypeSubfix == "1") {
                                //select_datetime = select_datetime.add(shopInfo.quoteTime,'minutes');
                            //}
                            return select_datetime;
                        } else {
                            return moment();
                        }
                    } else {

                        if (this.info.order_temp_info.order_time == "---") {
                            return moment(this.info.order_temp_info.order_date);
                        }
                        else {
                            if (this.info.order_temp_info.order_time.split('-').length > 1) {
                                return moment(this.info.order_temp_info.order_date + " " + this.info.order_temp_info.order_time.split('-')[1].replace(/ /g, ''));
                            }
                            else {
                                return moment(this.info.order_temp_info.order_date + " " + this.info.order_temp_info.order_time.split('-')[0].replace(/ /g, ''));
                            }
                        }                        
                    }
                }
            },
            OrderDateSelectMenuTime() {
                /*
                if (this.info.order_temp_info.order_date == "") {
                    return moment(moment().format("YYYY-MM-DD") + " " + this.info.order_temp_info.order_shop_menu_time);
                }
                else {
                    return moment(this.info.order_temp_info.order_date + " " + this.info.order_temp_info.order_shop_menu_time);
                }
                */
                if (this.info.order_temp_info.order_date == "") {
                    return moment();
                }
                else {

                    if (moment().format("YYYY-MM-DD") == moment(this.info.order_temp_info.order_date).format("YYYY-MM-DD")) {
                        if (this.info.order_temp_info.order_time == "asap") {
                            return moment();
                        } else {
                            if (this.info.order_temp_info.order_time == "---") {
                                return moment(this.info.order_temp_info.order_date);
                            }
                            else {
                                return moment(this.info.order_temp_info.order_date + " " + this.info.order_temp_info.order_time.split('-')[0].replace(/ /g, ''));
                            }
                        }
                    }
                    else {
                        if (this.info.order_temp_info.order_time == "asap" || this.info.order_temp_info.order_time == "---") {
                            return moment(this.info.order_temp_info.order_date);
                        }
                        else {
                            return moment(this.info.order_temp_info.order_date + " " + this.info.order_temp_info.order_time.split('-')[0].replace(/ /g, ''));
                        }
                    }
                    
                }
            },
            OrderDateSelectIsHoliday() {
                return this.AllHolidayList.filter(d => d == this.OrderDateSelectMenuTime.format("YYYY-MM-DD")).length > 0 ? true: false;
            },
            getCurrentOrderType() {
                return this.info.order_temp_info.order_type;
            },
            getCurrentOrderTypeSubfix() {
                //return this.info.order_temp_info.order_type == "delivery" ? "1" : "2";
                if (this.info.order_temp_info.order_type == "delivery") {
                    return "1";
                }
                else if (this.info.order_temp_info.order_type == "pickup") {
                    return "2";
                }
                else if (this.info.order_temp_info.order_type == "pickupShop") {
                    return "3";
                }
                else {
                    return "2";
                }
            },
            getCurrentOrderTypeShopDetailsSubfix() {
                if (this.info.order_temp_info.order_type == "delivery") {
                    return "1";
                }
                else if (this.info.order_temp_info.order_type == "pickup") {
                    return "2";
                }
                else if (this.info.order_temp_info.order_type == "pickupShop") {
                    return "3";
                }
            },
            getCurrentOrderTypeShopFilterSubfix() {
                if (this.info.order_temp_info.order_type == "delivery") {
                    return "1";
                }
                else if (this.info.order_temp_info.order_type == "pickup") {
                    return "2";
                }
                else if (this.info.order_temp_info.order_type == "pickupShop") {
                    return "3";
                }
            },
            CheckOrderModeIsShopping() {
                if (this.info.order_temp_info.order_mode == 'shopping') {
                    return true;
                }
                else {
                    return false;
                }
            },
        },
        components: { Modal, Modal2, ModalTop, CartListItem },
        created() {
            var app = this;

            // prevent cannot scroll when loading the page
            this.$root.setBodyOverflow(false);
            this.info.itemMenuDetailsOpen = false;

            this.getCurrentPathName();
            this.windowResizeEventHandler(null);

            this.info.loading = false;

            //get core info json start
            $.get(
                "/files/brand.json",
                data => {
                    this.info.core_info = data.core;
                },
                "JSON"
            );
            this.getCountryCodeList();
            //get core info json end

            this.getAllShopList();
            this.getAllHolidayList();

            for (var k in allLabel)
                this.info.langcodes.push({ code: k, name: allLabel[k]["lang_name"] });
            this.setLanguage(
                this.getParameterByName("lang") ||
                window.localStorage.getItem("language") ||
                (navigator.language || navigator.browserLanguage).toLowerCase()
            );            

            this.exitAction =
                this.getParameterByName("exitAction") ||
                window.localStorage.getItem("exitAction");

            if (this.exitAction)
                window.localStorage.setItem("exitAction", this.exitAction);

            this.finishAction =
                this.getParameterByName("finishAction") ||
                window.localStorage.getItem("finishAction");

            if (this.finishAction)
                window.localStorage.setItem("finishAction", this.finishAction);

            this.GetConfingJson();

            //this.initSelectBrand();
            this.getOrderData();

            this.CreateGATag();
            //this.CreateGoogleLogin(); // will call on guestlogin page
            //this.CreateAppleLogin(); // will call on guestlogin page

            // load storage data
            this.getLLShopListStorage();
            this.getOrderTempInfoData();
            this.initOrderDateData();            
            this.getCurrentAddressListStorage();

            // for cart start
            if (this.info.enableCouponCode) {
                if (this.cart.couponCode) {
                    this.info.couponCode.open = false;
                    this.info.couponCode.value = this.cart.couponCode;
                } else {
                    this.info.couponCode.open = true;
                }
            }
            // for cart end

            // check default param
            this.CheckInitPageDefaultParam();

            // get current position
            //app.getStoreCurrentPositionLL(); // no need cache the position on 20260323
            if(app.info.currentPathName != "/confirmation" && app.info.currentPathName != "/order_confirmation")
                app.getCurrentPositionLL(null, true);

            $(Object.keys(allLabel[this.info.lang]))
                .filter((i, o) => o.indexOf("static_page_title_") == 0)
                .each((i, o) => {
                    //console.log(o);
                    var code = o.substr("static_page_title_".length);
                    this.info.staticPages.push({
                        label: o,
                        //url: "/page/s/" + code + app.GetDefaultShopCodeValue(),
                        url: "/page/s/" + code,
                    });
                });

            // check browser version and resolution
            this.CheckingBrowser();

            // run loadCart to check the session timeout
            this.cart.loadCart();
            if (this.cart.member == null) {
                this.ResetOrderTempInfoSearchType();
            }
            if (this.info.order_temp_info.temp_default_shop != "") {
                this.GetDefaultShopCodeObj();
                this.GetDefaultShopAreaDistrictToSelectOption();

                if (this.cart != null) {
                    this.cart.shopArea = "";
                    this.cart.shopDistrict = "";
                }
            }

            // check the current cart session when init the page
            //this.checkCartSession();
        },

        destroyed() {
        },
        mounted() {
            this.setShopCartListHeight("mounted");
        },
        watch: {
            '$route': function (to, from) {
                /*
                console.log("check to menu to", to);
                console.log("check to menu from", from);
                console.log('to.path.indexOf("/menu")', to.path.indexOf("/menu"));
                if (to.path.indexOf("/menu") >= 0) {
                    console.log("run clear coupon and discount");
                    //this.cart.coupons = [];
                    //this.cart.discounts = [];
                    //this.updateCart();
                }
                */
            }
        },
        beforeMount() {
            window.addEventListener("resize", this.windowResizeEventHandler);
            window.addEventListener("load", this.onCurrentSessionLoad);
            window.addEventListener("beforeunload", this.onCurrentSessionUnload);
            window.addEventListener('scroll', this.handleScrollEvent);
        },
        beforeDestroy() {
            //console.log("beforeDestroy");
            window.removeEventListener("resize", this.windowResizeEventHandler);
            window.removeEventListener("load", this.onCurrentSessionLoad);
            window.removeEventListener("beforeunload", this.onCurrentSessionUnload);
            window.removeEventListener('scroll', this.handleScrollEvent);

            // remove storage
            this.removeOrderTempInfoData();
            this.removeLLShopListStorage();
            this.removeCurrentAddressListStorage();
            this.UpdateCurrentAddressList();
            this.cart.resetSessionTimeout();
        },
        methods: {
            GetConfingJson() {
                $.ajax({
                    type: "GET",
                    async: false,
                    url: "/files/config.json",
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        $.extend(this.info, data.info);
                        this.disableItem = data.disableItem;
                        this.itemImagePath = data.itemImagePath;
                        this.defaultShop = data.defaultShop;
                        this.ga_id = data.ga_id;
                        this.facebook_pixel_id = data.facebook_pixel_id;
                        this.googleTagKey = data.googleTagKey;
                        this.isWhatsApp = data.isWhatsApp;
                        this.whatsappNo = data.whatsappNo;
                        this.whatsappLink = data.whatsappLink;
                        this.whatsappLinkWeb = data.whatsappLinkWeb;
                        this.NFExternalAppBrowser = data.NFExternalAppBrowser;
                        this.googleLoginID = data.googleLoginID;
                        this.appleLoginID = data.appleLoginID;
                        this.ios_payMethod_openURL = data.ios_payMethod_openURL;
                        this.android_payMethod_openURL = data.android_payMethod_openURL;
                    }
                }).catch(function () {
                });
            },
            ReplaceLineBreakHtml(str) {
                return CommonReplaceLineBreakHtml(str); 
            },
            CheckOrderOrderTypeIdx(order) {
                if (order.orderType == 1) {
                    return 1;
                }
                else if (order.orderType == 2) {
                    if (order.orderMode == "order") {
                        return 2;
                    } else {
                        if (order.pickupShopCode == null) {
                            return 2;
                        }
                        else if (order.pickupShopCode != null) {
                            return 3;
                        }
                    }
                }
            },
            GetOrderModePickupTypeLabel(pickupType, orderMode) {
                var l = "";
                var order_mode = this.info.order_temp_info.order_mode;
                if (orderMode != null) {
                    order_mode = orderMode;
                }
                //console.log('pickupType', pickupType);
                if (pickupType == 1) {
                    l = this.label["order_mode_pickup_type_delivery_text_" + order_mode];
                }
                else if (pickupType == 2) {
                    l = this.label["order_mode_pickup_type_pickup_text_" + order_mode];
                }
                else if (pickupType == 3) {
                    //l = this.label["order_mode_pickup_type_pickupShop_text_" + order_mode];
                    l = this.label["order_mode_pickup_type_pickupShop_text"];
                }
                else {
                    l = pickupType;
                }

                if (l == undefined || l == null) {
                    if (pickupType == 1) {
                        l = this.label["order_mode_pickup_type_delivery_text"];
                    }
                    else if (pickupType == 2) {
                        l = this.label["order_mode_pickup_type_pickup_text"];
                    }
                    else if (pickupType == 3) {
                        l = this.label["order_mode_pickup_type_pickupShop_text"];
                    }
                }
                //console.log('GetOrderModePickupTypeLabel', l);
                return l;
            },
            ModifyAddressLayerHeaderText(orderMode) {                
                var order_mode = this.info.order_temp_info.order_mode;
                if (orderMode != null) {
                    order_mode = orderMode;
                }
                var l = this.label["modify_address_layer_header_text_" + order_mode];

                if (l == undefined || l == null) {
                    l = this.label["modify_address_layer_header_text"];
                }
                
                return l;
            },
            GetHomeOrderModeOrderTypeRemarksLabel() {
                var l = "";
                var order_mode = this.info.order_temp_info.order_mode;
                var order_type = parseInt(this.getCurrentOrderTypeSubfix,10);

                if (order_type == 1) {
                    l = this.label["home_orderType_delivery_remark_text_" + order_mode];
                }
                else if (order_type == 2) {
                    l = this.label["home_orderType_pickup_remark_text_" + order_mode];
                }
                else if (order_type == 3) {
                    l = this.label["home_orderType_pickupShop_remark_text_" + order_mode];
                }

                if (l == undefined || l == null) {
                    if (order_type == 1) {
                        l = this.label["home_orderType_delivery_remark_text"];
                    }
                    else if (order_type == 2) {
                        l = this.label["home_orderType_pickup_remark_text"];
                    }
                    else if (order_type == 3) {
                        l = this.label["home_orderType_pickupShop_remark_text"];
                    }
                    else {
                        l = "";
                    }
                }

                return l;
            },
            ContentNewLineHtmlReplace(c) {
                return c.replace((new RegExp("\r\n", "g")), "<br/>");
            },

            getWindowHeight() {
                return Math.max(window.innerHeight, $(window).height());
            },

            handleScrollEvent() {
                this.SetObjectHeightEvent();
                this.SetPaneTopDataScroll();
                this.FlowArrowCheck();
            },
            windowResizeEventHandler(e) {
                this.CheckingBrowser();
                this.checkIsCartListDisplay();
                this.checkIsHeaderDisplay();
                this.SetObjectHeightEvent();
            },
            SetObjectHeightEvent() {
                //this.full_screen_height.height_fix = window.innerHeight + "px";
                this.full_screen_height.height_fix = this.getWindowHeight() + "px";
            },
            checkPaneTopBasketDisplay() {
                var re = false;
                var d = ["/menu"];
                $.each(d, (i, o) => {
                    if (this.info.currentPathName.indexOf(o) >= 0) {
                        re = true;
                        return;
                    }
                    else {
                        re = false;
                    }
                });
                
                return re;
            },
            SetPaneTopDataScroll() {
                if (this.$refs.header_div != undefined) {
                    var header_div = this.$refs.header_div;
                    if (window.scrollY >= 20) {
                        $(header_div).addClass("scroll");
                    }
                    else {
                        $(header_div).removeClass("scroll");
                    }
                }
            },
            setShopCartListHeight(from) {
                var app = this;
                if (from == "mounted" && !app.info.common_cart_list_init && this.checkBrowser.checking) {
                    const shop_list_height_resizeObserver = new ResizeObserver(function() {
                        app.setShopCartListHeightRun();
                    });
                    app.info.common_cart_list_init = true;
                    if (app.$refs.main_div != null)
                        shop_list_height_resizeObserver.observe(app.$refs.main_div);
                }
            },
            setShopCartListHeightRun() {
                var window_size = window.innerWidth;
                var header_div_clientHeight = this.$refs.header_div == undefined ? 0 : this.$refs.header_div.clientHeight;
                this.header_div_info.height = header_div_clientHeight;

                if (window_size > this.info.responsive_width) {
                    //var main_div_clientHeight = this.$refs.main_div.clientHeight;
                    //var window_height = window.innerHeight;
                    var window_height = this.getWindowHeight();

                    var refs_footer_div = $(this.$refs.footer_div);
                    var footer_div_top = -1;   
                    var footer_height = 0;
                    if (refs_footer_div.length > 0) {
                        //var footer_div_top = this.$refs.footer_div.getBoundingClientRect().top;
                        footer_div_top = refs_footer_div.offset().top;
                        if (footer_div_top <= 0) {
                            footer_div_top = window_height;
                        }
                        footer_height = $(refs_footer_div).height();
                    }
                    //var main_div_computedStyle = getComputedStyle(this.$refs.main_div);

                    //console.log("window_height", window_height);
                    //console.log("header_div_clientHeight", header_div_clientHeight);
                    //console.log("window_height - header_div_clientHeight",window_height - header_div_clientHeight);
                    //console.log("footer_div_top", footer_div_top);
                    //console.log("footer_height", footer_height);
                    //console.log("main_div_clientHeight",main_div_clientHeight);
                    //console.log("main_div_computedStyle.paddingTop",main_div_computedStyle.paddingTop);
                    //console.log("main_div_computedStyle.paddingBottom",main_div_computedStyle.paddingBottom);

                    //var main_div_height = main_div_clientHeight - parseInt(main_div_computedStyle.paddingTop.replace("px",""),10) - parseInt(main_div_computedStyle.paddingBottom.replace("px",""),10) -1;
                    var main_div_height = footer_div_top - header_div_clientHeight -1;
                    var main_div_display_height = window_height - header_div_clientHeight - 1;
                    if (refs_footer_div.length > 0) {
                        if (footer_div_top > window_height) {
                            this.common_cart_list_style_postion_fix = {
                                'height': (footer_div_top - 1) + "px",
                            };

                            this.common_cart_list_area_style = {
                                //"margin-top": ""+header_div_clientHeight+"px",
                                //"height": "calc("+main_div_clientHeight+"px - "+main_div_computedStyle.paddingTop+" - "+main_div_computedStyle.paddingBottom+" - 1px)"
                                "height": main_div_display_height + "px",
                                "position": "sticky",
                                "top": header_div_clientHeight + "px",
                            }
                        }
                        else {
                            this.common_cart_list_style_postion_fix = {
                                'height': (footer_div_top - 1) + "px",
                            };

                            this.common_cart_list_area_style = {
                                "height": main_div_height + "px",
                                "position": "sticky",
                                "top": header_div_clientHeight + "px",
                            }

                            this.bodyfit_style = {
                                "min-height": (window_height - header_div_clientHeight - footer_height - 1) + "px",
                                "display": "flex",
                                "flex-direction": "column",
                                "align-items": "center",
                                "justify-content": "center"
                            }
                            this.bodyfit_style_start = JSON.parse(JSON.stringify(this.bodyfit_style));
                            this.bodyfit_style_start["justify-content"] = "flex-start";
                        }
                    }

                    //console.log("this.common_cart_list_style_postion_fix",this.common_cart_list_style_postion_fix);
                    //console.log("this.common_cart_list_area_style",this.common_cart_list_area_style);
                    //console.log(this.bodyfit_body_style);
                }
                else {
                    this.common_cart_list_style_postion_fix = {
                        'height':this.full_screen_height.height_fix,
                    };

                    this.common_cart_list_area_style = {
                        "margin-top": "0",
                        "height": "100%"
                    }
                }
            },
            onCurrentSessionLoad(event) {
                window.localStorage.setItem("CurrentSessionActive", true);
            },
            onCurrentSessionUnload(event) {
                window.localStorage.setItem("CurrentSessionActive", false);
            },
            scrollToXY(pos, isComplete) {
                //window.scrollTo(pos.x, pos.y);
                $("html, body").animate({
                    scrollLeft: pos.x,
                    scrollTop: pos.y
                }, 0, function () { if (isComplete != null && isComplete != undefined) { isComplete(); } });
            },
            scrollToXYAnimate(pos, isComplete) {
                $("html, body").animate({
                    scrollTop: pos.y
                }, 200, function () { if (isComplete != null && isComplete != undefined) { isComplete(); } });
            },
            ObjectScrollToObject(scroll_obj, scroll_to_obj) {
                var scroll_to_obj_top = $(scroll_to_obj).offset().top - $(scroll_obj).offset().top;
                $(scroll_obj).animate({ scrollTop: (scroll_obj.scrollTop + scroll_to_obj_top) }, 200);
            },

            writeGoogleMapPath(long, lat) {
                return "https://maps.google.com/maps?ll=" + lat + "," + long + "&z=18&mapclient=embed&q=" + lat + "," + long + "@" + lat + "," + long + "";
            },

            writeDisplayDateFormat(date) {
                var showdate = moment(date);
                /*
                if (this.info.lang == "en") {
                    return showdate.format("DD MMM YYYY");
                }
                else if (this.info.lang == "tc" || this.info.lang == "sc") {
                    return showdate.format("YYYY年M月D日");
                }
                */
                return showdate.format("YYYY-MM-DD");
            },
            writeDisplayDatetimeFormat(date) { 
                return this.writeDisplayDateFormat(date) + " " + moment(date).format("HH:mm:ss");
            },
            writeDisplayDatetimeFormat2(date) {
                //return this.writeDisplayDateFormat(date) + " " + moment(date).format("HH:mm");
                return this.writeDisplayDateFormat(date) + " " + this.sessionTimeFormat(moment(date).format("HH:mm"));
            },

            getShopImage(shop) {
                return `/files/images/shop_image/${shop.shopCode}.png`;
            },
            getShopImageCheck(shop) {
                var img = `/files/images/shop_image/${shop.shopCode}.png`;
                var response = jQuery.ajax({
                    url: img,
                    type: 'HEAD',
                    async: false
                }).status;
                return (response != "200") ? "" : img;
            },
            getFoodImage(shop_code, food_id) {
                /*
                if (this.itemImagePath == "") {
                    return `/files/menu/images/${shop_code}/${food_id}.png`;
                } else {
                    var img = this.itemImagePath + `/${shop_code}-images/${food_id}.png`;
                    var response = jQuery.ajax({
                        url: img,
                        type: 'HEAD',
                        async: false
                    }).status;
                    return (response != "200") ? "" : img;
                }
                */
                var img = `/files/menu/images/${shop_code}/${food_id}.png`;
                var response = jQuery.ajax({
                    url: img,
                    type: 'HEAD',
                    async: false
                }).status;
                return (response != "200") ? "" : img;
            },
            getFoodImagePath(img) {
                // hide ajax checking on 20251118, change to lazy and onerror on img
                /*if (img != "") {
                    var response = jQuery.ajax({
                        url: img,
                        type: 'HEAD',
                        async: false
                    }).status;
                    return (response != "200") ? "" : img;
                }
                else {
                    return "";
                }*/
                return img
            },
            getFoodImageList(shop, food, isloop) {
                var re = [];
                var img = "";
                if (isloop) {
                    for (var i = 1; i <= 5; i++) {
                        //img = this.getFoodImage(shop.shopCode.substring(0, shop.shopCode.lastIndexOf('_')), food.id + "" + i);
                        //img = food.image;
                        img = this.getFoodImagePath(food.image);
                        if (img != "") {
                            re.push(img);
                        }
                        else {
                            break;
                        }
                    }
                }
                else {
                    //img = this.getFoodImage(shop.shopCode.substring(0, shop.shopCode.lastIndexOf('_')), food.id);
                    //img = food.image;
                    img = this.getFoodImagePath(food.image);
                    if (img != "") {
                        re.push(img);
                    }
                }
                return re;
            },

            getItemSubfix() {
                //return this.info.lang == "zh" ? "1" : "2";
                if (this.info.lang == "en") {
                    return "2";
                }
                else if (this.info.lang == "sc") {
                    return "3";
                }
                else {
                    return "1";
                }
            },
            displayOrderDeliveryMessage(order) {
                return (order != undefined && order.order.remarkDelivery != undefined && order.order.remarkDelivery != "") ? order.order.remarkDelivery.replace(/(?:\r\n|\r|\n)/g, '<br/>') : "";
            },
            displayOrderRemarksPreview(order) {
                var re = (order != undefined && order.order.remark != undefined && order.order.remark != "") ? order.order.remark.replace(/(?:\r\n|\r|\n)/g, '<br/>') : "";
                if (order.order.needCutlery) {
                    if (re == "") {
                        re = this.label['order_need_extra_items_remark_msg'];
                    }
                    else {
                        re = re + "<br/>" + this.label['order_need_extra_items_remark_msg'];
                    }
                }
                return re;
            },
            displayOrderRemarks(order) {
                var re = (order != undefined && order.order.remark != undefined && order.order.remark != "") ? order.order.remark.replace(/(?:\r\n|\r|\n)/g, '<br/>') : "";
                return re;
            },
            displayOrderDateTime(d, lingBreak, showTime) {
                if (showTime == null)
                    showTime = true;

                var today = moment();
                var da = moment(d);
                var isToday = false;
                var isTomorrow = false;
                if (da.format("YYYY-MM-DD") == today.format("YYYY-MM-DD")) {
                    isToday = true;
                }
                else if (da.format("YYYY-MM-DD") == today.add(1, 'days').format("YYYY-MM-DD")) {
                    isTomorrow = true;
                }

                return da.format("YYYY-MM-DD") + "(" + this.label['common.text.date.day.text.' + da.day()] + ")" + (isToday ? "(" + this.label['common.text.date.day.text.today'] + ")" : "") + (isTomorrow ? "(" + this.label['common.text.date.day.text.tomorrow'] + ")" : "") + (lingBreak ? "<br/>" : " ") + (showTime ? da.format("HH:mm") : "");
            },
            orderDateTimeDisplay(d) {
                return moment(d).format("YYYY-MM-DD HH:mm");
            },
            orderDateDisplay(d) {
                return moment(d).format("YYYY-MM-DD");
            },
            
            beforeRouteUpdate() {
                this.info.canGoBack = window.location.pathname != "/";
                this.info.openLangBox = false;
                window.scrollTo(0, 0);
            },
            setLanguageSelect(event) {
                this.setLanguage(event.target.value);
            },
            setLanguage(lang) {
                if (this.topShowMore) {
                    this.topShowMoreClose();
                }

                if (lang == "tc") {
                    lang = "zh";
                }

                if (!allLabel[lang])
                    if (lang.indexOf("-") > -1) lang = lang.substring(0, lang.indexOf("-"));
                if (!allLabel[lang])
                    for (var _lang in allLabel) {
                        lang = _lang;
                        break;
                    }
                this.info.lang = lang;

                if (this.info.lang == "zh") {
                    this.info.langws = "tc";
                }
                else if (this.info.lang == "tc") {
                    this.info.langws = "tc";
                    this.info.lang = "zh";
                }
                else {
                    this.info.langws = this.info.lang + "";
                }


                if (this.label["page_title"]) {
                    $("head>title").text(this.label["page_title"]);
                    this.UpdateDefaultShopCodeObjHeadTitle();
                }
                window.localStorage.setItem("language", this.info.lang);
            },
            getLabel() {
                return allLabel[this.info.lang];
            },
            switchLang() {
                var idx = this.info.langcodes.indexOf(this.info.lang) + 1;
                if (idx >= this.info.langcodes.length) idx = 0;
                this.setLanguage(this.info.langcodes[idx].code);
            },
            setGoBackAction(action) {
                this.goBackAction = action;
            },
            goBack() {
                if (window.location.pathname == "/cart") {
                    this.$router.push("/menu");
                    return;
                }
                if (this.goBackAction != undefined && this.goBackAction()) return;
                if (this.exitAction)
                    if (["/shop", "/error"].indexOf(window.location.pathname) >= 0) {
                        eval(this.exitAction);
                        return;
                    }
                this.$router.go(-1);
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return "";
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            alert(str) {
                if (str.includes("EXMessage: ") ||
                    str.includes("Object reference not set to an instance of an object.")
                ) {
                    const mess = str.replace("EXMessage: ", "");
                    if (this.label[mess] != undefined && this.label[mess] != null) {
                        this.checkAlertMessage(mess)
                    }
                    else {
                        var checkMess = "use.coupon.fail.validate"
                        if (mess.indexOf(checkMess + ".") >= 0) {
                            this.alertMsg(this.label[checkMess] + "(" + mess.replace(checkMess + ".", "") + ")");
                        }
                        else {
                            this.alertMsg(this.label["error_serverError"]);
                        }                           
                    }
                }
                else {
                    this.checkAlertMessage(str)
                }
            },
            checkAlertMessage(str) {
                // window.alert(this.label[str] || str);
                this.info.alertMsg = this.label[str] || str;
                switch (str) {
                    case "shop.offline":
                        //this.$router.replace("shop");
                        this.$router.replace("/");
                        break;
                    case "shop.not.found":
                        //this.$router.replace("shop");
                        this.$router.replace("/");
                        break;
                    case "item_count_reach_limit":
                        this.$root.alert(this.label["item_count_reach_limit"].replace(/#itemsLimit#/g, this.cart.itemsLimit));
                        break;
                    case "seesion.not.found":
                        this.cart.resetSessionTimeout();
                        this.address_list = [];
                        this.ResetOrderTempInfoSearchType();

                        if (this.$root.finishAction) {
                            eval(this.$root.finishAction);
                            return;
                        } else if (this.$root.exitAction) {
                            eval(this.$root.exitAction);
                            return;
                        }

                        // redirect to shop when seesion.not.found
                        //this.$router.push("/");
                        this.$router.replace("/");

                        break;

                    /*case "Object reference not set to an instance of an object.":
                        this.alertMsg(this.label["error_serverError"]);
                        break;*/

                    case "member.seesion.not.found":
                        this.memberSessionNotFound();
                        break;

                    default:
                        break;
                }
            },
            alertMsg(str) {
                this.info.alertMsg = str;
            },
            wsPost(url, lang, data, cb) {
                return $.ajax({
                    type: "POST",
                    headers: { lang: this.info.lang },
                    url: url,
                    contentType: "application/json",
                    data: data,
                    dataType: "json",
                    success: (data) => {
                        cb(data);
                    },
                });
            },
            wsPostAsync(url, lang, data, cb) {
                return $.ajax({
                    type: "POST",
                    headers: { lang: this.info.lang },
                    url: url,
                    async: false,
                    timeout: 50000,
                    contentType: "application/json",
                    data: data,
                    dataType: "json",
                    success: (data) => {
                        cb(data);
                    },
                });
            },
            wsGet(url, lang, cb) {
                return $.ajax({
                    type: "GET",
                    headers: { lang: this.info.lang },
                    url: url,
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        cb(data);
                    },
                });
            },
            wsGetAsync(url, lang, cb) {
                return $.ajax({
                    type: "GET",
                    headers: { lang: this.info.lang },
                    url: url,
                    async: false,
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        cb(data);
                    },
                });
            },
            
            clearAllStoreData() {
                this.cart.reset();
                this.removeOrderTempInfoData();
                this.removeLLShopListStorage();
                this.removeCurrentAddressListStorage();
                this.UpdateCurrentAddressList();

                // update latest LLShopList after clear storage
                this.updateCurrentLLShopList();
            },
            setBodyOverflow(ishidden) {
                if (ishidden) {
                    //$("html, body").css({ overflow: 'hidden' });
                    $("body").css({ overflow: 'hidden' });
                    //if (window.innerWidth <= this.info.responsive_width) {
                    //if (this.info.order_temp_info.order_device != "web") {
                        //$("html").css({ overflow: 'hidden' });
                    //}
                    //$($("body").find(".full_content")[0]).css({ overflow: 'hidden', 'max-height':'100vh' });
                    //$("html, body").css({ overflow: 'hidden', position: 'fixed' });
                } else {
                    //$("html, body").css({ overflow: 'initial' });
                    $("body").css({ overflow: 'initial' });
                    //if (window.innerWidth <= this.info.responsive_width) {
                    //if (this.info.order_temp_info.order_device != "web") {
                        //$("html").css({ overflow: 'initial' });
                    //}
                    //$($("body").find(".full_content")[0]).css({ overflow: 'initial', 'max-height':'100vh' });
                    //$("html, body").css({ overflow: 'initial', position: 'initial' });
                }
            },

            setSelectBrand(brand, routeTo) {
                var currentBrand = window.localStorage.getItem("selectBrand") || "";

                if (currentBrand != "") {
                    var currentBrand_obj = JSON.parse(currentBrand);

                    // clear cart?
                    //console.log("setSelectBrand", currentBrand_obj.brandCode +","+ brand.brandCode);
                    if (currentBrand_obj.brandCode != brand.brandCode) {
                        //console.log("different brand clear cart");
                        cart.clearCart();
                        window.localStorage.removeItem("selectShop");
                        window.localStorage.removeItem("lastShopCode");
                    }
                }

                this.info.selectBrand = brand;
                window.localStorage.setItem("selectBrand", JSON.stringify(brand));

                this.unloadBrandBanner();

                if (this.defaultShop != "") {
                    $.each(this.AllShopList, (i, o) => {
                        if (o.shopCode == this.defaultShop) {

                            // get new token before select shop
                            this.createGuestLogin("GUEST", "99999999");

                            o.isOnline = true;
                            o.isOpen = true;

                            this.cart.shop = o;
                            this.cart.saveCart();
                            this.setSelectShop(o);

                            this.$router.push("menu");
                            routeTo = null;

                            return;
                        } // check default shop end
                    });
                } // check defaultShop end

                if (routeTo != null) {
                    this.$router.push(routeTo);
                }
            },
            setSelectShop(shop) {
                var currentShop = window.localStorage.getItem("selectShop") || "";

                if (currentShop != "") {
                    var currentShop_obj = JSON.parse(currentShop);

                    // clear cart?
                    //console.log("setSelectShop", currentShop_obj.shopCode +","+ shop.shopCode);
                    if (currentShop_obj.shopCode != shop.shopCode) {
                        //console.log("different shop clear cart");
                        cart.clearCart();
                    }
                }

                this.info.selectShop = shop;
                window.localStorage.setItem("selectShop", JSON.stringify(shop));
            },
            setSelectShopCheckReOrder(shop, cb) {
                var app = this;
                if (this.reorder_temp_data.shop != null) {

                    if (shop.shopCode.replace("_1", "").replace("_2", "").replace("_3", "") != this.reorder_temp_data.shop.shopCode.replace("_1", "").replace("_2", "").replace("_3", "")) {
                        this.setConfirmMsg(this.label['reorder.text.different.shop.alert'], function() { app.setSelectShop(shop); if(cb) cb(); }, undefined);
                    }
                    else {
                        this.setSelectShopCheckReOrderConfirm(shop, cb);
                    }

                } else {
                    this.setSelectShop(shop);
                    if(cb) cb();
                }
            },
            setSelectShopCheckReOrderConfirm(shop, cb) {
                this.setSelectShop(shop);
                if(cb) cb();

                this.cart.readyTime = this.OrderDateSelect.format("YYYY-MM-DD HH:mm") + ":00";
                this.cart.items = JSON.parse(JSON.stringify(this.reorder_temp_data.items));
                this.reorder_temp_data.shop = null;
                this.reorder_temp_data.items = [];
                this.updateCart(null, false);
            },

            initSelectBrand() {
                if (window.location.pathname == "/") {
                    //this.info.showBrand = false;
                    //this.info.showShop = false;
                }
                else {
                    //this.info.showBrand = true;
                    //this.info.showShop = true;
                }

                var currentBrand = window.localStorage.getItem("selectBrand") || "";
                if (currentBrand != "") {
                    this.info.selectBrand = JSON.parse(currentBrand);
                    this.loadBrandBanner();

                    var currentShop = window.localStorage.getItem("selectShop") || "";
                    if (currentShop != "") {
                        this.info.selectShop = JSON.parse(currentShop);
                        this.loadShopCategoryStatisPage();
                    }
                    else {
                        this.unloadShopCategoryStatisPage();
                        if (this.info.currentPathName != "/" && this.info.currentPathName != "/shop") {
                            this.$router.replace("/shop");
                        }
                    }
                }
                else {
                    if (this.info.currentPathName != "/" && !this.info.currentPathName.startsWith("/page")) {
                        this.$router.replace("/")
                    }
                }
            },

            loadBrandBanner() {
                if (this.info.currentPathName != '/' && this.info.currentPathName != '/shop') {
                    if (this.info.BrandBanners.length <= 0) {
                        if (typeof BrandBanner != 'undefined' && BrandBanner[this.info.selectBrand.brandCode]) this.info.BrandBanners = BrandBanner[this.info.selectBrand.brandCode];
                        this.$nextTick(function () {
                            if (this.$refs.brand_slide) {
                                $(this.$refs.brand_slide).slick({
                                    adaptiveHeight: true,
                                    autoplay: true,
                                    arrows: false
                                });
                            }
                        });
                        this.$nextTick(function () {
                            if (this.$refs.brand_slide_resp) {
                                $(this.$refs.brand_slide_resp).slick({
                                    adaptiveHeight: true,
                                    autoplay: true,
                                    arrows: false
                                });
                            }
                        });
                    }
                }
                else {
                    this.unloadBrandBanner();
                }
            },
            unloadBrandBanner() {
                // remove slick start
                this.info.BrandBanners = [];
                if (this.$refs.brand_slide) {
                    $(this.$refs.brand_slide).slick('unslick');
                }
                if (this.$refs.brand_slide_resp) {
                    $(this.$refs.brand_slide_resp).slick('unslick');
                }
                // remove slick end
            },

            loadShopCategoryStatisPage() {
                if (this.info.ShopCategoryStatisPage.length <= 0 && (this.info.selectShop != undefined && this.info.selectShop != null)) {
                    $.ajax({
                        type: "GET",
                        async: false,
                        url: "/files/shop_category_static_page.json",
                        contentType: "application/json",
                        dataType: "json",
                        success: (data) => {
                            if (data[this.info.selectShop.shopCode]) {
                                this.info.ShopCategoryStatisPage = data[this.info.selectShop.shopCode];
                                $(this.info.ShopCategoryStatisPage).each((i, o) => {
                                    this.info.ShopCategoryStatisPage[i].page_url = "/menu/0/sc/" + o.page_code;
                                });
                            }
                        }
                    }).catch(function () {
                    });
                }
            },
            unloadShopCategoryStatisPage() {
                this.info.ShopCategoryStatisPage = [];
            },
            selectShopCategoryStatisPage(page) {
                this.$router.push(page.page_url);
            },

            createGuestLogin(name, phone) {
                var app = this;
                app.info.loading = true;
                app.wsPostAsync(
                    app.info.wsUrl + "/order/guestlogin",
                    app.lang,
                    JSON.stringify({ data: { name: name, phone: phone } }),
                    (data) => {
                        app.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                        //console.log("serverTimeDiff", app.$root.serverTimeDiff);
                        //console.log(data);
                        if (data.status == 0) {
                            app.cart.token = data.token;
                            $.extend(cart, data.cart);
                            app.cart.saveCart();

                            // update order contact info
                            if (this.info.order_temp_info.order_address_type == "search" && this.cart.member != null) {
                                this.FillMemberInfoToOrderContactInfo();
                            }

                        } else {
                            app.$root.alert(data.message);
                        }
                    }
                )
                    .always(() => {
                        app.info.loading = false;
                    })
                    .fail(() => {
                        //app.$root.alert("Fail!");
                        app.$root.alert("common_fail_message");
                    });
            },

            setOrderData(order_data, isReceiveNews) {
                this.info.order = order_data;
                this.info.order.receiveNews = isReceiveNews;
                window.localStorage.setItem("currentOrder", JSON.stringify(this.info.order));
            },
            getOrderData() {
                var currentOrder = window.localStorage.getItem("currentOrder") || "";
                if (currentOrder != "") {
                    this.info.order = JSON.parse(currentOrder);
                }

                //console.log("this.info.order", this.info.order);
            },
            removeOrderData() {
                this.info.order = undefined;
                window.localStorage.removeItem("currentOrder");
            },

            topShowMoreOpen() {
                this.topShowMore = true;
                this.SetObjectHeightEvent();
                this.setBodyOverflow(true);
            },
            topShowMoreClose() {
                this.topShowMore = false;
                this.setBodyOverflow(false);
            },

            getCurrentPathName() {
                this.info.currentPathName = window.location.pathname;
                this.checkIsCartListDisplay();
                this.checkIsHeaderDisplay();
            },

            CheckInitPageDefaultParam() {
                var app = this;
                
                // check member token 
                var atoken = this.getParameterByName("atoken");
                var rtoken = this.getParameterByName("rtoken");
                if ((atoken != null && atoken != "") && (rtoken != null && rtoken != "")) {
                    this.sendMemberIDTokenLogin(atoken, rtoken);
                }

                if (atoken == "login_fail") {
                    this.modalTopMessage = this.label['common_text_login_fail'];
                } else if (atoken == "logout") {
                    this.LogoutBtnClick();
                }
                else {
                    atoken = "";
                    rtoken = "";
                }
                
                var default_device = this.getParameterByName("device");
                var default_order_mode = this.getParameterByName("order_mode");
                var default_order_type = this.getParameterByName("order_type");
                var default_shopcode = this.getParameterByName("default_shopcode");
                var default_item = this.getParameterByName("default_item");
                var fixHomeOption = this.getParameterByName("fixHomeOption");

                if (default_device != null && default_device != "") {
                    switch(default_device.toLowerCase()) {
                        case "ios":
                            this.info.order_temp_info.order_device = "ios";
                            break;

                        case "aos":
                        case "android":
                            this.info.order_temp_info.order_device = "android";
                            break;

                        default:
                            this.info.order_temp_info.order_device = "web";
                            break;
                    }
                }

                if (default_order_mode != null && default_order_mode != "") {
                    switch (default_order_mode.toLowerCase()) {
                        case "foodordering":
                            this.info.order_temp_info.order_mode = "order";
                            break;

                        case "shopping":
                            this.info.order_temp_info.order_mode = "shopping";
                            break;
                        /*
                        case "smallPoonChoi":
                            this.info.order_temp_info.order_mode = "smallPoonChoi";
                            break;

                        case "largePoonChoi":
                            this.info.order_temp_info.order_mode = "largePoonChoi";
                            break;

                        case "party":
                            this.info.order_temp_info.order_mode = "party";
                            break;
                        */
                        default:
                            this.info.order_temp_info.order_mode = "order";
                            break;
                    }

                    app.fixHomeOptionObj.orderMode = app.info.order_temp_info.order_mode;
                }
                else {
                    //this.info.order_temp_info.order_mode = "order";
                }

                if (default_order_type != null && default_order_type != "") {
                    switch (default_order_type.toLowerCase()) {
                        case "delivery":
                            this.info.order_temp_info.order_type = "delivery";
                            break;

                        case "pickup":
                            this.info.order_temp_info.order_type = "pickup";
                            break;

                        case "pickupShop":
                            this.info.order_temp_info.order_type = "pickupShop";
                            break;

                        default:
                            //this.info.order_temp_info.order_type = "delivery";
                            this.info.order_temp_info.order_type = "pickup"; // set default as pickup for nanfung
                            if (this.info.order_temp_info.order_mode == "shopping")
                                this.info.order_temp_info.order_type = "pickupShop"; // set default as pickupShop for tenren
                            break;
                    }
                    //app.fixHomeOptionObj.orderType = app.info.order_temp_info.order_mode;
                }
                else {
                    this.info.order_temp_info.order_type = "pickup"; // set default as pickup for nanfung
                    if (this.info.order_temp_info.order_mode == "shopping") 
                        this.info.order_temp_info.order_type = "pickupShop"; // set default as pickupShop for tenren
                }

                if (default_shopcode != null && default_shopcode != "") {
                    if (default_shopcode != "clear") {
                        app.info.order_temp_info.temp_default_shop = default_shopcode + "";
                        app.info.order_temp_info.temp_default_shop_isInit = true;
                        app.GetDefaultShopCodeObj();
                        app.GetDefaultShopAreaDistrictToSelectOption();
                    }
                    else {
                        this.info.order_temp_info.temp_default_shop = "";
                    }
                }
                else {
                    if (this.info.order_temp_info.order_mode == "shopping") {
                        this.info.order_temp_info.temp_default_shop = "";
                    }
                }
                this.info.order_temp_info.home_select_shop = "";

                if (default_item != null && default_item != "") {
                    this.info.order_temp_info.temp_default_item = default_item + "";
                }
                else {
                    this.info.order_temp_info.temp_default_item = "";
                }

                if (fixHomeOption != null && fixHomeOption == "true") {
                    app.fixHomeOptionObj.isFix = true;
                }

                // get page mode for testing
                this.info.pageMode = this.getParameterByName("mode");

                // set order setting
                this.UpdateInfoOrderSettingByMode();

                // check member session and set address list
                if (atoken == "" && rtoken == "") {                    
                    if (this.cart.member != null) {
                        this.GetMemberAddressList();
                        this.GetMemberPreferShopList();
                    }
                }

                // update order info storage
                this.setOrderTempInfoData();
                this.initOrderDateData();                

                // check pageType
                var pageType = this.getParameterByName("pageType");
                if (pageType != null && pageType != "") {
                    if (app.cart.member != null) {
                        switch (pageType) {
                            case "orderDetails":
                                app.$router.replace("/member/orderhistory");
                                break;

                            default:
                        }
                    }
                }
                else {
                    // replace url text
                    if (this.info.currentPathName == "/" || this.info.currentPathName == "/guestlogin" || this.info.currentPathName == "/checkout") {
                        window.history.replaceState(null, null, this.info.currentPathName);
                    }                    
                }
            },
            GetDefaultShopCodeValue() {
                if (this.info.order_temp_info.temp_default_shop == null || this.info.order_temp_info.temp_default_shop == "") {
                    return "";
                }
                else {
                    return this.info.order_temp_info.temp_default_shop;
                }
            },
            GetDefaultShopCodeObj() {
                var app = this;
                if (app.GetDefaultShopCodeValue() != "") {
                    var temp_shop = app.AllShopList.filter(s => (s.shopCode == app.info.order_temp_info.temp_default_shop + "_" + app.getCurrentOrderTypeShopDetailsSubfix));
                    /*if (app.getCurrentOrderTypeShopDetailsSubfix == "3") {
                        temp_shop = app.AllShopList.filter(s => (s.shopCode_global == app.info.order_temp_info.temp_default_shop));
                    }*/
                    // no default shop for shopping
                    if (app.CheckOrderModeIsShopping) {
                        temp_shop = []; 
                    }
                    if (temp_shop.length > 0) {
                        app.info.order_temp_info.temp_default_shop_obj = JSON.parse(JSON.stringify(temp_shop[0]));
                        app.UpdateDefaultShopCodeObjHeadTitle();
                    }
                    else {
                        app.info.order_temp_info.temp_default_shop = "";
                        app.info.order_temp_info.temp_default_shop_obj = null;
                        app.info.order_temp_info.temp_default_shop_isInit = false;
                    }
                }
                else {
                    app.info.order_temp_info.temp_default_shop = "";
                    app.info.order_temp_info.temp_default_shop_obj = null;
                    app.info.order_temp_info.temp_default_shop_isInit = false;
                }
                app.setOrderTempInfoData();
            },
            UpdateDefaultShopCodeObjHeadTitle() {
                /*
                if (this.info.order_temp_info.temp_default_shop_obj != null) {
                    var shopCode_global = this.info.order_temp_info.temp_default_shop_obj["shopCode_global"];

                    // update head title
                    $("head>title").text(this.info.order_temp_info.temp_default_shop_obj["name" + this.getItemSubfix()]);                    

                    // add css
                    var css_id = 'stylesheet_custom_' + shopCode_global;
                    var css_obj = $("#" + css_id);
                    if (css_obj.length > 0) {
                        css_obj.remove();
                    }
                    var head = document.getElementsByTagName('head')[0];
                    var script = document.createElement('link');
                    script.id = css_id;
                    script.rel = 'stylesheet';
                    script.type = 'text/css';
                    script.href = "/files/css/custom_" + shopCode_global + ".css";
                    head.appendChild(script);
                }
                */
            },
            GetDefaultShopCodeObjStartEndTime() {
                var app = this;
                var defaultStartEndTime = [["00:00", "23:59"]];
                var StartEndTime = [];
                if (app.info.order_temp_info.temp_default_shop_obj != null) {
                    var shop = app.info.order_temp_info.temp_default_shop_obj;
                    if (!shop.businessHours) return defaultStartEndTime;
                    var businessHour = [];
                    var date = app.OrderDateSelectMenuTime;
                    var isHoliday = app.$root.OrderDateSelectIsHoliday;
                    if (isHoliday) businessHour = shop.businessHours.filter(x => x.date == '' + 7);
                    if (businessHour.length == 0) businessHour = shop.businessHours.filter(x => x.date == '' + moment(date).day());
                    if (businessHour.length == 0) return defaultStartEndTime;
                    $.each(businessHour[0].time, (i, t) => {
                        var a = t.split("-");
                        /*
                        if (i == 0) {
                            StartEndTime[0] = a[0].substring(0, 2) + ":" + a[0].substring(2, 4);
                        }
                        if (i == businessHour[0].time.length - 1) {
                            StartEndTime[1] = a[1].substring(0, 2) + ":" + a[1].substring(2, 4);
                        }
                        */
                        StartEndTime.push([a[0].substring(0, 2) + ":" + a[0].substring(2, 4), a[1].substring(0, 2) + ":" + a[1].substring(2, 4)]);
                    });

                    //console.log("StartEndTime", StartEndTime);
                    return StartEndTime;
                }
                else {
                    return defaultStartEndTime;
                }                
            },
            GetDefaultShopAreaDistrictToSelectOption() {
                var app = this;

                // get shop shop area district
                var temp_shop = app.AllShopList.filter(s => (s.shopCode_global == app.GetDefaultShopCodeValue()));
                //console.log("temp_shop", temp_shop);
                if (temp_shop.length > 0) {
                    app.$root.homeSelectShop.homeSelectShopArea = temp_shop[0].areaCode + "";
                    app.$root.homeSelectShop.homeSelectShopDistrict = temp_shop[0].districtCode + "";

                    if (temp_shop[0].districtCode == "") {
                        app.$root.homeSelectShop.homeSelectShopArea = "";
                        app.$root.homeSelectShop.homeSelectShopDistrict = "";
                        app.fixHomeOptionObj.selectAreaDistrict = false;
                    }
                    else {
                        app.fixHomeOptionObj.selectAreaDistrict = true;
                    }
                }
            },
            UpdateInfoOrderSettingByMode() {
                $.extend(this.info.order_setting, this.info.order_mode_setting[this.info.order_temp_info.order_mode]);
                if (this.$root.info.order_setting.orderType.indexOf(this.info.order_temp_info.order_type) < 0) { 
                    this.info.order_temp_info.order_type = this.$root.info.order_setting.orderType[0];
                    this.info.order_temp_info.order_type_temp = this.$root.info.order_setting.orderType[0];
                }                
            },
            CheckingBrowser() {
                var bv = GetBrowserVersion();
                //console.log("CheckingBrowser", bv);

                this.checkBrowser.checking = true;
                this.checkBrowser.version = true;
                this.checkBrowser.resolution = true;

                if (bv.browserName == "Safari" && bv.browserMajorVersion < 13) {
                    this.checkBrowser.checking = false;
                    this.checkBrowser.version = false;
                }
                else if (bv.browserName == "") {
                    this.checkBrowser.checking = false;
                    this.checkBrowser.version = false;
                }
                /*
                if (this.checkBrowser.checking && this.info.browserResolutionSmallChecking) {
                    var window_size = window.innerWidth;
                    if ((this.info.order_temp_info.order_device == "web") && (window_size <= this.info.responsive_width)) {
                        this.checkBrowser.checking = false;
                        this.checkBrowser.resolution = false;
                    }
                }

                if (this.checkBrowser.checking && this.info.browserResolutionLargeChecking) {
                    var window_size = window.innerWidth;
                    if ((this.info.order_temp_info.order_device == "web") && (window_size > this.info.responsive_width)) {
                        this.checkBrowser.checking = false;
                        this.checkBrowser.resolution = false;
                        if (this.info.browserResolutionLargeReDirect != "") {
                            window.location.href = this.info.browserResolutionLargeReDirect;
                        }
                    }
                }
                */
                // redirect to other page when not from app
                if (this.info.currentPathName.indexOf("/page") == 0 || this.info.currentPathName.indexOf("/confirmation") == 0) { }
                else {
                    if (this.getParameterByName("mode") == "admin" || this.info.pageMode == "admin") { }
                    else {
                        if (this.info.order_temp_info.order_device == "web" && this.info.browserResolutionLargeReDirect != "") {
                            //window.location.href = this.info.browserResolutionLargeReDirect;
                            window.location.replace(this.info.browserResolutionLargeReDirect);
                        }
                    }
                }
            },

            CreateGATag() {
                if (this.ga_id != "" && typeof WebOnGAObj != 'undefined') {
                    CreateWebOnGA(this.ga_id);
                }
                if (this.facebook_pixel_id != "") {
                    initFacebookPixel(this.facebook_pixel_id);
                }

                if (this.googleTagKey != "") {
                    initGoogleTag(this.googleTagKey);
                }
            },
            CreateGoogleLogin() {
                if (this.googleLoginID != "" && typeof agLoginObj != 'undefined') {
                    CreateGoogleLogin(this.googleLoginID);
                }
            },
            CreateAppleLogin() {
                if (this.appleLoginID != "" && typeof agLoginObj != 'undefined') {
                    CreateAppleLogin(this.appleLoginID);
                }
            },

            checkIsCartListDisplay() {
                var window_size = window.innerWidth;
                if (window_size > this.info.responsive_width) {
                    this.setBodyOverflow(false);
                    if (this.info.currentPathName.startsWith("/menu")) {
                        this.info.showShopCartList = true;
                    }
                    else {
                        this.info.showShopCartList = false;
                    }
                }
                else {

                    if (this.info.currentPathName.startsWith("/menu") || this.info.currentPathName == "/shop") {
                        //this.info.showShopCartList = false;
                        if (this.info.showShopCartList) {
                            this.openCart();
                        } else {
                            this.closeCart();
                        }
                    }
                    else {
                        this.closeCart();
                    }
                }
            },
            checkIsHeaderDisplay() {
                var window_size = window.innerWidth;
                if (window_size > this.info.responsive_width) {
                    this.info.display_header = true;
                } else {
                    /*
                    if (this.info.currentPathName == "/" ||
                            this.info.currentPathName == "/shop"
                        ) {
                        this.info.display_header = true;
                    } else {
                        this.info.display_header = false;
                    }
                    */
                    this.info.display_header = false;
                }
            },
            checkIsFooderHeaderDisplay() {
                var window_size = window.innerWidth;
                if (window_size > this.info.responsive_width) {
                    return true;
                } else {
                    if (this.info.order_temp_info.order_device == 'web') {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },

            // for cart start
            cartCurrentECashChecking(cb) {
                var ecash = 0;
                var real_amount = this.cart.amount + this.cart.usedECash;
                if (real_amount > 0) {
                    if (this.cart.usedECash > Math.floor(real_amount)) {
                        ecash = Math.floor(real_amount)
                    }
                    else {
                        ecash = this.cart.usedECash;
                    }
                }
                else {
                    ecash = 0;
                }

                this.cartUpdateECashAPI(ecash, cb);
            },
            cartUpdateECashAPI(ecash, cb) {
                var self = this;
                if (ecash != self.cart.usedECash) {
                    self.cart.usedECash = ecash;

                    self.info.loading = true;
                    self.$root
                        .wsPost(
                            self.info.wsUrl + "/order/updatecart",
                            self.info.lang,
                            JSON.stringify({ data: { token: self.cart.token, cart: self.cart } }),
                            (data) => {
                                self.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                                //console.log("serverTimeDiff", self.$root.serverTimeDiff);
                                console.log("cartUpdateECashAPI", data);
                                $.extend(self.cart, data.cart);
                                self.cart.saveCart();

                                if (data.status == 0) {
                                    if (cb) cb();
                                } else {
                                    self.$root.alert(data.message);
                                }
                            }
                        )
                        .always(() => {
                            self.info.loading = false;
                        })
                }
                else {
                    if (cb) cb();
                }
            },
            checkCartSession() {                
                var self = this;
                self.info.loading = true;
                self.$root
                    .wsPost(
                        self.info.wsUrl + "/order/updatecart",
                        self.info.lang,
                        JSON.stringify({ data: { token: self.cart.token, cart: self.cart } }),
                        (data) => {                            
                            self.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                            //console.log("serverTimeDiff", self.$root.serverTimeDiff);
                            console.log("updateCart", data);
                            $.extend(self.cart, data.cart);
                            self.cart.saveCart();
                        }
                    )
                    .always(() => {
                    })
                    .fail(() => {
                    });
            },
            updateCart(cb, guest_login, runAlert, reRun) {
                if (guest_login == undefined || guest_login == null) {
                    guest_login = true;
                }
                if (runAlert == undefined || runAlert == null) {
                    runAlert = true;
                }
                if (reRun == undefined || reRun == null) {
                    reRun = true;
                }

                this.cart.readyTime = this.OrderDateSelect.format("YYYY-MM-DD HH:mm") + ":00";
                this.cart.orderMode = this.info.order_temp_info.order_mode;
                if (this.info.order_temp_info.order_time == "asap") {
                    this.cart.asapOrder = true;
                }
                else {
                    this.cart.asapOrder = false;
                }
                var self = this;
                self.cart.device = self.info.order_temp_info.order_device;
                self.$root.UpdateCartShopInfo(self.cart.shop);
                
                console.log("updateCart post cart", self.cart);
                self.info.loading = true;
                self.$root
                    .wsPost(
                        self.info.wsUrl + "/order/updatecart",
                        self.info.lang,
                        JSON.stringify({ data: { token: self.cart.token, cart: self.cart } }),
                        (data) => {
                            self.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                            //console.log("serverTimeDiff", self.$root.serverTimeDiff);
                            console.log("updateCart", data);
                            const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";
                            
                            //if (data.status != 0 && (data_msg == "use.coupon.fail.validate" || data_msg == "couponCode.not.valid")) {
                            if (data.status != 0 && (data_msg.indexOf("use.coupon.fail.validate") >= 0 || data_msg == "couponCode.not.valid")) {
                                self.cart.couponCode = "";
                                self.cart.couponPromoteCode = "";
                                self.cart.coupons = [];
                                self.updateCart(cb, guest_login, runAlert, reRun);

                            }  // end not pass checking coupon error message
                            else {

                                $.extend(self.cart, data.cart);
                                self.cart.saveCart();

                                if (data.status == 0) {
                                    self.info.loading = false;
                                    if (cb) cb(data);
                                    //self.cartCurrentECashChecking(cb);
                                } else {

                                    if (guest_login) {

                                        if (data.status == 99 && data_msg == "seesion.not.found") {
                                            /*
                                            // get new token before select shop
                                            this.cart.member = null;
                                            this.cart.memberAddress = [];
                                            this.createGuestLogin("GUEST", "99999999");
                                            this.updateCart(cb);
                                            */
                                            self.$root.alert(data.message);
                                            self.info.loading = false;
                                        }
                                        else if (data.status == 99 && data_msg == "item.updated") {
                                            if (runAlert) {
                                                self.$root.alert(data.message);

                                                // redirect to menu page and open cart list
                                                if (this.info.currentPathName.startsWith("/checkout")) {
                                                    this.updateCurrentLLShopList();
                                                    this.$router.replace("/menu");
                                                    this.openCart();
                                                }
                                                else if (this.info.currentPathName.startsWith("/menu")) {
                                                    this.updateCurrentLLShopList();
                                                    this.menuIsUpdate++;
                                                }

                                                self.info.loading = false;
                                            }
                                        } else {
                                            //self.cart.removeInvalidItem();
                                            //self.cart.saveCart();
                                            self.$root.alert(data.message);
                                            self.info.loading = false;
                                        }

                                    } else {

                                        if (data.status == 99 && data_msg == "item.updated") {
                                            if (runAlert) {
                                                self.$root.alert(data.message);

                                                // redirect to menu page and open cart list
                                                if (this.info.currentPathName.startsWith("/checkout")) {
                                                    this.updateCurrentLLShopList();
                                                    this.$router.replace("/menu");
                                                    this.openCart();
                                                }
                                                else if (this.info.currentPathName.startsWith("/menu")) {
                                                    this.updateCurrentLLShopList();
                                                    this.menuIsUpdate++;
                                                }

                                                self.info.loading = false;
                                            }
                                        } else {
                                            //self.cart.removeInvalidItem();
                                            //self.cart.saveCart();
                                            self.$root.alert(data.message);
                                            self.info.loading = false;
                                        }

                                    }
                                }

                            } // end pass checking coupon error message
                        }
                    )
                    .always(() => {
                        //self.info.loading = false;
                    })
                    .fail((e) => {
                        //self.$root.alert("Fail!");
                        //self.$root.alert("common_fail_message");

                        var isReRun = false;
                        if (!reRun) {
                            //this.$root.setConfirmMsg("updateCart: " + JSON.stringify(e), undefined, undefined);
                            console.log(e);
                            this.$root.alert("common_fail_message");
                        }
                        try {
                            if (!(e.status == 0 && e.readyState == 0)) {
                                //this.$root.alert(e);
                                console.log(e);
                                this.$root.alert("common_fail_message");
                            }
                            else {
                                // try run the function once
                                if (reRun) {
                                    this.updateCart(cb, guest_login, runAlert, false);
                                    isReRun = true;
                                }
                            }
                        }
                        catch {
                            //this.$root.alert(e);
                            console.log(e);
                            this.$root.alert("common_fail_message");
                        }
 
                        // clear cart and redirect to select brand when fail
                        if (!isReRun) {
                            self.cart.clearCart();
                            self.$router.push("/");
                        }
                    });
            },
            CartCheckOrderMenuTimeExpiry(timeout_redirect) {
                var re = false;

                // update LL shop info if asap (hide it because need to update LLShop list for itemsControl before submit)
                /*if (this.info.order_temp_info.order_time == "asap") {
                    this.updateCurrentLLShopList();
                }*/

                var return_time_range = { value:moment() };
                var check_datetime = true;
                if (this.info.order_temp_info.order_time == "asap") {
                    check_datetime = false;
                } else {
                    check_datetime = this.checkSelectedDateTimeData(this.OrderDateSelect, this.info.order_temp_info.order_type, return_time_range);
                }

                //console.log("this.OrderDateSelect",this.OrderDateSelect);
                //console.log("return_time_range",return_time_range);
                //console.log("check_datetime",check_datetime);

                if (!check_datetime) {
                    /*
                    var target_shop_menu_time = moment();
                    if (this.info.order_temp_info.order_time == "asap") {
                        target_shop_menu_time = this.getShopMenuTime(this.info.order_temp_info.order_type, this.OrderDateSelect.format("HH:mm") + "-" + this.OrderDateSelect.format("HH:mm"));
                    }
                    else {
                        target_shop_menu_time = this.getShopMenuTime(this.info.order_temp_info.order_type, return_time_range.value.format("HH:mm") + "-" + return_time_range.value.format("HH:mm"));
                    }

                    console.log("target_shop_menu_time",target_shop_menu_time);
                    console.log("this.info.order_temp_info.order_shop_menu_time",this.info.order_temp_info.order_shop_menu_time);

                    if (target_shop_menu_time != this.info.order_temp_info.order_shop_menu_time) {
                        // update the order time and clear cart if different shop menu time
                        this.info.order_temp_info.order_time_list = this.initOrderTimeList(this.info.order_temp_info.order_date, this.info.order_temp_info.order_type);
                        this.info.order_temp_info.order_time = this.info.order_temp_info.order_time_list[0];

                        if (!this.info.order_setting.order_time_select) {
                            this.info.order_temp_info.order_time = "00:00";
                        }

                        this.SetOrderShopMenuTime();
                        this.setOrderTempInfoData();

                        // update order menu time if asap
                        if (this.info.order_temp_info.order_time == "asap") {
                            this.SetOrderShopMenuTime();
                        }

                        this.$root.alert("order_menu_timeout_alert_text");
                        this.cart.clearCart();
                        if (this.info.order_temp_info.order_time_list[0] == "---") {
                            this.$router.replace("/");
                        } else {
                            if (timeout_redirect) {
                                //this.$router.replace("/menu");
                                if (this.info.currentPathName.startsWith("/menu")) {
                                    this.$router.replace("/menu");
                                    //this.$router.go(this.$router.currentRoute);
                                    this.menuIsUpdate++;
                                }
                                else {
                                    this.$router.replace("/menu");
                                }
                            }
                        }
                        re = false;
                    }
                    else {
                        // update the order time only if same shop menu time
                        this.info.order_temp_info.order_time_list = this.initOrderTimeList(this.info.order_temp_info.order_date, this.info.order_temp_info.order_type);
                        this.info.order_temp_info.order_time = this.info.order_temp_info.order_time_list[0];

                        if (!this.info.order_setting.order_time_select) {
                            this.info.order_temp_info.order_time = "00:00";
                        }

                        this.setOrderTempInfoData();

                        re = true;
                    }
                    */

                    // change to not using menu time on 20230602
                    this.info.order_temp_info.order_time_list = this.initOrderTimeList(this.info.order_temp_info.order_date, this.info.order_temp_info.order_type);
                    this.info.order_temp_info.order_time = this.info.order_temp_info.order_time_list[0];
                    if (!this.info.order_setting.order_time_select) {
                        this.info.order_temp_info.order_time = "00:00";
                    }
                    this.setOrderTempInfoData();
                    re = true;
                }
                else {
                    re = true;
                }

                return re;
            },
            checkout() {
                var self = this;
                if (self.cartItemCount > 0) {
                    self.info.loading = true;

                    // prevent cannot scroll when loading the page
                    self.$root.setBodyOverflow(false);
                    self.info.itemMenuDetailsOpen = false;

                    // check shop and update LLShop List if shop is offline
                    self.checkShopCodeIsActive(self.cart.shop.shopCode.substring(0, self.cart.shop.shopCode.length - 2), self.checkoutCB)
                    /*
                    if (!self.checkShopCodeIsActiveAsync(self.cart.shop.shopCode.substring(0, self.cart.shop.shopCode.length - 2))) {
                        self.updateCurrentLLShopList();
                        self.$root.alert("shop.offline");
                        this.$router.replace("/shop");
                        self.info.loading = false;
                        return;
                    }
                    */
                }
            },
            checkoutCB(checkShop) {
                var self = this;

                if (!checkShop) {
                    self.updateCurrentLLShopList(function () {
                        self.$root.alert("shop.offline");
                        //self.$router.replace("/shop");
                        self.$router.replace("/");
                        self.info.loading = false;
                    });                    
                }
                else {
                    var check_data = true;

                    // check menu time (after check shop)
                    if (check_data) {
                        if (!self.CartCheckOrderMenuTimeExpiry(false)) {
                            self.info.loading = false;
                            check_data = false;

                            //self.$router.replace("/menu");
                            if (self.info.currentPathName.startsWith("/menu")) {
                                self.$router.replace("/menu");
                                //self.$router.go(self.$router.currentRoute);
                                self.menuIsUpdate++;
                            }
                            else {
                                self.$router.replace("/menu");
                            }                            
                        }
                    }

                    if (check_data) {
                        if (self.cart.itemCount() > self.cart.itemsLimit) {
                            self.info.loading = false;
                            check_data = false;
                            self.$root.alert("item_count_reach_limit");
                        }
                    }

                    if (check_data) {

                        this.cart.readyTime = this.OrderDateSelect.format("YYYY-MM-DD HH:mm") + ":00";
                        this.cart.orderMode = this.info.order_temp_info.order_mode;
                        if (this.info.order_temp_info.order_time == "asap") {
                            this.cart.asapOrder = true;
                        }
                        else {
                            this.cart.asapOrder = false;
                        }

                        self.$root
                            .wsPost(
                                self.info.wsUrl + "/order/updatecart",
                                self.info.lang,
                                JSON.stringify({ data: { token: this.cart.token, cart: this.cart } }),
                                (data) => {
                                    //self.info.itemMenuDetailsOpen = false; // for closeCart function

                                    self.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                                    //console.log("serverTimeDiff", self.$root.serverTimeDiff);
                                    console.log("checkout", data);
                                    const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";
                                    $.extend(self.cart, data.cart);
                                    self.cart.saveCart();                                    

                                    if (data.status == 0) {

                                        if (self.cart.member != null) {
                                            self.cartCheckout();
                                        }
                                        else {
                                            self.page_after_login = "/checkout";
                                            self.$router.push("/guestlogin");
                                        }

                                        //self.cartCheckout();
                                    } else {

                                        if (data.status == 99 && data_msg == "item.updated") {
                                            self.$root.alert(data.message);

                                            if (self.info.currentPathName.startsWith("/menu")) {
                                                //self.updateCurrentLLShopList(); // update shop itemControl list
                                                //self.checkShopCodeIsActiveAsync(self.cart.shop.shopCode.substring(0, self.cart.shop.shopCode.length - 2));
                                                self.menuIsUpdate++;
                                            }
                                        }
                                        else {
                                            //self.cart.removeInvalidItem();
                                            //self.cart.saveCart();
                                            self.$root.alert(data.message);
                                        }
                                    }
                                }
                            )
                            .always(() => {
                                self.info.loading = false;
                            })
                            .fail((e) => {
                                //alert("Fail!");
                                //self.$root.alert("common_fail_message");
                                try {
                                    if (!(e.status == 0 && e.readyState == 0)) {
                                        //self.$root.alert(e);
                                        console.log(e);
                                        self.$root.alert("common_fail_message");
                                    }
                                }
                                catch {
                                    //self.$root.alert(e);
                                    console.log(e);
                                    self.$root.alert("common_fail_message");
                                }
                            });
                    }
                }
            },
            cartCheckout() {
                this.$router.push("/checkout");
            },

            deleteItemClick(item) {
                this.info.deleteItem = item;
                this.info.deleteItemMessage = this.label["cartList_Confirm_Remove_Item_Alert"].replace("#item_name#", item["name" + this.getItemSubfix()]);
            },
            confirmDelete() {
                this.info.deleteItem.qty = 0;
                this.cart.updateCart();
                this.updateCart();
                this.info.updateCartList++;

                this.info.deleteItem = null;
                this.info.deleteItemMessage = "";
            },
            confirmDeleteCancel() {
                this.info.deleteItem = null;
                this.info.updateCartList++;
            },
            setCartItemQty(item, newQty) {
                if (newQty > 0 && !item.invalid) {
                    item.qty = newQty;
                    //this.cart.updateCart();
                    this.updateCart();
                }
            },
            setCartItemSelectQty(item, event) {
                var newQty = parseInt(event.target.value,10);
                if (!item.invalid) {
                    var oldQty = item.qty;

                    if (newQty <= 0) {
                        this.deleteItemClick(item);
                    } else {
                        if (newQty > 0) {
                            item.qty = newQty;

                            // check itemsLimit
                            if (this.cart.itemCount() > this.cart.itemsLimit) {
                                this.$root.alert("item_count_reach_limit");
                                item.qty = oldQty;
                                return;
                            }

                            //this.cart.updateCart();
                            this.updateCart();
                        }
                    }
                }
                else {
                    if (newQty <= 0) {
                        this.deleteItemClick(item);
                    } else {
                        event.target.value = item.qty;
                    }
                }
            },
            submitCouponCode() {
                var app = this;
                if (app.info.couponCode.value != "") {
                    app.$root
                        .wsGet(
                            app.info.wsUrl +
                            "/order/checkcouponcode?code=" +
                            app.info.couponCode.value,
                            app.info.lang,
                            (data) => {
                                //console.log(data);
                                if (data.status == 0) {
                                    app.cart.couponCode = app.info.couponCode.value;
                                    app.updateCart();
                                    app.info.couponCode.open = app.info.couponCode.error = false;
                                } else {
                                    app.info.couponCode.open = app.info.couponCode.error = true;
                                }
                                //app.info.couponCode.value = "";

                                if (this.CheckCartUseCouponCodeOpen()) {
                                    setTimeout(this.commonCartTopAreaScrollToBottom,100);
                                }
                            }
                        )
                        .always(() => {
                            app.info.loading = false;
                        })
                        .fail(() => {
                            //app.$root.alert("Fail!");
                            app.$root.alert("common_fail_message");
                        });
                }
            },
            removeCouponCode() {
                var app = this;
                //app.info.couponCode.value = "";
                app.cart.couponCode = "";
                app.updateCart();
                app.info.couponCode.open = true;
            },
            CheckCartUseCouponCodeOpen() {
                // keep open if contains coupon
                if (!this.info.couponCode.open && this.cart.couponCode) {
                    return true;
                }
                else {
                    if (this.info.couponCode_area_isOpen) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },
            CartUseCouponCodeOpen() {
                if (this.info.couponCode_area_isOpen) {
                        this.info.couponCode_area_isOpen = false;
                }
                else {
                    this.info.couponCode_area_isOpen = true;
                }
                if (this.CheckCartUseCouponCodeOpen()) {
                    //this.commonCartTopAreaScrollToBottom();
                    setTimeout(this.commonCartTopAreaScrollToBottom,100);
                }
            },
            commonCartTopAreaScrollToBottom() {
                var container = this.$el.querySelector("#cart_top_area");
                //container.scrollTop = container.scrollHeight;
                $(container).prop({ scrollTop: $(container).prop("scrollHeight") });
            },
            openCart() {
                var window_size = window.innerWidth;
                if (window_size <= this.info.responsive_width) {
                    this.info.showShopCartList = true;
                    this.setBodyOverflow(true);
                    this.setShopCartListHeightRun();
                }
            },
            closeCart() {
                var window_size = window.innerWidth;
                if (window_size <= this.info.responsive_width) {
                    this.info.showShopCartList = false;
                    if (!this.info.itemMenuDetailsOpen) {
                        this.setBodyOverflow(false);
                    }
                }
            },
            saveOrderCb(cb) {
                var app = this;
                this.info.loading = true;
                this.$root
                    .wsPost(
                        this.info.wsUrl + "/order/saveorder",
                        this.lang,
                        JSON.stringify({
                            data: { token: this.cart.token, cart: this.cart },
                        }),
                        (data) => {
                            // console.log("saveOrderCb", data);
                            const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";

                            if ((data.aToken != undefined && data.aToken != null && data.aToken != '') && (data.rToken != undefined && data.rToken != null && data.rToken != ''))
                                UpdateARToken(app.info.order_temp_info.order_device, data.aToken, data.rToken);

                            if (data.status == 0) {
                                //data.cart.remarkForm = this.remarkForm;
                                //this.$root.setOrderData(data.cart, this.isReceiveNews);
                                this.$root.setOrderData(data.cart, "n");
                                //this.$router.push("checkout");

                                if (cb) cb(data);
                            } else {
                                $.extend(this.cart, data.cart);
                                this.cart.saveCart();
                                this.$root.alert(data.message);

                                if (data.status == 99 && data_msg == "item.updated") {
                                    // redirect to menu page and open cart list
                                    if (this.info.currentPathName.startsWith("/checkout")) {
                                        this.$router.replace("/menu");
                                        this.openCart();
                                    }
                                }

                                this.info.loading = false;
                            }
                        }
                    )
                    .always(() => {
                        //this.info.loading = false;
                    })
                    .fail(() => {
                        //alert("Fail!");
                        this.$root.alert("common_fail_message");
                        this.info.loading = false;
                    });
            },
            sumItemListPrice(item_list) {
                var p = 0;
                $.each(item_list, (i, o) => {
                    p += (o.price * o.qty);
                });
                return p;
            },
            CartNeedCutleryClick() {
                if (this.cart.needCutlery) {
                    this.cart.needCutlery = false;
                } else {
                    this.cart.needCutlery = true;
                }
            },

            UpdateTempPayMethod(cb) {                
                var self = this;

                console.log("UpdateTempPayMethod post cart", self.cart);
                self.info.loading = true;
                self.$root
                    .wsPost(
                        self.info.wsUrl + "/order/UpdateTempPayMethod?token=" + encodeURIComponent(self.cart.token) + "&tempPayMethod=" + (self.tempPaymentMethod == undefined || self.tempPaymentMethod == null ? "" : encodeURIComponent(self.tempPaymentMethod.code)),
                        self.info.lang,
                        JSON.stringify({}),
                        (data) => {
                            self.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                            //console.log("serverTimeDiff", self.$root.serverTimeDiff);
                            console.log("UpdateTempPayMethod", data);
                            $.extend(self.cart, data.cart);
                            self.cart.saveCart();

                            if (data.status == 0) {
                                self.info.loading = false;
                                if (cb) cb(data);
                            } else {
                                self.info.loading = false;
                                self.$root.alert(data.message);
                            }
                        }
                    )
                    .always(() => {
                        //self.info.loading = false;
                    })
                    .fail(() => {
                        //self.$root.alert("Fail!");
                        self.$root.alert("common_fail_message");

                        // clear cart and redirect to select brand when fail
                        self.cart.clearCart();
                        self.$router.push("/");
                    });
            },
            // for cart end

            // for shop start
            getAllShopList() {
                //get shop Area District json
                $.ajax({
                    async: false,
                    type: "GET",
                    url: "/files/shopDistrict.json",
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        this.AllShopDistrictList = data.list;
                    }
                }).catch(function () {
                    this.AllShopDistrictList = [];
                })

                //get shopping District json
                $.ajax({
                    async: false,
                    type: "GET",
                    url: "/files/shoppingDistrict.json",
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        this.shoppingDistrictList = data.list;
                    }
                }).catch(function () {
                    this.shoppingDistrictList = [];
                })

                //get shop list json
                $.ajax({
                    async: false,
                    type: "GET",
                    url: "/files/shop.json",
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        this.AllShopList = data.list;
                        console.log('this.AllShopList', this.AllShopList);
                    }
                }).catch(function () {
                    this.AllShopList = [];
                })
            },
            getShopAreaObj(shopArea) {
                if (this.CheckOrderModeIsShopping) {
                    var temp_shop = this.shoppingDistrictList.filter(s => s.areaCode == shopArea);
                    return temp_shop.length > 0 ? temp_shop[0] : null;
                }
                else {
                    var temp_shop = this.AllShopDistrictList.filter(s => s.areaCode == shopArea);
                    return temp_shop.length > 0 ? temp_shop[0] : null;
                }
            },
            getShopDistrictObj(shopArea, shopDistrict) {
                if (this.CheckOrderModeIsShopping) {
                    var temp_shop = this.getShopAreaObj(shopArea);
                    if (temp_shop != null) {
                        var temp_district = temp_shop.district.filter(s => s.districtCode == shopDistrict);
                        return temp_district.length > 0 ? temp_district[0] : null;
                    }
                    else {
                        return null;
                    }
                }
                else {
                    var temp_shop = this.getShopAreaObj(shopArea);
                    if (temp_shop != null) {
                        var temp_district = temp_shop.district.filter(s => s.districtCode == shopDistrict);
                        return temp_district.length > 0 ? temp_district[0] : null;
                    }
                    else {
                        return null;
                    }
                }
            },

            getShopInfo(shop_code, isglobal) {
                var selectShop = [];
                if (isglobal)
                    selectShop = this.AllShopList.filter(s => s.shopCode_global == shop_code);
                else 
                    selectShop = this.AllShopList.filter(s => s.shopCode == shop_code);

                if (selectShop.length > 0) {
                    return selectShop[0];
                } else {
                    return null;
                }
            },
            getLLShopInfo(shop_code) {
                var selectShop = this.LLShopList.filter(s => s.shopCode == shop_code.substring(0, shop_code.length-2));
                if (selectShop.length > 0) {
                    return selectShop[0];
                } else {
                    return null;
                }
            },
            getLLShopInfoByListByShopCodeGlobal(shopList, shop_code) {
                var selectShop = shopList.filter(s => s.shopCode == shop_code);
                if (selectShop.length > 0) {
                    return selectShop[0];
                } else {
                    return null;
                }
            },
            getAllHolidayList() {
                this.wsGetAsync(
                    "/files/holiday.json",
                    this.lang,
                    data => {
                        this.AllHolidayList = data.list;
                    }
                );
            },
            CheckIsHoliday(check_date) {
                if (this.AllHolidayList.filter(d => d == moment(check_date).format("YYYY-MM-DD")).length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            getCurrentPositionLL(cb, renew, retry) {
                if (renew == null || renew == undefined)
                    renew = false;
                if (retry == null || retry == undefined)
                    retry = 10; // no retry
                
                var app = this;
                if (app.CheckOrderModeIsShopping) // no need the GPS position for shopping
                    app.info.googleMapLocation = false;

                if (app.info.googleMapLocation && (!app.currentPositionLL || renew)) {

                    // clear location when get the position
                    window.localStorage.removeItem("CurrentPositionLL"); // clear storage
                    app.currentPositionLL = null;

                    if (
                        navigator.geolocation == undefined
                        //  || !/^https/.test(location.protocol.toLowerCase())
                    ) {
                        //app.$root.alert("01 - " + app.label["shop_device_location_error"]);
                        if (app.info.currentPathName == "/" || app.info.currentPathName == "/shop") {
                            app.$root.alert(app.label["shop_device_location_error"]);
                        }
                        return;
                    }
                    navigator.geolocation.getCurrentPosition(                        
                        function (position) {
                            //app.$root.alert(JSON.stringify(position));
                            app.currentPositionLL = {
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude
                            };

                            window.localStorage.setItem("CurrentPositionLL", JSON.stringify(app.currentPositionLL));
                            if (cb) cb();
                        },
                        function (err) {
                            //app.$root.alert("err: " + err);
                            window.localStorage.removeItem("CurrentPositionLL"); // clear storage
                            app.currentPositionLL = null;

                            if (retry <= 0) {
                                retry++;
                                window.setTimeout(function () { app.getCurrentPositionLL(cb, renew, retry); }, 1000);
                            } else {
                                //app.$root.alert("02 - " + app.label["shop_device_location_error"]);
                                //app.$root.alert("02 - " + err.code + " - " + err.message);
                                if (app.info.currentPathName == "/" || app.info.currentPathName == "/shop") {
                                    if (err.code + "" == "1") {
                                        app.$root.alert(app.label["shop_device_location_error"]);
                                    }
                                    else {
                                        app.$root.alert(app.label["shop_device_location_error_23"]);
                                    }
                                }
                            }
                        },
                        { enableHighAccuracy: true, timeout: 5000 }  // 5sec timeout with no retry
                    );
                }
                else {
                    if (cb) cb();
                }                
            },
            getStoreCurrentPositionLL() {
                var p = window.localStorage.getItem("CurrentPositionLL") || "";
                if (p != "") {
                    this.currentPositionLL = JSON.parse(p);
                }
            },
            getShopList(cb) {
                var app = this;
                app.wsGet(
                    app.info.wsUrl + "/Order/GetShopList",
                    app.lang,
                    data => {
                        app.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                        var temp_shop = [];
                        $.each(data.shops, (i, s1) => {
                            //temp_shop = app.$root.AllShopList.filter(s2 => (s1.shopCode == s2.shopCode_global));
                            temp_shop = app.$root.AllShopList.filter(s2 => ((s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopDetailsSubfix) == s2.shopCode));
                            if (temp_shop.length > 0) {
                                s1.businessHours = temp_shop[0].businessHours;
                                s1.visible = temp_shop[0].visible;
                                //if (s1.visible != "y") s1.isOnline = false; // not checking visible on tenren
                                if (app.cart.shop != null) {
                                    app.cart.shop.shopBufferTime = s1.shopBufferTime;
                                    app.cart.shop.shopBufferTimeMin = s1.shopBufferTimeMin;
                                    app.cart.shop.itemPackingTime = s1.itemPackingTime;
                                }
                                return false;
                            }
                        });
                        if (cb) cb(data);
                    }
                );
            },
            getShopListByShopCode(shopCode, cb) {
                var app = this;
                app.wsGet(
                    app.info.wsUrl + "/Order/GetShopListByShopCode?shopCode=" + encodeURIComponent(shopCode),
                    app.lang,
                    data => {
                        app.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                        var temp_shop = [];
                        $.each(data.shops, (i, s1) => {
                            //temp_shop = app.$root.AllShopList.filter(s2 => (s1.shopCode == s2.shopCode_global));
                            temp_shop = app.$root.AllShopList.filter(s2 => ((s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopDetailsSubfix) == s2.shopCode));
                            if (temp_shop.length > 0) {
                                s1.businessHours = temp_shop[0].businessHours;
                                s1.visible = temp_shop[0].visible;
                                //if (s1.visible != "y") s1.isOnline = false; // not checking visible on tenren
                                if (app.cart.shop != null) {
                                    app.cart.shop.shopBufferTime = s1.shopBufferTime;
                                    app.cart.shop.shopBufferTimeMin = s1.shopBufferTimeMin;
                                    app.cart.shop.itemPackingTime = s1.itemPackingTime;
                                }
                                return false;
                            }
                        });
                        if (cb) cb(data);
                    }
                );
            },
            getShopListByShopCodeAsync(shopCode, cb) {
                var app = this;
                app.wsGetAsync(
                    app.info.wsUrl + "/Order/GetShopListByShopCode?shopCode=" + encodeURIComponent(shopCode),
                    app.lang,
                    data => {
                        app.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                        var temp_shop = [];
                        $.each(data.shops, (i, s1) => {
                            //temp_shop = app.$root.AllShopList.filter(s2 => (s1.shopCode == s2.shopCode_global));
                            temp_shop = app.$root.AllShopList.filter(s2 => ((s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopDetailsSubfix) == s2.shopCode));
                            if (temp_shop.length > 0) {
                                s1.businessHours = temp_shop[0].businessHours;
                                s1.visible = temp_shop[0].visible;
                                //if (s1.visible != "y") s1.isOnline = false; // not checking visible on tenren
                                if (app.cart.shop != null) {
                                    app.cart.shop.shopBufferTime = s1.shopBufferTime;
                                    app.cart.shop.shopBufferTimeMin = s1.shopBufferTimeMin;
                                    app.cart.shop.itemPackingTime = s1.itemPackingTime;
                                }
                                return false;
                            }
                        });
                        if (cb) cb(data);
                    }
                );
            },
            getShopListAsync(cb) {
                var app = this;
                app.wsGetAsync(
                    app.info.wsUrl + "/Order/GetShopList",
                    app.lang,
                    data => {
                        app.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                        var temp_shop = [];
                        $.each(data.shops, (i, s1) => {
                            //temp_shop = app.$root.AllShopList.filter(s2 => (s1.shopCode == s2.shopCode_global));
                            temp_shop = app.$root.AllShopList.filter(s2 => ((s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopDetailsSubfix) == s2.shopCode));
                            if (temp_shop.length > 0) {
                                s1.businessHours = temp_shop[0].businessHours;
                                s1.visible = temp_shop[0].visible;
                                //if (s1.visible != "y") s1.isOnline = false; // not checking visible on tenren
                                if (app.cart.shop != null) {
                                    app.cart.shop.shopBufferTime = s1.shopBufferTime;
                                    app.cart.shop.shopBufferTimeMin = s1.shopBufferTimeMin;
                                    app.cart.shop.itemPackingTime = s1.itemPackingTime;
                                }
                                return false;
                            }
                        });
                        if (cb) cb(data);
                    }
                );
            },
            getShopListByLL(latitude,longitude,cb) {
                var app = this;
                var OrderTypeSubfix = app.$root.getCurrentOrderTypeShopDetailsSubfix + "";
                app.wsGet(
                    app.info.wsUrl + "/order/getshoplistbylocation?location="+latitude+","+longitude+"&deliveryType="+OrderTypeSubfix,
                    app.lang,
                    data => {
                        app.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                        var temp_shop = [];
                        
                        $.each(data.shops, (i, s1) => {
                            //temp_shop = app.$root.AllShopList.filter(s2 => (s1.shopCode == s2.shopCode_global));
                            temp_shop = app.$root.AllShopList.filter(s2 => ((s1.shopCode + "_" + OrderTypeSubfix) == s2.shopCode));
                            if (temp_shop.length > 0) {
                                s1.businessHours = temp_shop[0].businessHours;
                                s1.visible = temp_shop[0].visible;
                                //if (s1.visible != "y") s1.isOnline = false; // not checking visible on tenren
                                if (app.cart.shop != null) {
                                    app.cart.shop.shopBufferTime = s1.shopBufferTime;
                                    app.cart.shop.shopBufferTimeMin = s1.shopBufferTimeMin;
                                    app.cart.shop.itemPackingTime = s1.itemPackingTime;
                                }
                                return false;
                            }
                        });
                        if (cb) cb(data);
                    }
                );
            },
            getShopListByLLAsync(latitude,longitude,cb) {
                var app = this;
                var OrderTypeSubfix = app.$root.getCurrentOrderTypeShopDetailsSubfix + "";
                app.wsGetAsync(
                    app.info.wsUrl + "/order/getshoplistbylocation?location="+latitude+","+longitude+"&deliveryType="+OrderTypeSubfix,
                    app.lang,
                    data => {
                        app.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                        var temp_shop = [];
                        $.each(data.shops, (i, s1) => {
                            //temp_shop = app.$root.AllShopList.filter(s2 => (s1.shopCode == s2.shopCode_global));
                            temp_shop = app.$root.AllShopList.filter(s2 => ((s1.shopCode + "_" + OrderTypeSubfix) == s2.shopCode));
                            if (temp_shop.length > 0) {
                                s1.businessHours = temp_shop[0].businessHours;
                                s1.visible = temp_shop[0].visible;
                                //if (s1.visible != "y") s1.isOnline = false; // not checking visible on tenren
                                if (app.cart.shop != null) {
                                    app.cart.shop.shopBufferTime = s1.shopBufferTime;
                                    app.cart.shop.shopBufferTimeMin = s1.shopBufferTimeMin;
                                    app.cart.shop.itemPackingTime = s1.itemPackingTime;
                                }
                                return false;
                            }
                        });
                        if (cb) cb(data);
                    }
                );
            },
            getShopListByLLShopCode(latitude, longitude, ShopCode, cb) {
                var app = this;
                var OrderTypeSubfix = app.$root.getCurrentOrderTypeShopDetailsSubfix + "";
                app.wsGet(
                    app.info.wsUrl + "/order/getshoplistbylocation?location=" + latitude + "," + longitude + "&deliveryType=" + OrderTypeSubfix + "&shopCode=" + ShopCode,
                    app.lang,
                    data => {
                        app.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                        var temp_shop = [];
                        $.each(data.shops, (i, s1) => {
                            //temp_shop = app.$root.AllShopList.filter(s2 => (s1.shopCode == s2.shopCode_global));
                            temp_shop = app.$root.AllShopList.filter(s2 => ((s1.shopCode + "_" + OrderTypeSubfix) == s2.shopCode));
                            if (temp_shop.length > 0) {
                                s1.businessHours = temp_shop[0].businessHours;
                                s1.visible = temp_shop[0].visible;
                                //if (s1.visible != "y") s1.isOnline = false; // not checking visible on tenren
                                if (app.cart.shop != null) {
                                    app.cart.shop.shopBufferTime = s1.shopBufferTime;
                                    app.cart.shop.shopBufferTimeMin = s1.shopBufferTimeMin;
                                    app.cart.shop.itemPackingTime = s1.itemPackingTime;
                                }
                                return false;
                            }
                        });
                        if (cb) cb(data);
                    }
                );
            },
            getShopListByLLShopCodeAsync(latitude, longitude, ShopCode, cb) {
                var app = this;
                var OrderTypeSubfix = app.$root.getCurrentOrderTypeShopDetailsSubfix + "";
                app.wsGetAsync(
                    app.info.wsUrl + "/order/getshoplistbylocation?location=" + latitude + "," + longitude + "&deliveryType=" + OrderTypeSubfix + "&shopCode=" + ShopCode,
                    app.lang,
                    data => {
                        app.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                        var temp_shop = [];
                        $.each(data.shops, (i, s1) => {
                            //temp_shop = app.$root.AllShopList.filter(s2 => (s1.shopCode == s2.shopCode_global));
                            temp_shop = app.$root.AllShopList.filter(s2 => ((s1.shopCode + "_" + OrderTypeSubfix) == s2.shopCode));
                            if (temp_shop.length > 0) {
                                s1.businessHours = temp_shop[0].businessHours;
                                s1.visible = temp_shop[0].visible;
                                //if (s1.visible != "y") s1.isOnline = false; // not checking visible on tenren
                                if (app.cart.shop != null) {
                                    app.cart.shop.shopBufferTime = s1.shopBufferTime;
                                    app.cart.shop.shopBufferTimeMin = s1.shopBufferTimeMin;
                                    app.cart.shop.itemPackingTime = s1.itemPackingTime;
                                }
                                return false;
                            }
                        });
                        if (cb) cb(data);
                    }
                );
            },
            updateCurrentLLShopList(cb) {
                var app = this;

                if (this.$root.info.order_setting.skipZeekShopList || (this.$root.info.order_temp_info.order_type == 'pickup' || this.$root.info.order_temp_info.order_type == 'pickupShop')) {
                    this.getShopList(
                        function (data) {
                            app.LLShopList = data.shops;
                            app.setLLShopListStorage();

                            if (cb) cb();
                        }
                    );
                }
                else {
                    var temp_location = (this.info.order_temp_info.order_address.location + "").split(',');
                    this.getShopListByLL(temp_location[0], temp_location[1],
                        function (data) {
                            app.LLShopList = data.shops;
                            app.setLLShopListStorage();

                            if (cb) cb();
                        }
                    );
                }
            },
            updateCurrentLLShopListAsync(cb) {
                var app = this;

                if (this.$root.info.order_setting.skipZeekShopList || (this.$root.info.order_temp_info.order_type == 'pickup' || this.$root.info.order_temp_info.order_type == 'pickupShop')) {
                    this.getShopListAsync(
                        function (data) {
                            app.LLShopList = data.shops;
                            app.setLLShopListStorage();

                            if (cb) cb();
                        }
                    );
                }
                else {
                    var temp_location = (this.info.order_temp_info.order_address.location + "").split(',');
                    this.getShopListByLLAsync(temp_location[0], temp_location[1],
                        function (data) {
                            app.LLShopList = data.shops;
                            app.setLLShopListStorage();

                            if (cb) cb();
                        }
                    );
                }
            },
            checkShopCodeIsActive(shopCode, cb) {
                var app = this;
                
                if (this.$root.info.order_setting.skipZeekShopList || (this.$root.info.order_temp_info.order_type == 'pickup' || this.$root.info.order_temp_info.order_type == 'pickupShop')) {
                    this.getShopListByShopCode(shopCode, 
                        function (data) {
                            var temp_LLShopList = data.shops;

                            var LLshopInfo = app.getLLShopInfoByListByShopCodeGlobal(temp_LLShopList, shopCode);
                            if (LLshopInfo != null) {
                                app.updateGlobalLLShopListByLLshopInfo(shopCode, LLshopInfo);

                                if (LLshopInfo.isOnline) {
                                    var check_date = app.$root.OrderDateSelect;
                                    var check_time = check_date.hour() * 100 + check_date.minute();
                                    var isOpen = app.cart.getShopOpen(LLshopInfo, app.$root.OrderDateSelectIsHoliday, check_date, check_time);
                                    if (isOpen) {
                                        if (cb) cb(true);
                                    }
                                    else {
                                        if (cb) cb(false);
                                    }
                                }
                                else {
                                    if (cb) cb(false);
                                }
                            }
                            else {
                                if (cb) cb(false);
                            }
                        }
                    );
                }
                else {
                    var temp_location = (this.info.order_temp_info.order_address.location + "").split(',');
                    this.getShopListByLLShopCode(temp_location[0], temp_location[1], shopCode, 
                        function (data) {
                            var temp_LLShopList = data.shops;

                            var LLshopInfo = app.getLLShopInfoByListByShopCodeGlobal(temp_LLShopList, shopCode);
                            if (LLshopInfo != null) {
                                app.updateGlobalLLShopListByLLshopInfo(shopCode, LLshopInfo);

                                if (LLshopInfo.isOnline) {
                                    var check_date = app.$root.OrderDateSelect;
                                    var check_time = check_date.hour() * 100 + check_date.minute();
                                    var isOpen = app.cart.getShopOpen(LLshopInfo, app.$root.OrderDateSelectIsHoliday, check_date, check_time);
                                    if (isOpen) {
                                        if (cb) cb(true);
                                    }
                                    else {
                                        if (cb) cb(false);
                                    }
                                }
                                else {
                                    if (cb) cb(false);
                                }
                            }
                            else {
                                if (cb) cb(false);
                            }
                        }
                    );
                }
            },
            checkShopCodeIsActiveAsync(shopCode) {
                var app = this;
                var re = false;
                
                if (this.$root.info.order_setting.skipZeekShopList || (this.$root.info.order_temp_info.order_type == 'pickup' || this.$root.info.order_temp_info.order_type == 'pickupShop')) {
                    this.getShopListByShopCodeAsync(shopCode, 
                        function (data) {
                            var temp_LLShopList = data.shops;
                            var LLshopInfo = app.getLLShopInfoByListByShopCodeGlobal(temp_LLShopList, shopCode);
                            if (LLshopInfo != null) {
                                app.updateGlobalLLShopListByLLshopInfo(shopCode, LLshopInfo);

                                if (LLshopInfo.isOnline) {
                                    var check_date = app.$root.OrderDateSelect;
                                    var check_time = check_date.hour() * 100 + check_date.minute();
                                    var isOpen = app.cart.getShopOpen(LLshopInfo, app.$root.OrderDateSelectIsHoliday, check_date, check_time);
                                    if (isOpen) {
                                        re = true;
                                    }
                                    else {
                                        re = false;
                                    }
                                }
                                else {
                                    re = false;
                                }
                            }
                            else {
                                re = false;
                            }
                        }
                    );
                }
                else {
                    var temp_location = (this.info.order_temp_info.order_address.location + "").split(',');
                    this.getShopListByLLShopCodeAsync(temp_location[0], temp_location[1], shopCode,
                        function (data) {                            
                            var temp_LLShopList = data.shops;
                            var LLshopInfo = app.getLLShopInfoByListByShopCodeGlobal(temp_LLShopList, shopCode);
                            if (LLshopInfo != null) {
                                app.updateGlobalLLShopListByLLshopInfo(shopCode, LLshopInfo);

                                if (LLshopInfo.isOnline) {
                                    var check_date = app.$root.OrderDateSelect;
                                    var check_time = check_date.hour() * 100 + check_date.minute();
                                    var isOpen = app.cart.getShopOpen(LLshopInfo, app.$root.OrderDateSelectIsHoliday, check_date, check_time);
                                    if (isOpen) {
                                        re = true;
                                    }
                                    else {
                                        re = false;
                                    }
                                }
                                else {
                                    re = false;
                                }
                            }
                            else {
                                re = false;
                            }
                        }
                    );
                }

                return re;
            },
            updateGlobalLLShopListByLLshopInfo(shopCode, LLshopInfo) {
                var app = this;
                $.each(app.LLShopList, (i, o) => {
                    if (o.shopCode == shopCode) {
                        app.LLShopList[i] = JSON.parse(JSON.stringify(LLshopInfo));
                        app.setLLShopListStorage();
                        return;
                    }
                });
            },
            setLLShopListStorage() {
                window.localStorage.setItem("LLShopList", JSON.stringify(this.LLShopList));
            },
            getLLShopListStorage() {
                var p = window.localStorage.getItem("LLShopList") || "";
                if (p != "") {
                    this.LLShopList = JSON.parse(p);
                }
            },
            removeLLShopListStorage() {
                this.LLShopList = [];
                window.localStorage.removeItem("LLShopList");
            },
            GoogleMapComputeDistanceBetween(p1, p2) {
              return google.maps.geometry.spherical.computeDistanceBetween(
                new google.maps.LatLng(p1[0], p1[1]),
                new google.maps.LatLng(p2[0], p2[1])
              );
            },
            setShopListDistance(shopList) {
                var app = this;    

                if (app.$root.info.order_temp_info.order_type == 'pickup') {

                    if (app.$root.currentPositionLL == null) { return; }
                    else if (shopList.length == 0) {
                        return;
                    }
                    else {
                        var p1 = [app.$root.currentPositionLL.latitude, app.$root.currentPositionLL.longitude];
                        //console.log("p1", p1);
                        $.each(shopList, (i, o) => {
                            o.distance = Math.round(app.$root.GoogleMapComputeDistanceBetween(p1, o.location) / 100) / 10;
                        });
                        /*
                        shopList = shopList.sort(function (a, b) {
                            return a.distance > b.distance ? 1 : -1;
                        });
                        */
                    }

                }
                else {

                    if (app.info.order_temp_info.order_address == null) { return; }
                    else if (shopList.length == 0) {
                        return;
                    }
                    else {
                        var p1 = (app.info.order_temp_info.order_address.location + "").split(',');
                        //console.log("p1", p1);
                        $.each(shopList, (i, o) => {
                            o.distance = Math.round(app.$root.GoogleMapComputeDistanceBetween(p1, o.location) / 100) / 10;
                        });
                    }

                }
            },
            // for shop end

            // for address start
            SearchAddressText(ev,page_type) {
                this.SearchAddressPageType = page_type;
                var app = this;
                //var target = ev.target;
                var target = $($(ev.target).parents(".address_input_div")[0]).find(".input_area input")[0];
                var search_value = target.value;
                app.SearchAddressCurrentText = search_value;

                if (search_value.replace(/ /g,'').length > 0) {

                    if (app.SearchAddressDisplayText != search_value) {
                        app.isSearchAddress = true;
                        app.SearchAddressDisplayText = "";
                        app.isGetSearchAddress = 0;
                        app.SearchAddressTarget = target;
                        var parent_obj = $(app.SearchAddressTarget).parent().parent().get(0);
                        var parent_obj_data = parent_obj.getBoundingClientRect();
                        var parent_obj_offset = $(parent_obj).offset();

                        this.search_address_select_main_style = {
                                "top": (parent_obj_offset.top + parent_obj_data.height) + "px",
                                "left": (parent_obj_offset.left) + "px",
                                "width": (parent_obj_data.width) + "px"
                            };

                        $.ajax({
                            type: "GET",
                            url: app.info.wsUrl + "/map/search?q=" + encodeURIComponent(search_value),
                            contentType: "application/json",
                            dataType: "json",
                            success: (data) => {
                                //console.log("SearchAddressText",data);

                                if (app.SearchAddressCurrentText == search_value) {

                                    if (app.SearchAddressDisplayText != app.SearchAddressCurrentText) {
                                        if (data.flag == 0) {
                                            app.isGetSearchAddress = 1;
                                            app.SearchAddressDisplayText = app.SearchAddressCurrentText;

                                            $.each(data.result, (i, o) => {
                                                o["address_sc"] = o["address_zh"] + "";
                                            });                                            
                                            app.SearchAddressList = data.result;
                                        } else {
                                            app.isGetSearchAddress = 2;
                                        }

                                    } // SearchAddressDisplayText end
                                } // SearchAddressCurrentText end

                            }
                        }).catch(function () {
                        });

                    } // SearchAddressDisplayText != search_value end

                } else {
                    app.SearchAddressClear();
                }

            },
            SearchAddressPositionLL(target_id,page_type) {
                var app = this;
                if (app.currentPositionLL != null) {
                    this.SearchAddressPageType = page_type;
                    var target = this.$el.querySelector("#"+target_id);
                    var old_address = null;
                    if ($(target).data("oldValue") != undefined && $(target).data("oldValue") != null) {
                        old_address = $(target).data("oldValue");
                    }

                    if (page_type == "home") {
                        app.ChangeOrderAddressType('search',old_address);
                    }

                    target.value = "";

                    app.isSearchAddress = true;
                    app.SearchAddressDisplayText = "";
                    app.isGetSearchAddress = 0;
                    app.SearchAddressTarget = target;
                    var parent_obj = $(app.SearchAddressTarget).parent().parent().get(0);
                    var parent_obj_data = parent_obj.getBoundingClientRect();
                    var parent_obj_offset = $(parent_obj).offset();

                    this.search_address_select_main_style = {
                            "top": (parent_obj_offset.top + parent_obj_data.height) + "px",
                            "left": (parent_obj_offset.left) + "px",
                            "width": (parent_obj_data.width) + "px"
                        };

                    $.ajax({
                        type: "GET",
                        url: app.info.wsUrl + "/map/reverse?longitude=" + app.currentPositionLL.longitude + "&latitude=" + app.currentPositionLL.latitude,
                        contentType: "application/json",
                        dataType: "json",
                        success: (data) => {
                            //console.log("SearchAddressPositionLL",data);

                            if (data.flag == 0) {
                                app.isGetSearchAddress = 1;
                                app.SearchAddressDisplayText = app.SearchAddressCurrentText;

                                $.each(data.result, (i, o) => {
                                    o["address_sc"] = o["address_zh"] + "";
                                }); 
                                app.SearchAddressList = data.result;
                            } else {
                                app.isGetSearchAddress = 2;
                            }

                        }
                    }).catch(function () {
                    });
                }
                else {
                    app.getCurrentPositionLL(function() { app.SearchAddressPositionLL(target_id,page_type);  }, true);
                }
            },
            SetSearchAddressObj(add) {
                //console.log("SetSearchAddressObj",add);
                var search_address = JSON.parse(JSON.stringify(this.info.order_temp_info.order_address_sample));
                search_address["address_full_zh"] = add["address_zh"];
                search_address["address_full_en"] = add["address_en"];
                search_address["address_full_sc"] = add["address_sc"];
                search_address["address_zh"] = add["address_zh"];
                search_address["address_en"] = add["address_en"];
                search_address["address_sc"] = add["address_sc"];
                search_address["location"] = add["latitude"] + "," + add["longitude"];
                return search_address;
            },
            SearchAddressSelect(add) {
                var app = this;
                app.SearchAddressTarget.value = add["address_" + app.info.lang];

                var search_address = this.SetSearchAddressObj(add);
                $(app.SearchAddressTarget).data("oldValue", search_address);


                // check action page type
                if (app.SearchAddressPageType == "home") {
                    app.ChangeOrderAddressType("search",search_address);
                }
                else if (app.SearchAddressPageType == "add_modify") {
                    if (app.SearchAddressTarget.id == "modify_address_map_location_input") {
                        this.modify_address.address["address_en"] = add["address_en"]+"";
                        this.modify_address.address["address_zh"] = add["address_zh"] + "";
                        this.modify_address.address["address_sc"] = add["address_sc"] + "";
                        this.modify_address.address["location"] = add["latitude"] + "," + add["longitude"];
                        this.modifyAddressUpdateFullAddress();
                    }
                }
                else if (app.SearchAddressPageType == "member_profile") {
                    if (app.SearchAddressTarget.id == "member_profile_address_map_location_input") {
                        this.modify_address.address["address_en"] = add["address_en"]+"";
                        this.modify_address.address["address_zh"] = add["address_zh"] + "";
                        this.modify_address.address["address_sc"] = add["address_sc"] + "";
                        this.modify_address.address["location"] = add["latitude"] + "," + add["longitude"];
                        this.modifyAddressUpdateFullAddress();
                    }
                }

                app.SearchAddressClear();
            },
            SearchAddressClear() {
                var app = this;
                app.isSearchAddress = false;
                app.isSearchAddressFocus = false;
                app.isGetSearchAddress = 0;

                app.SearchAddressTarget = null;
                app.SearchAddressCurrentText = "";
                app.SearchAddressDisplayText = "";
            },
            SearchAddressFocus(ev,page_type) {
                var target_id = "";
                if (page_type == "home") {
                    target_id = ev.target.id;
                    var target = this.$el.querySelector("#"+target_id);
                    var old_address = null;
                    if ($(target).data("oldValue") != undefined && $(target).data("oldValue") != null) {
                        old_address = $(target).data("oldValue");
                    }

                    // update order address
                    this.ChangeOrderAddressType('search', old_address);
                    
                    //console.log("this.$root.address_list", JSON.parse(JSON.stringify(this.$root.address_list)));
                }

                var target = ev.target;
                if (!this.isSearchAddress) {
                    if (target.value.replace(/ /g,'').length > 0) {
                        ev.target.value = "";
                    }
                }

                this.isSearchAddressFocus = true;
            },
            SearchAddressBlur(ev, page_type) {
                var target = ev.target;
                if (target.value.replace(/ /g, '').length > 0) {
                    this.SearchAddressText(ev, page_type);
                }
                else {
                    if ($(target).data("oldValue") != undefined && $(target).data("oldValue") != null) {
                        target.value = $(target).data("oldValue")["address_" + this.info.lang];
                    }
                    else {
                        target.value = "";
                        $(target).data("oldValue",null);
                    }
                    this.SearchAddressClear();
                }
            },
            SearchAddressCancel() {
                if (this.SearchAddressTarget != null) {
                    var target = this.SearchAddressTarget;
                    if ($(target).data("oldValue") != undefined && $(target).data("oldValue") != null) {
                        target.value = $(target).data("oldValue")["address_" + this.info.lang];
                    }
                    else {
                        target.value = "";
                        $(target).data("oldValue",null);
                    }
                }
                this.SearchAddressClear();
            },
            modifyAddressOpen(open_type,header_text) {
                this.modify_address_header_text = header_text;

                this.modify_address_list = [];
                if (open_type == "home") {
                    this.modify_address_list = (this.address_list.filter(a => a.address_type == "member")).slice();
                    //this.modify_address_list = JSON.parse(JSON.stringify((this.address_list.filter(a => a.address_type == "member"))));
                }
                else if (open_type == "checkout") {
                    //console.log("this.address_list", JSON.parse(JSON.stringify(this.address_list)));
                    if (this.info.order_temp_info.order_address_type == "search") {
                        this.modify_address_list = this.address_list.slice();
                        //this.modify_address_list = JSON.parse(JSON.stringify(this.address_list));
                    } else if (this.info.order_temp_info.order_address_type == "member") {
                        this.modify_address_list = (this.address_list.filter(a => a.address_type == "member")).slice();
                        //this.modify_address_list = JSON.parse(JSON.stringify((this.address_list.filter(a => a.address_type == "member"))));
                    }
                }
                //console.log("this.modify_address_list", JSON.parse(JSON.stringify(this.modify_address_list)));

                this.is_modify_address = true;
                this.setBodyOverflow(true);
            },
            modifyAddressClose() {
                this.is_modify_address = false;
                this.is_modify_address_edit = false;
                this.modify_address_list = [];
                this.modify_address = null;
                this.setBodyOverflow(false);

                this.SearchAddressCancel();
            },
            modifyAddressSelect() {
                var app = this;
                
                // check address shop list
                this.info.loading = true;
                if (this.$root.info.order_setting.skipZeekShopList) {
                    this.$root.getShopList(function (data) { app.modifyAddressSelectCheckLLCb(data); });
                }
                else {
                    var selectAddress = app.modify_address_list.filter(a => a.isSelect)[0];
                    var selectAddress_location = (selectAddress.address.location + "").split(',');
                    app.getShopListByLL(selectAddress_location[0], selectAddress_location[1], function (data) { app.modifyAddressSelectCheckLLCb(data); });
                }                
            },
            modifyAddressSelectCheckLLCb(data) {
                var temp_shop_list = data.shops;
                var temp_shop_list_filter = [];

                if (this.cart.shop != null) {
                    temp_shop_list_filter = temp_shop_list.filter(a => (a.shopCode + "_" + this.getCurrentOrderTypeShopFilterSubfix) == this.cart.shop.shopCode);
                }
                this.info.loading = false;

                if (this.cart.shop == null || temp_shop_list_filter.length > 0) {
                    this.modifyAddressSelectConfirm(temp_shop_list, false);
                }
                else {
                    var app = this;
                    this.setConfirmMsg(app.label['confirmation_msg_change_location_alert'], function () { app.modifyAddressSelectConfirm(temp_shop_list, app.info.order_setting.location_datetime_modify_redirect); }, undefined);
                }
            },
            modifyAddressSelectConfirm(new_shop_list, redirect_shop) {
                this.info.loading = true;
                var select_address_id = "";

                // reset id and resave member address list
                this.modifyAddresIdReset();
                var member_address_update = [];
                $.each(this.modify_address_list, (i, a) => {
                    if (a.isSelect) {
                        select_address_id = a["address_id"];
                    }

                    if (a.isSave) {
                        member_address_update.push(a);
                        member_address_update[member_address_update.length-1]["address_id"] = "madd" + member_address_update.length; // reset save member address id prevent duplicate with address list

                        if (a.isSelect) {
                            select_address_id = "madd" + member_address_update.length;
                        }
                    }
                });
                if (member_address_update.length > 0 && member_address_update.filter(a => a.isDefault).length <= 0) {
                    member_address_update[0].isDefault = true;
                }
                if (member_address_update.length > 0 && member_address_update.filter(a => a.isMemberSelect).length <= 0) {
                    member_address_update.filter(a => a.isDefault)[0].isMemberSelect = true;
                }
                //console.log("member_address_update",JSON.parse(JSON.stringify(member_address_update)));

                // update selected address after update member address
                if (this.UpdateSaveMemberAddressList(member_address_update)) {                    
                    // update cart member address
                    this.cart.memberAddress = JSON.parse(JSON.stringify(member_address_update));

                    // update current shop list
                    this.LLShopList = new_shop_list;
                    this.setLLShopListStorage();

                    // update order info data
                    //var selectAddress = this.address_list.filter(a => a["address_id"] == select_address_id)[0];
                    var selectAddress = this.modify_address_list.filter(a => a["address_id"] == select_address_id)[0];
                    this.SetOrderDataAddressContactData(selectAddress.address_id + "",selectAddress.address_type + "",  (selectAddress.address_tag == undefined || selectAddress.address_tag == null ? "" : selectAddress.address_tag + ""), JSON.parse(JSON.stringify(selectAddress.address)),JSON.parse(JSON.stringify(selectAddress.contact_info)));

                    //update cart order info
                    this.cart.updateCartOrderInfo(this.info.order_temp_info, this.info.lang);

                    // reset address_list
                    this.UpdateCurrentAddressList();

                    // reset data
                    this.info.loading = false;
                    this.modify_address_list = [];
                    this.is_modify_address = false;
                    this.is_modify_address_edit = false;
                    this.setBodyOverflow(false);

                    // check need redirect
                    if (redirect_shop) {
                        // clear cart then redirect to shop page
                        this.cart.clearCart();
                        this.cart.shop = null;
                        if (this.info.currentPathName != "/")
                            this.$router.replace("/shop");
                    }
                    else {
						// update cart       
                        if (this.info.currentPathName != "/") {
                            this.updateCart();
                        }
                    }

                }
                // else if update member address fail
                else {
                    this.info.loading = false;
                }
            },
            modifyAddresIdReset() {
                // set member type and id
                var isSelectSearchAddress = this.modify_address_list.filter(a => (a.address_type == "search" && a.isSelect));
                $.each(this.modify_address_list, (i, a) => {
                    if (a["address_type"] == "member") {
                        a["address_id"] = "m" + (i+1);
                    } else {
                        // address type change to member if save the search address
                        if (a.isSave) {
                            a["address_type"] = "member";
                            a["address_id"] = "m" + (i+1);
                        } else {
                            a["address_id"] = "search";
                        }
                    }
                });

                // set isMemberSelect after set address type (isMemberSelect is for display address on home page)
                var isSelectSearchAddress = this.modify_address_list.filter(a => (a.address_type == "search" && a.isSelect));
                if (isSelectSearchAddress.length <= 0) {
                    $.each(this.modify_address_list, (i, a) => {
                        // not selecting search address means selecting member address so update all data to false first
                        a.isMemberSelect = false;

                        if (a.isSelect) {
                            // update isMemberSelect if selecting the member address
                            if (a.address_type == "member") {
                                a.isMemberSelect = true;
                            }
                        }
                    });
                }
            },

            modifyAddressEditClick(addObj) {
                console.log("addObj",addObj);

                if (!this.is_modify_address_edit) {
                    this.is_modify_address_edit = true;

                    if (addObj == undefined || addObj == null) {
                        // empty a modify_address
                        this.modify_address = {"address_id":"new_address","address_type":"member","address_tag":""};
                        this.modify_address.address = JSON.parse(JSON.stringify(this.info.order_temp_info.order_address_sample));
                        this.modify_address.contact_info = JSON.parse(JSON.stringify(this.info.order_temp_info.order_contact_info_sample));
                        this.modify_address.contact_info.email = this.cart.member.email+"";
                        this.modify_address.isDefault = false;
                        this.modify_address.isSelect = false;
                        this.modify_address.isSave = false;
                        this.modify_address_isSave = false;
                    } else {
                        this.modify_address = addObj;
                        this.modify_address_isSave = addObj.isSave;
                    }

                    this.modifyAddressEditFillData();
                } else {
                    this.modify_address = null;
                    this.modify_address_isSave = false;
                    this.is_modify_address_edit = false;
                    this.SearchAddressCancel();
                }
            },
            modifyAddressEditFillData() {
                var modify_address_map_location_input = this.$el.querySelector("#modify_address_map_location_input");
                //var modify_address_map_location_floor_input = this.$el.querySelector("#modify_address_map_location_floor_input");
                //var modify_address_map_location_flat_input = this.$el.querySelector("#modify_address_map_location_flat_input");
                //var modify_address_map_location_contact_name_input = this.$el.querySelector("#modify_address_map_location_contact_name_input");
                //var modify_address_map_location_contact_tel_input = this.$el.querySelector("#modify_address_map_location_contact_tel_input");
                //var modify_address_map_location_contact_tel2_input = this.$el.querySelector("#modify_address_map_location_contact_tel2_input");

                //console.log("modify_address_map_location_input",modify_address_map_location_input);
                if (modify_address_map_location_input != null) {
                    modify_address_map_location_input.value = this.modify_address.address['address_'+this.info.lang];
                    var modify_address_location = this.modify_address.address['location'].split(',');
                    $(modify_address_map_location_input).data("oldValue", {"address_zh":this.modify_address.address['address_zh'],"address_en":this.modify_address.address['address_en'],"address_sc":this.modify_address.address['address_sc'],"latitude":modify_address_location[0],"longitude":modify_address_location[1]});

                    //modify_address_map_location_floor_input.value = this.modify_address.address['floor'];
                    //modify_address_map_location_contact_name_input.value = this.modify_address.contact_info['name'];
                    //modify_address_map_location_contact_tel_input.value = this.modify_address.contact_info['tel'];
                    //modify_address_map_location_contact_tel_countryCode_input.value = this.modify_address.contact_info['tel_countryCode'];
                    //modify_address_map_location_contact_tel2_input.value = this.modify_address.contact_info['tel2'];
                    //modify_address_map_location_contact_tel2_countryCode_input.value = this.modify_address.contact_info['tel2_countryCode'];
                } else {
                    setTimeout(this.modifyAddressEditFillData,100);
                }
            },
            modifyAddressEditCheckCanSubmit(isAlert) {
                if (this.modify_address != null && this.modify_address.address.address_en != '' && !((this.modify_address.address.block == '' || this.modify_address.address.block == undefined) && this.modify_address.address.flat == '' && this.modify_address.address.floor == '') && this.modify_address.contact_info.name != '' && this.modify_address.contact_info.tel != '') {
                    if (this.$root.CheckPhoneFormat(this.modify_address.contact_info.tel)) {
                        return true;
                    }
                    else {
                        if (isAlert)
                            this.alert("tel.invalid");

                        return false;
                    }
                }
                else {
                    if (isAlert)
                        this.alert("modify_address_alert_please_fill_correct_address_and_contact_info");

                    return false;
                }
            },
            modifyAddressIsSaveClick() {
                if (this.modify_address_isSave) {
                    this.modify_address_isSave = false;
                } else {
                    var modify_address_isSave = this.modify_address_list.filter(a => a.isSave);
                    if (modify_address_isSave.length+1 > this.info.memberAddressSaveLimit) {
                        this.alert("modify_address_alert_address_save_is_limit");
                    } else {
                        this.modify_address_isSave = true;
                    }
                }
            },
            modifyAddressSelectClick(select_add) {
                $.each(this.modify_address_list, (i, a) => {
                    a.isSelect = false;
                });
                select_add.isSelect = true;

                if (select_add["address_type"] == "member") {
                    $.each(this.modify_address_list.filter(a => a["address_type"] == "member"), (i, a) => {
                        //a.isMemberSelect = false;
                    });
                    //select_add.isMemberSelect = true;
                }

                //console.log("this.modify_address_list",JSON.parse(JSON.stringify(this.modify_address_list)));
            },
            modifyAddressUpdateFullAddress() {
                var zh_str = this.modify_address.address.address_zh + ((this.modify_address.address.block != '' && this.modify_address.address.block != undefined) ? " " + this.modify_address.address.block + "" + allLabel['zh']['modify_address_address_fill_block_text'] + "" : '') + (this.modify_address.address.floor != '' ? " " + this.modify_address.address.floor + "" + allLabel['zh']['modify_address_address_fill_floor_text'] + "" : '') + (this.modify_address.address.flat != '' ? " " + this.modify_address.address.flat + "" + allLabel['zh']['modify_address_address_fill_flat_text'] + "" : '');
                var en_str = (this.modify_address.address.flat != '' ? allLabel['en']['modify_address_address_fill_flat_text'] + " " + this.modify_address.address.flat + ", " : '') + (this.modify_address.address.floor != '' ? allLabel['en']['modify_address_address_fill_floor_text'] + " " + this.modify_address.address.floor + ", " : '') + ((this.modify_address.address.block != '' && this.modify_address.address.block != undefined) ? this.modify_address.address.block + " " + allLabel['en']['modify_address_address_fill_block_text'] + ", " : '') + this.modify_address.address.address_en;
                this.modify_address.address['address_full_zh'] = zh_str;
                this.modify_address.address['address_full_en'] = en_str;
                this.modify_address.address['address_full_sc'] = zh_str;
                this.modify_address.isSave = this.modify_address_isSave;
                this.modifyAddressUpdateKey();
            },
            modifyAddressUpdateKey() {
                this.modify_address_isUpdate++;
            },
            modifyAddressEditUpdate() {
                this.SearchAddressCancel();
                if (this.modifyAddressEditCheckCanSubmit(true)) {
                    this.info.loading = true;
                    this.modify_address.isSave = this.modify_address_isSave;

                    var isNew = (this.modify_address["address_id"] == "new_address");
                    if (isNew) {
                        this.modify_address_list.push(JSON.parse(JSON.stringify(this.modify_address)));
                    }

                    this.info.loading = false;
                    this.modify_address = null;
                    this.modify_address_isSave = false;
                    this.is_modify_address_edit = false;
                }
            },
            // for address end

            // for confirm msg start
            setConfirmMsg(msg, confirm_action, close_action) {
                this.info.confirmMsg = msg;
                this.setConfirmMsgConfirmAction(confirm_action);
                this.setConfirmMsgCancelAction(close_action);
            },
            confirmMsgConfirmClick() {
                if (this.confirmMsgConfirmAction != undefined) {
                    this.confirmMsgConfirmAction();
                }
                this.setConfirmMsgConfirmAction();
                this.setConfirmMsgCancelAction();
                this.info.confirmMsg = "";
            },
            confirmMsgCancelClick() {
                if (this.confirmMsgCancelAction != undefined) {
                    this.confirmMsgCancelAction();
                }
                this.setConfirmMsgConfirmAction();
                this.setConfirmMsgCancelAction();
                this.info.confirmMsg = "";
            },
            setConfirmMsgConfirmAction(action) {
                this.confirmMsgConfirmAction = action;
            },
            setConfirmMsgCancelAction(action) {
                this.confirmMsgCancelAction = action;
            },
            // for confirm msg end

            // for order data start
            setOrderTempInfoData() {
                window.localStorage.setItem("OrderTempInfoData", JSON.stringify(this.info.order_temp_info));
            },
            getOrderTempInfoData() {
                var OrderTempInfoData = window.localStorage.getItem("OrderTempInfoData") || "";
                if (OrderTempInfoData != "") {
                    //this.info.order_temp_info = JSON.parse(OrderTempInfoData);
                    $.extend(this.info.order_temp_info, JSON.parse(OrderTempInfoData));
                }
                this.UpdateInfoOrderSettingByMode();
            },
            removeOrderTempInfoData() {
                var temp_order_device = this.info.order_temp_info.order_device + "";
                var temp_order_mode = this.info.order_temp_info.order_mode + "";
                window.localStorage.removeItem("OrderTempInfoData");
                //this.info.order_temp_info.temp_default_shop = ""; // no need to remove default_shop for nanfung(keep if visit by default_shopcode)
                this.info.order_temp_info.temp_default_shop = ""; // clear temp_default_shop for prefer shop on home page
                this.info.order_temp_info.home_select_shop = "";
                this.info.order_temp_info.order_device = temp_order_device + "";
                //this.info.order_temp_info.order_mode = "order";
                this.info.order_temp_info.order_mode = temp_order_mode;
                this.info.order_temp_info.order_type = this.$root.info.order_setting.orderType[0];
                this.info.order_temp_info.order_type_temp = this.$root.info.order_setting.orderType[0];
                this.info.order_temp_info.order_address_type = "search";
                this.info.order_temp_info.order_address = null;
                this.info.order_temp_info.order_contact_info = null;
                this.fixHomeOptionObj.isFix = false;
                this.UpdateInfoOrderSettingByMode();
                this.initOrderDateData(true);
            },
            checkSelectedDateTimeData(check_datetime, order_type, return_time_range) {
                var re = false;
                var starting_date_time = moment(check_datetime.format("YYYY-MM-DD") + " " + this.info.order_setting.order_time_starting_time);



                //console.log("starting_date_time 1", starting_date_time.format("YYYY-MM-DD HH:mm"));
                if (this.info.order_temp_info.temp_default_shop != "") {
                    if (moment().format("YYYY-MM-DD") == check_datetime.format("YYYY-MM-DD")) {
                        var checkDate = null;
                        $.each(this.GetDefaultShopCodeObjStartEndTime(), (i, t) => {
                            //console.log("0", t);
                            //console.log("1",moment(check_datetime.format("YYYY-MM-DD") + " " + t[0]));
                            //console.log("2",(moment() <= moment(check_datetime.format("YYYY-MM-DD") + " " + t[0])));
                            if (moment() <= moment(check_datetime.format("YYYY-MM-DD") + " " + t[0])) {
                                checkDate = moment(check_datetime.format("YYYY-MM-DD") + " " + t[0]);
                                return false;
                            }
                        });

                        if (checkDate == null) {
                            return false;
                        }
                        else {
                            starting_date_time = moment(checkDate);
                        }
                    }
                    else {
                        starting_date_time = moment(check_datetime.format("YYYY-MM-DD") + " " + this.GetDefaultShopCodeObjStartEndTime()[0][0]);
                    }                    
                }
                //console.log("starting_date_time 2", starting_date_time.format("YYYY-MM-DD HH:mm"));



                var start_time_range = this.initStartTimeRangeValue(starting_date_time, order_type);
                if (return_time_range != undefined) {
                    return_time_range.value = moment(start_time_range);
                }

                //console.log("checkSelectedDateTimeData check_datetime", check_datetime.format("YYYY-MM-DD HH:mm"));
                //console.log("checkSelectedDateTimeData start_time_range", moment(start_time_range).format("YYYY-MM-DD HH:mm"));
                if (check_datetime >= start_time_range) {
                    re = true;
                }
                //console.log("checkSelectedDateTimeData re", re);
                return re;
            },
            initOrderDateData(reset) {
                var check_datetime = true;
                var return_time_range = { value:moment() };
                if (!reset) {
                    if (this.info.order_temp_info.order_time == "asap") {
                        check_datetime = false;
                    } else {
                        check_datetime = this.checkSelectedDateTimeData(this.OrderDateSelect, this.info.order_temp_info.order_type, return_time_range);
                    }
                }

                //if (reset || this.info.order_temp_info.order_date_list.length == 0 || this.info.order_temp_info.order_date_list[0] != moment().format("YYYY-MM-DD") || !check_datetime) {
                if (reset || this.info.order_temp_info.order_date_list.length == 0 || this.info.order_temp_info.order_date_list[0] != moment().add(this.info.order_setting.order_start_from_date, 'days').format("YYYY-MM-DD") || !check_datetime) {

                    // hide for not checking menu time on 20230602
                    /*
                    if (!check_datetime && this.cartItemCount > 0) {
                        var target_shop_menu_time = moment();
                        if (this.info.order_temp_info.order_time == "asap") {
                            target_shop_menu_time = this.getShopMenuTime(this.info.order_temp_info.order_type, this.OrderDateSelect.format("HH:mm") + "-" + this.OrderDateSelect.format("HH:mm"));
                        }
                        else {
                            target_shop_menu_time = this.getShopMenuTime(this.info.order_temp_info.order_type, return_time_range.value.format("HH:mm") + "-" + return_time_range.value.format("HH:mm"));
                        }
                        if (target_shop_menu_time != this.info.order_temp_info.order_shop_menu_time) {

                            // update order menu time if asap
                            if (this.info.order_temp_info.order_time == "asap") {
                                this.SetOrderShopMenuTime();
                            }

                            this.$root.alert("order_menu_timeout_alert_text");
                            this.cart.clearCart();
                            //this.$router.replace("/menu");
                            if (this.info.currentPathName.startsWith("/menu")) {
                                this.$router.replace("/menu");
                                //this.$router.go(this.$router.currentRoute);
                                this.menuIsUpdate++;
                            }
                            else {
                                this.$router.replace("/menu");
                            }
                        }
                    }
                    */

                    var start_date_moment = moment();
                    if (this.info.order_setting.order_start_date != "today") {
                        start_date_moment = moment(this.info.order_setting.order_start_date);
                    }
                    this.info.order_temp_info.order_date_list = [];
                    var temp_option_date = null;

                    if (this.info.order_setting.order_start_date == "today") {                        
                        start_date_moment = start_date_moment.add(this.info.order_setting.order_start_from_date, 'days');

                        for (var i = this.info.order_temp_info.order_date_list.length; this.info.order_temp_info.order_date_list.length < this.info.order_setting.order_date_range; i++) {
                            temp_option_date = moment(start_date_moment).add(i, 'days');

							if (this.info.order_setting.aspa_only) {
								if (temp_option_date.format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
									if (this.checkDateIsSatSunHoliday(temp_option_date, this.info.order_setting.holidayCount)) {
										this.info.order_temp_info.order_date_list.push(temp_option_date.format("YYYY-MM-DD"));
									}
								}
							}
							else {
								if (this.checkDateIsSatSunHoliday(temp_option_date, this.info.order_setting.holidayCount)) {
									this.info.order_temp_info.order_date_list.push(temp_option_date.format("YYYY-MM-DD"));
								}
							}
							
							if (i>=10) {
								break;
							}
                        }
                    }
                    else {
                        for (var i = 0; i < this.info.order_setting.order_date_range; i++) {                            
                            temp_option_date = moment(start_date_moment).add(i, 'days');

                            if (this.info.order_setting.aspa_only) {
                                if (temp_option_date.format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
                                    if (parseInt(temp_option_date.format("YYYYMMDD"), 10) >= parseInt(moment().add(this.info.order_setting.order_start_from_date, 'days').format("YYYYMMDD"), 10)) {
                                        if (this.checkDateIsSatSunHoliday(temp_option_date, this.info.order_setting.holidayCount)) {
                                            this.info.order_temp_info.order_date_list.push(temp_option_date.format("YYYY-MM-DD"));
                                        }
                                    }
                                }
                            }
                            else {
                                if (parseInt(temp_option_date.format("YYYYMMDD"), 10) >= parseInt(moment().add(this.info.order_setting.order_start_from_date, 'days').format("YYYYMMDD"), 10)) {
                                    if (this.checkDateIsSatSunHoliday(temp_option_date, this.info.order_setting.holidayCount)) {
                                        this.info.order_temp_info.order_date_list.push(temp_option_date.format("YYYY-MM-DD"));
                                    }
                                }
                            }

                            if (i >= 10) {
                                break;
                            }
                        }
                    }

                    if (this.info.order_temp_info.order_date_list.length > 0) {
                        //if (parseInt(moment(this.info.order_temp_info.order_date).format("YYYYMMDD"),10) <= parseInt(moment(this.info.order_temp_info.order_date_list[0]).format("YYYYMMDD"),10) && this.info.order_temp_info.order_date_list[0] == moment().format("YYYY-MM-DD")) {
                        if (this.info.order_temp_info.order_date_list[0] == moment().format("YYYY-MM-DD") ||
                            this.info.order_temp_info.order_date_list[0] != this.info.order_temp_info.order_date[0]
                            ) {
                            this.info.order_temp_info.order_time_list = this.initOrderTimeList(this.info.order_temp_info.order_date_list[0], this.info.order_temp_info.order_type);
                            this.info.order_temp_info.order_date = this.info.order_temp_info.order_date_list[0];
                            this.info.order_temp_info.order_time = this.info.order_temp_info.order_time_list[0];
                        } else {
                            this.info.order_temp_info.order_time_list = this.initOrderTimeList(this.info.order_temp_info.order_date, this.info.order_temp_info.order_type);
                            if (!this.info.order_temp_info.order_time_list.includes(this.info.order_temp_info.order_time)) {
                                this.info.order_temp_info.order_time = this.info.order_temp_info.order_time_list[0];
                            }
                        }
                        this.SetOrderShopMenuTime();
                    }
                    else {
                        this.info.order_temp_info.order_date_list = ["---"];
                        this.info.order_temp_info.order_time_list = ["---"];
                        this.info.order_temp_info.order_date = this.info.order_temp_info.order_date_list[0];
                        this.info.order_temp_info.order_time = this.info.order_temp_info.order_time_list[0];
                    }

                    if (!this.info.order_setting.order_time_select) {
                        this.info.order_temp_info.order_time = "00:00";
                    }

                    this.setOrderTempInfoData();
                }
            },
            checkDateIsSatSunHoliday(checkDate, holidayCountObj) {
                var re = true;

                if (holidayCountObj != undefined && holidayCountObj != null) {
                    if (holidayCountObj.isCheck) {
                        var checkDate_day = checkDate.day();

                        if (re) {
                            if (holidayCountObj.saturday && checkDate_day == 6) {
                                re = false;
                            }
                        }
 
                        if (re) {
                            if (holidayCountObj.sunday && checkDate_day == 0) {
                                re = false;
                            }
                        }
                        
                        if (re) {
                            if (holidayCountObj.holiday && this.CheckIsHoliday(checkDate)) {
                                re = false;
                            }
                        }
                        
                        if (re) {
                            if (holidayCountObj.dates.length > 0 && holidayCountObj.dates.indexOf(checkDate.format("YYYY-MM-DD")) >= 0) {
                                re = false;
                            }
                        }
                    }
                }

                return re;
            },
            initStartTimeRangeValue(starting_date_time, order_type) {
                var start_time_range = moment(starting_date_time);
                if (moment(starting_date_time).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
                    var order_time_start = null;
                    if (order_type == "delivery") {
                        order_time_start = moment().add(this.info.order_setting.order_time_start_from_mins_delivery,'minutes');
                    }
                    else if (order_type == "pickup") {
                        order_time_start = moment().add(this.info.order_setting.order_time_start_from_mins_pickup,'minutes');
                    }

                    //console.log("order_time_start", order_time_start);
                    if (order_time_start != null) {
                        while (start_time_range < order_time_start) {
                            //console.log("start_time_range while", moment(start_time_range).format("YYYY-MM-DD HH:mm"));
                            start_time_range = moment(start_time_range).add(this.info.order_setting.order_time_minutes_range,'minutes');
                        }
                    }
                }

                return start_time_range;
            },
            initOrderTimeList(date_string, order_type) {
                var order_time_list = [];
                var order_starting_date_time = moment(date_string + " " + this.info.order_setting.order_time_starting_time);
                var order_ending_date_time = moment(date_string + " " + this.info.order_setting.order_time_ending_time);

                if (this.info.order_setting.alow_aspa && this.info.order_setting.aspa_only && moment(date_string).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
                    order_time_list.push("asap");
                }
                else {

                    if (this.info.order_temp_info.temp_default_shop != "") {

                        $.each(this.GetDefaultShopCodeObjStartEndTime(), (i, t) => {
                            order_starting_date_time = moment(date_string + " " + t[0]);
                            order_ending_date_time = moment(date_string + " " + t[1]);
                            //console.log("order_starting_date_time", order_starting_date_time);
                            //console.log("order_ending_date_time", order_ending_date_time);

                            var start_time_range = this.initStartTimeRangeValue(order_starting_date_time, order_type);
                            var set_time = null;
                            while (start_time_range < order_ending_date_time) {
                                set_time = moment(start_time_range);
                                //order_time_list.push(set_time.format("HH:mm") + " - " + set_time.add(this.info.order_setting.order_time_minutes_range,'minutes').add(-1,'minutes').format("HH:mm")); // time not end as 00 (eg: 11:59)
                                order_time_list.push(set_time.format("HH:mm") + " - " + set_time.add(this.info.order_setting.order_time_minutes_range, 'minutes').format("HH:mm")); // time end as 00  (eg: 12:00)
                                start_time_range.add(this.info.order_setting.order_time_minutes_range, 'minutes');
                            }
                        });

                    }
                    else {
                        //console.log("order_starting_date_time", order_starting_date_time);
                        //console.log("order_ending_date_time", order_ending_date_time);

                        var start_time_range = this.initStartTimeRangeValue(order_starting_date_time, order_type);
                        var set_time = null;
                        while (start_time_range < order_ending_date_time) {
                            set_time = moment(start_time_range);
                            //order_time_list.push(set_time.format("HH:mm") + " - " + set_time.add(this.info.order_setting.order_time_minutes_range,'minutes').add(-1,'minutes').format("HH:mm")); // time not end as 00 (eg: 11:59)
                            order_time_list.push(set_time.format("HH:mm") + " - " + set_time.add(this.info.order_setting.order_time_minutes_range, 'minutes').format("HH:mm")); // time end as 00  (eg: 12:00)
                            start_time_range.add(this.info.order_setting.order_time_minutes_range, 'minutes');
                        }
                    }

                    if (order_time_list.length == 0) {
                        order_time_list.push("---");
                    }
                    else {
                        if (this.info.order_setting.alow_aspa && moment(date_string).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
                            order_time_list.splice(0, 0, "asap");

                            if (this.info.order_setting.aspa_only) {
                                order_time_list.length = 1;
                            }
                        }
                    }

                }

                return order_time_list;
            },
            
            ChangeSelectShopDistrict(ev) {
                this.$root.homeSelectShop.homeSelectShopDistrict = ev.target.value + "";

                // hide for update pickup function
                /*
                this.$root.homeSelectShop.homeSelectShopList = [];
                this.$root.homeSelectShop.homeSelectedShopList = "";
                if (this.$root.homeSelectShop.homeSelectShopDistrict != "")
                    this.ChangeSelectShopDistrictFilter();
                */
            },
            ChangeSelectShopDistrictFilter() {                
                var app = this;
                var temp_shop = app.$root.AllShopList.filter(s2 => s2.shopType == app.$root.info.order_temp_info.order_mode && s2.shopCode.indexOf("_" + app.$root.getCurrentOrderTypeShopFilterSubfix) > 0 && s2.districtCode == app.$root.homeSelectShop.homeSelectShopDistrict);
                //console.log("temp_shop", temp_shop);
                $.each(temp_shop, (i, s) => {
                    s.isOnline = true;
                    s.quoteTime = 1;
                    app.$root.homeSelectShop.homeSelectShopList.push(s);
                });                
            },
            ChangeSelectShopDistrictArea(ev) {
                this.$root.homeSelectShop.homeSelectShopArea = ev.target.value + "";
                this.$root.homeSelectShop.homeSelectShopDistrict = "";
                this.$root.homeSelectShop.homeSelectShopAreaDistrictList = [];
                if (this.$root.homeSelectShop.homeSelectShopArea != "")
                    this.ChangeSelectShopDistrictAreaFilter();                
            },
            ChangeSelectShopDistrictAreaFilter() {
                var app = this;
                app.ChangeSelectShopDistrictAreaFilterFill(app.$root.homeSelectShop.homeSelectShopArea, app.$root.homeSelectShop.homeSelectShopAreaDistrictList);                
            },
            ChangeSelectShopDistrictAreaFilterFill(selectArea, fillDistrictArray) {
                var app = this;
                var temp_shop = app.AllShopDistrictList.filter(s => s.areaCode == selectArea);
                if (temp_shop.length > 0) {
                    $.each(temp_shop[0].district, (i, s) => {
                        if (app.$root.getCurrentOrderTypeShopFilterSubfix == '3') {                            
                            temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType != 'shopping' && s2.visible == 'y' && s2.shopCode.includes("_" + app.$root.getCurrentOrderTypeShopFilterSubfix) && (s2.districtCode == s.districtCode)));
                            if (temp_shop.length > 0)
                                fillDistrictArray.push(s);
                        }
                        else {
                            fillDistrictArray.push(s);
                        }
                    });
                }
            },
            ChangeSelectShoppingDistrictArea(ev, cb) {
                this.$root.homeSelectShop.homeSelectShopArea = ev.target.value + "";
                this.$root.homeSelectShop.homeSelectShopDistrict = "";
                this.$root.homeSelectShop.homeSelectShopAreaDistrictList = [];
                if (this.$root.homeSelectShop.homeSelectShopArea != "")
                    this.ChangeSelectShoppingDistrictAreaFilter();              

                if (cb) cb();
            },
            ChangeSelectShoppingDistrictAreaFilter() {
                var app = this;
                var temp_shop = app.shoppingDistrictList.filter(s => s.areaCode == app.$root.homeSelectShop.homeSelectShopArea);
                if (temp_shop.length > 0) {
                    $.each(temp_shop[0].district, (i, s) => {
                        app.$root.homeSelectShop.homeSelectShopAreaDistrictList.push(s);
                    });
                }                
            },
            ChangeSelectShopDistrictAreaDistrict(ev, cb) {
                this.$root.homeSelectShop.homeSelectShopDistrict = ev.target.value + "";
                if (cb) cb();
            },
            ChangeSelectShopDistrictAreaList(ev, cb) {
                this.$root.homeSelectShop.homeSelectShopArea = ev.target.value + "";
                this.$root.homeSelectShop.homeSelectShopDistrict = "";
                if (cb) cb();
            },

            changeSelectShopList(ev) {
                this.$root.homeSelectShop.homeSelectedShopList = ev.target.value + "";
            },
            homeSelectShopListConfirm() {
                var app = this;
                /*
                if (app.$root.homeSelectShop.homeSelectedShopList != "") {
                    var select_shop = app.$root.AllShopList.filter(s2 => s2.shopCode == app.$root.homeSelectShop.homeSelectedShopList)[0];
                    select_shop.isOpen = true;
                    select_shop.isCloseSoon = false;
                    app.cart.shop = select_shop;
                }
                */
                if (app.$root.homeSelectShop.homeSelectShopDistrict != "") {
                }
            },
            resetAllHomeSelect() {
                try {
                    //this.$root.homeSelectShop.homeSelectShopArea = "";
                    //this.$root.homeSelectShop.homeSelectShopDistrict = "";
                    //this.$root.homeSelectShop.homeSelectShopAreaDistrictList = [];

                    this.homeSelectShop.homeSelectShopList = [];
                    this.homeSelectShop.homeSelectedShopList = "";
                    this.info.order_temp_info.order_address = null;
                    this.info.order_temp_info.order_address_type = "search";

                    var target_id = "home_search_address_text";
                    var target = this.$el.querySelector("#" + target_id);
                    target.value = "";
                    $(target).data("oldValue", null);
                } catch (e) {}
            },

            checkHomeOrderModeEnable(mode) {
                var app = this;
                var re = false;

                re = app.$root.info.order_mode_setting[mode].active;
                if (re) {
                    if (app.fixHomeOptionObj.isFix) {
                        if (app.fixHomeOptionObj.orderMode != "") {
                            if (mode != app.fixHomeOptionObj.orderMode) {
                                re = false;
                            }
                            else {
                                re = true;
                            }
                        }
                        else {
                            re = true;
                        }
                    }
                    else {
                        re = true;
                    }
                }
                else {
                    re = false;
                }

                return re;
            },
            checkHomeEnableSelectAreaDistrict() {
                /*
                var app = this;
                var re = false;

                re = app.$root.info.order_temp_info.order_type == 'pickup';
                if (re) {                    
                    if (app.fixHomeOptionObj.isFix && app.fixHomeOptionObj.selectAreaDistrict) {
                        re = false;
                    }
                    else {
                        re = true;
                    }
                }
                else {
                    re = false;
                }

                return re;
                */

                // always return false for nanfung
                if (this.info.order_temp_info.temp_default_shop != "") {
                    return false;
                }
                else {
                    if (this.info.order_temp_info.order_type == 'pickup' || this.info.order_temp_info.order_type == 'pickupShop') {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },

            changeOrderMode(mode) {
                var old_mode = this.info.order_temp_info.order_mode + "";
                this.info.order_temp_info.order_mode = mode;                
                this.UpdateInfoOrderSettingByMode();

                if (old_mode != mode) {
                    this.$root.homeSelectShop.homeSelectShopArea = "";
                    this.$root.homeSelectShop.homeSelectShopDistrict = "";
                    this.$root.homeSelectShop.homeSelectShopAreaDistrictList = [];
                }
                
                if (this.info.currentPathName == "/") {
                    this.SearchAddressCancel();
                    this.resetAllHomeSelect();
                }

                this.initOrderDateData(true);
            },
            changeOrderType(type) {
                /*
                if (this.cart.shop != null) {
                    if (this.getShopInfo(this.cart.shop.shopCode.substring(0, this.cart.shop.shopCode.length - 2) + "_" + (type == "delivery" ? "1" : "2")) == null) {
                        return;
                    }
                }
                */
                if (type != this.info.order_temp_info.order_type) {
                    if (this.info.order_setting.location_datetime_modify_redirect) {
                        if (this.cartItemCount > 0) {
                            var app = this;
                            this.setConfirmMsg(app.label['confirmation_msg_change_order_type_alert'], function() { app.changeOrderTypeConfirm(type); }, function() { app.changeOrderTypeCancel(); });
                        }
                        else {
                            this.changeOrderTypeConfirm(type);
                        }
                    } else {
                        this.changeOrderTypeConfirm(type);
                    }
                }
            },
            changeOrderTypeConfirm(type) {
                var app = this;
                this.info.order_temp_info.order_type = type;
                this.info.order_temp_info.order_type_temp = type;
                if (this.cart.shop != null) {
                    var shopCode = this.cart.shop.shopCode_global + "_" + this.getCurrentOrderTypeShopDetailsSubfix;
                    if (this.getCurrentOrderTypeShopDetailsSubfix == "3") {
                        shopCode = this.cart.shop.shopCode_global;
                    }
                    this.cart.shop = this.getShopInfo(shopCode, true);
                }

                // reset the order date time
                this.initOrderDateData(true);

                // clear cart
                if (this.info.order_setting.location_datetime_modify_redirect) {
                    this.cart.clearCart();
                }
                console.log('this.cart', this.cart);

                // reset home select area district
                this.$root.homeSelectShop.homeSelectShopArea = "";
                this.$root.homeSelectShop.homeSelectShopDistrict = "";
                this.$root.homeSelectShop.homeSelectShopAreaDistrictList = [];

                if (app.GetDefaultShopCodeValue() != "") {
                    app.GetDefaultShopAreaDistrictToSelectOption();                    
                }
                
                // reload the menu?
            },
            changeOrderTypeCancel() {
                this.info.order_temp_info.order_type = this.info.order_temp_info.order_type_temp;                
            },
            OrderDateTagTextDisplay(select_date) {
                var d = moment(select_date);
                if (this.getItemSubfix() == "2") {
                    return (d.format("D") + " " + this.label['common.text.date.month.text.' + d.format("M")]);
                }
                else {
                    return (this.label['common.text.date.month.text.' + d.format("M")] + d.format("D") + this.label['common.text.day.text']);
                }
            },
            changeOrderDateTag(select_date) {
                if (select_date != this.info.order_temp_info.order_date) {
                    if (this.info.order_setting.location_datetime_modify_redirect) {
                        if (this.cartItemCount > 0) {
                            var app = this;
                            this.setConfirmMsg(app.label['confirmation_msg_change_order_date_alert'], function () { app.changeOrderDateConfirm(select_date); }, null);
                        }
                        else {
                            this.changeOrderDateConfirm(select_date);
                        }
                    } else {
                        this.changeOrderDateConfirm(select_date);
                    }
                }
            },
            changeOrderDate(ev) {
                var select_date = ev.target.value;
                if (select_date != this.info.order_temp_info.order_date) {
                    if (this.info.order_setting.location_datetime_modify_redirect) {
                        if (this.cartItemCount > 0) {
                            var app = this;
                            this.setConfirmMsg(app.label['confirmation_msg_change_order_date_alert'], function () { app.changeOrderDateConfirm(select_date); }, function() { app.changeOrderDateCancel(ev); });
                        }
                        else {
                            this.changeOrderDateConfirm(select_date);
                        }
                    } else {
                        this.changeOrderDateConfirm(select_date);
                    }
                }
            },
            changeOrderDateConfirm(select_date) {
                this.info.order_temp_info.order_date = select_date;
                this.info.order_temp_info.order_time_list = this.initOrderTimeList(this.info.order_temp_info.order_date, this.info.order_temp_info.order_type);
                this.info.order_temp_info.order_time = this.info.order_temp_info.order_time_list[0];

                if (!this.info.order_setting.order_time_select) {
                    this.info.order_temp_info.order_time = "00:00";
                }

                this.SetOrderShopMenuTime();
                this.setOrderTempInfoData();

                // clear cart
                if (this.info.order_setting.location_datetime_modify_redirect) {
                    this.cart.clearCart();
                }

                // reload the menu?
            },
            changeOrderDateCancel(ev) {
                ev.target.value = this.info.order_temp_info.order_date;
            },
            changeOrderTime(ev) {
                /*
                var target_shop_menu_time = this.getShopMenuTime(this.info.order_temp_info.order_type, ev.target.value);
                if (target_shop_menu_time != this.info.order_temp_info.order_shop_menu_time) {
                    if (this.info.order_setting.location_datetime_modify_redirect) {
                        if (this.cartItemCount > 0) {
                            var app = this;
                            this.setConfirmMsg(this.label['confirmation_msg_change_order_time_alert'], function() { app.changeOrderTimeConfirm(ev); }, function() { app.changeOrderTimeCancel(ev); });
                        }
                        else {
                            this.changeOrderTimeConfirm(ev);
                        }
                    }
                    else {
                        this.changeOrderTimeConfirm(ev);
                    }
                } else {
                    this.changeOrderTimeConfirm(ev);
                }
                */

                // hide for not checking menu time on 20230602
                var app = this;
                if (this.info.order_setting.location_datetime_modify_redirect) {
                    if (this.cartItemCount > 0) {
                        this.setConfirmMsg(app.label['confirmation_msg_change_order_time_alert'], function () { app.changeOrderTimeConfirm(ev); }, function () { app.changeOrderTimeCancel(ev); });
                    }
                    else {
                        this.changeOrderTimeConfirm(ev);
                    }
                }
                else {
                    this.changeOrderTimeConfirm(ev);
                }                
            },
            changeOrderTimeConfirm(ev) {
                this.info.order_temp_info.order_time = ev.target.value;
                this.SetOrderShopMenuTime();
                this.setOrderTempInfoData();

                // clear cart
                if (this.info.order_setting.location_datetime_modify_redirect) {
                    //this.cart.clearCart(); // change to not checking menu time so hide for not clear cart on 20230602
                }

                // add updateCart for checking when update order info on 20230602
                if (this.cart.shop != null) {
                    if (this.getCurrentOrderTypeSubfix == "1") {
                        if (!(this.info.order_temp_info.order_address == null || this.info.order_temp_info.order_address == "")) {
                            this.updateCart();
                        }
                    }
                    else {
                        this.updateCart();
                    }
                }

                // reload the menu?
            },
            SetOrderShopMenuTime() {
                // not using menu time on 20230602
                /*
                this.info.order_temp_info.order_shop_menu_time = this.getShopMenuTime(this.info.order_temp_info.order_type, this.info.order_temp_info.order_time);
                console.log("SetOrderShopMenuTime", this.info.order_temp_info.order_shop_menu_time);
                */
            },
            changeOrderTimeCancel(ev) {
                ev.target.value = this.info.order_temp_info.order_time;
            },
            ChangeOrderAddressType(type, search_address) {
                var select_address_id = "search";
                if (this.cart.token != "" && this.cart.member != null && type == "member") {
                    var select_member_address = this.address_list.filter(a => a.isMemberSelect)[0];
                    select_address_id = select_member_address.address_id+"";
                    this.SetOrderDataAddressContactData(select_member_address.address_id+"","member", (select_member_address.address_tag == undefined || select_member_address.address_tag == null  ? "" : select_member_address.address_tag+""), JSON.parse(JSON.stringify(select_member_address.address)),JSON.parse(JSON.stringify(select_member_address.contact_info)));
                }
                else if (type == "search") {
                    select_address_id = "search";
                    this.SetOrderDataAddressContactData("search","search","",search_address,null);
                    if (this.cart.member != null) {
                        this.FillMemberInfoToOrderContactInfo();
                    }

                    // update address_list
                    var s_add =  this.address_list.filter(a => a.address_type == "search");
                    if (s_add.length > 0) {
                        s_add[0].address = (this.info.order_temp_info.order_address == null ? null : JSON.parse(JSON.stringify(this.info.order_temp_info.order_address)));
                        s_add[0].contact_info = (this.info.order_temp_info.order_contact_info == null ? null : JSON.parse(JSON.stringify(this.info.order_temp_info.order_contact_info)));
                    }
                    this.setCurrentAddressListStorage();
                }

                $.each(this.address_list, (i, a) => {
                    a.isSelect = false;
                    if (a["address_id"] == select_address_id) {
                        a.isSelect = true;
                    }
                });
            },
            OpenOrderInfoEditLayer(cb) {
                if (!this.info.order_setting.aspa_only) {
                    this.order_type_layer_temp = this.info.order_temp_info.order_type;
                    this.order_date_layer_temp = this.info.order_temp_info.order_date;
                    this.order_time_layer_temp = this.info.order_temp_info.order_time;
                    this.order_date_layer_list = this.info.order_temp_info.order_date_list.slice(0, this.info.order_temp_info.order_date_list.length);
                    this.order_time_layer_list = this.info.order_temp_info.order_time_list.slice(0, this.info.order_temp_info.order_time_list.length);
                    this.showOrderInfoEditLayer = true;
                    this.showOrderInfoEditLayerCallBack = (cb == null ? null : cb)
                    this.setBodyOverflow(true);
                }
            },
            CloseOrderInfoEditLayer() {
                this.order_type_layer_temp = '';
                this.order_date_layer_temp = '';
                this.order_time_layer_temp = '';
                this.order_date_layer_list = [];
                this.order_time_layer_list = [];
                this.showOrderInfoEditLayer = false;
                this.showOrderInfoEditLayerCallBack = null;
                this.setBodyOverflow(false);
            },
            UpdateOrderInfoTypeLayerTemp(type) {

                if (this.cart.shop != null) {
                    var shopCode = this.cart.shop.shopCode_global + "_" + this.getCurrentOrderTypeShopDetailsSubfix;
                    if (this.getCurrentOrderTypeShopDetailsSubfix == "3") {
                        shopCode = this.cart.shop.shopCode_global;
                    }
                    if (this.getShopInfo(shopCode, true) == null) {
                        return;
                    }
                }

                this.order_type_layer_temp = type;

                // reload layer order datetime list
                var start_date_moment = moment();
                if (this.info.order_setting.order_start_date != "today") {
                    start_date_moment = moment(this.info.order_setting.order_start_date);
                }
                this.order_date_layer_list = [];
                var temp_option_date = null;
                /*
                for (var i = this.order_date_layer_list.length; this.order_date_layer_list.length < this.info.order_setting.order_date_range; i++) {


                    temp_option_date = moment(start_date_moment).add(i, 'days');
                    if (this.info.order_setting.order_start_date == "today") {
                        //this.order_date_layer_list.push(temp_option_date.format("YYYY-MM-DD"));
                        if (parseInt(temp_option_date.format("YYYYMMDD"), 10) >= parseInt(moment().add(this.info.order_setting.order_start_from_date, 'days').format("YYYYMMDD"), 10)) {
                            this.order_date_layer_list.push(temp_option_date.format("YYYY-MM-DD"));
                        }
                    }
                    else if (this.info.order_setting.order_start_date != "today" && parseInt(temp_option_date.format("YYYYMMDD"),10) >= parseInt(moment().add(this.info.order_setting.order_start_from_date, 'days').format("YYYYMMDD"),10)) {
                        this.order_date_layer_list.push(temp_option_date.format("YYYY-MM-DD"));
                    }
                }
                */
                if (this.info.order_setting.order_start_date == "today") {                    
                    start_date_moment = start_date_moment.add(this.info.order_setting.order_start_from_date, 'days');

                    for (var i = this.order_date_layer_list.length; this.order_date_layer_list.length < this.info.order_setting.order_date_range; i++) {
                        temp_option_date = moment(start_date_moment).add(i, 'days');

                        if (this.info.order_setting.aspa_only) {
                            if (temp_option_date.format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
                                if (this.checkDateIsSatSunHoliday(temp_option_date, this.info.order_setting.holidayCount)) {
                                    this.order_date_layer_list.push(temp_option_date.format("YYYY-MM-DD"));
                                }
                            }
                        }
                        else {
                            if (this.checkDateIsSatSunHoliday(temp_option_date, this.info.order_setting.holidayCount)) {
                                this.order_date_layer_list.push(temp_option_date.format("YYYY-MM-DD"));
                            }
                        }

                        if (i >= 10) {
                            break;
                        }
                    }
                }
                else {
                    for (var i = 0; i < this.info.order_setting.order_date_range; i++) {                        
                        temp_option_date = moment(start_date_moment).add(i, 'days');

                        if (this.info.order_setting.aspa_only) {
                            if (temp_option_date.format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
                                if (parseInt(temp_option_date.format("YYYYMMDD"), 10) >= parseInt(moment().add(this.info.order_setting.order_start_from_date, 'days').format("YYYYMMDD"), 10)) {
                                    if (this.checkDateIsSatSunHoliday(temp_option_date, this.info.order_setting.holidayCount)) {
                                        this.order_date_layer_list.push(temp_option_date.format("YYYY-MM-DD"));
                                    }
                                }
                            }
                        }
                        else {
                            if (parseInt(temp_option_date.format("YYYYMMDD"), 10) >= parseInt(moment().add(this.info.order_setting.order_start_from_date, 'days').format("YYYYMMDD"), 10)) {
                                if (this.checkDateIsSatSunHoliday(temp_option_date, this.info.order_setting.holidayCount)) {
                                    this.order_date_layer_list.push(temp_option_date.format("YYYY-MM-DD"));
                                }
                            }
                        }

                        if (i >= 10) {
                            break;
                        }
                    }
                }

                this.order_time_layer_list = this.initOrderTimeList(this.order_date_layer_list[0], this.order_type_layer_temp);

                this.order_date_layer_temp = this.order_date_layer_list[0];
                this.order_time_layer_temp = this.order_time_layer_list[0];

                if (!this.info.order_setting.order_time_select) {
                    this.order_time_layer_temp = "00:00";
                }
            },
            UpdateOrderInfoDateLayerTempTag(select_date) {
                this.order_date_layer_temp = select_date;

                this.order_time_layer_list = this.initOrderTimeList(this.order_date_layer_temp, this.order_type_layer_temp);
                this.order_time_layer_temp = this.order_time_layer_list[0];

                if (!this.info.order_setting.order_time_select) {
                    this.order_time_layer_temp = "00:00";
                }
            },
            UpdateOrderInfoDateLayerTemp(ev) {
                this.UpdateOrderInfoDateLayerTempTag(ev.target.value);
            },
            UpdateOrderInfoTimeLayerTemp(ev) {
                this.order_time_layer_temp = ev.target.value;
            },
            ClickOrderInfoEditLayerBtn() {
                if (this.order_time_layer_temp != "---") {
                    if (this.order_type_layer_temp != this.info.order_temp_info.order_type ||
                            this.order_date_layer_temp != this.info.order_temp_info.order_date
                        ) {
                        if (this.info.order_setting.location_datetime_modify_redirect) {
                            if (this.cartItemCount > 0) {
                                var app = this;
                                this.setConfirmMsg(app.label['confirmation_msg_change_order_data_alert'], function() { app.OrderInfoEditConfirm(true); }, undefined);
                            }
                            else {
                                this.OrderInfoEditConfirm(true);
                            }
                        }
                        else {
                            this.OrderInfoEditConfirm(false);
                        }
                    }
                    else if (this.order_time_layer_temp != this.info.order_temp_info.order_time) {
                        /*
                        var target_shop_menu_time = this.getShopMenuTime(this.order_type_layer_temp, this.order_time_layer_temp);
                        if (target_shop_menu_time != this.info.order_temp_info.order_shop_menu_time) {

                            if (this.info.order_setting.location_datetime_modify_redirect) {
                                if (this.cartItemCount > 0) {
                                    this.setConfirmMsg(this.label['confirmation_msg_change_order_data_alert'], function() { this.OrderInfoEditConfirm(true); }, undefined);
                                }
                                else {
                                    this.OrderInfoEditConfirm(true);
                                }
                            }
                            else {
                                this.OrderInfoEditConfirm(false);
                            }

                        }
                        else {
                            this.OrderInfoEditConfirm(false);
                        }
                        */

                        // change to not checking menu time on 20230602
                        var app = this;
                        if (this.info.order_setting.location_datetime_modify_redirect) {
                            if (this.cartItemCount > 0) {
                                this.setConfirmMsg(app.label['confirmation_msg_change_order_data_alert'], function () { app.OrderInfoEditConfirm(true); }, undefined);
                            }
                            else {
                                this.OrderInfoEditConfirm(true);
                            }
                        }
                        else {
                            this.OrderInfoEditConfirm(false);
                        }                        
                    }
                    else {
                        this.CloseOrderInfoEditLayer();
                    }
                }
            },
            OrderInfoEditConfirm(reload_menu) {
                var app = this;

                var old_type = this.info.order_temp_info.order_type + "";
                this.info.order_temp_info.order_type = this.order_type_layer_temp;
                this.info.order_temp_info.order_date = this.order_date_layer_temp;
                this.info.order_temp_info.order_time = this.order_time_layer_temp;
                this.info.order_temp_info.order_date_list = this.order_date_layer_list.slice(0, this.order_date_layer_list.length);
                this.info.order_temp_info.order_time_list = this.order_time_layer_list.slice(0, this.order_time_layer_list.length);
                this.SetOrderShopMenuTime();
                this.setOrderTempInfoData();
                if (this.cart.shop != null) {
                    var shopCode = this.cart.shop.shopCode_global + "_" + this.getCurrentOrderTypeShopDetailsSubfix;
                    if (this.getCurrentOrderTypeShopDetailsSubfix == "3") {
                        shopCode = this.cart.shop.shopCode_global;
                    }
                    this.cart.shop = this.getShopInfo(shopCode, true);
                }
                this.cart.updateCartOrderInfo(this.info.order_temp_info, this.info.lang);
                this.cart.saveCart();

                if (this.showOrderInfoEditLayerCallBack != null)
                    this.showOrderInfoEditLayerCallBack();

                this.CloseOrderInfoEditLayer();

                // clear cart
                if (reload_menu) {
                    //this.cart.clearCart(); // change to not checking menu time so hide for not clear cart on 20230602
                }

                var checkingPass = true;
                var callUpdateCart = true;

                // check shop business hour
                if (checkingPass) {
                    var check_date = this.$root.OrderDateSelect;
                    var check_time = check_date.hour() * 100 + check_date.minute();

                    // shop not open
                    if (!this.cart.getShopOpen(this.cart.shop, this.$root.OrderDateSelectIsHoliday, check_date, check_time)) {
                        //this.cart.shop = null;
                        //this.cart.saveCart();  


                        /*
                        if (old_type != this.info.order_temp_info.order_type && (this.info.order_temp_info.order_address == null || this.info.order_temp_info.order_address == "")) {
                            this.$router.replace("/");
                        }
                        else {
                            if (!this.checkShoppingTypeAreaDistrict()) {
                                this.$router.replace("/");
                            }
                            else {
                                this.$router.replace("/shop");
                            }
                        }
                        */

                        // back to home if shop is not open
                        this.alert(this.label['shop.offline']); // add alert message on 20230602
                        this.$router.replace("/");
                        callUpdateCart = false;
                    }

                    // shop is open
                    else {

                        if (old_type != this.info.order_temp_info.order_type) {

                            // clear cart when change order type on 20230602
                            if (this.info.order_setting.location_datetime_modify_redirect) {
                                this.cart.clearCart();
                            }

                            if (this.info.order_temp_info.order_address == null || this.info.order_temp_info.order_address == "") {
                                this.$router.replace("/");
                            }
                            else {

                                // update and check shop list
                                app.info.loading = true;
                                app.updateCurrentLLShopList(function () { app.OrderInfoEditConfirmShopListCheckingCB(reload_menu, callUpdateCart); });

                            }
                        }
                        else {
                            // hide for come bugs that menu page reload will contains some bugs
                            /*
                            if (reload_menu && this.info.currentPathName.startsWith("/menu")) {
                                this.$router.replace("/menu");
                                /this.$router.go(this.$router.currentRoute);
                            }
                            */
                        }

                    }
                }

                // add updateCart for checking when update order info on 20230602
                if (this.cart.shop != null && callUpdateCart) {
                    if (this.getCurrentOrderTypeSubfix == "1") {
                        if (!(this.info.order_temp_info.order_address == null || this.info.order_temp_info.order_address == "")) {
                            this.updateCart();
                        }
                    }
                    else {
                        this.updateCart();
                    }
                }
            },
            OrderInfoEditConfirmShopListCheckingCB(reload_menu, callUpdateCart) {
                var app = this;
                app.info.loading = false;

                if (callUpdateCart) {
                    var LLshopInfo = app.getLLShopInfo(app.cart.shop.shopCode);
                    if (LLshopInfo == null) {
                        this.$router.replace("/");
                    }
                    else {
                        if (LLshopInfo.isOnline) {
                            this.SetOrderShopMenuTime();

                            if (!this.checkShoppingTypeAreaDistrict()) {
                                this.$router.replace("/");
                            }
                            else {
                                // reload the menu
                                if (reload_menu && this.info.currentPathName.startsWith("/menu")) {
                                    this.$router.replace("/menu");
                                    this.$router.go(this.$router.currentRoute);
                                }
                                // back to menu
                                else if (reload_menu && this.info.currentPathName == "/checkout") {
                                    this.$router.replace("/menu");
                                }

                            }

                        }
                    }
                }
            },

            MenuPageChangeOrderType(type) {
                var typeSubfix = "2";
                if (type == "delivery") {
                    typeSubfix = "1";
                }
                else if (type == "pickup") {
                    typeSubfix = "2";
                }
                else if (type == "pickupShop") {
                    typeSubfix = "3"
                }

                if (this.cart.shop != null) {
                    if (this.getShopInfo(this.cart.shop.shopCode_global + "_" + typeSubfix) == null) {
                        return;
                    }
                }

                if (type != this.info.order_temp_info.order_type) {
                    if (this.info.order_setting.location_datetime_modify_redirect) {
                        if (this.cartItemCount > 0) {
                            var app = this;
                            this.setConfirmMsg(app.label['confirmation_msg_change_order_type_alert'], function() { app.MenuPageChangeOrderTypeConfirm(true, type); }, undefined);
                        }
                        else {
                            this.MenuPageChangeOrderTypeConfirm(true, type);
                        }
                    }
                    else {
                        this.MenuPageChangeOrderTypeConfirm(false, type);
                    }
                }                
                else {
                }                
            },
            MenuPageChangeOrderTypeConfirm(reload_menu, type) {
                var app = this;

                var old_type = this.info.order_temp_info.order_type + "";
                this.info.order_temp_info.order_type = type;
                
                this.SetOrderShopMenuTime();
                this.setOrderTempInfoData();
                if (this.cart.shop != null) {
                    var shopCode = this.cart.shop.shopCode_global + "_" + this.getCurrentOrderTypeShopDetailsSubfix;
                    if (this.getCurrentOrderTypeShopDetailsSubfix == "3") {
                        shopCode = this.cart.shop.shopCode_global;
                    }
                    this.cart.shop = this.getShopInfo(shopCode, true);
                }
                this.cart.updateCartOrderInfo(this.info.order_temp_info, this.info.lang);
                this.cart.saveCart();

                var checkingPass = true;
                var callUpdateCart = true;

                // check shop business hour
                if (checkingPass) {
                    var check_date = this.$root.OrderDateSelect;
                    var check_time = check_date.hour() * 100 + check_date.minute();

                    // shop not open
                    if (!this.cart.getShopOpen(this.cart.shop, this.$root.OrderDateSelectIsHoliday, check_date, check_time)) {
                        // back to home if shop is not open
                        this.alert(this.label['shop.offline']); // add alert message on 20230602
                        this.$router.replace("/");
                        callUpdateCart = false;
                    }

                    // shop is open
                    else {

                        if (old_type != this.info.order_temp_info.order_type) {

                            // clear cart when change order type on 20230602
                            if (this.info.order_setting.location_datetime_modify_redirect) {
                                this.cart.clearCart();
                            }

                            if (this.info.order_temp_info.order_address == null) {
                                this.$router.replace("/");
                            }
                            else {

                                // update and check shop list
                                app.info.loading = true;
                                app.updateCurrentLLShopList(function () { app.MenuPageChangeOrderTypeConfirmShopListCheckingCB(reload_menu, callUpdateCart); });

                            }
                        }
                        else {
                        }

                    }
                }

                // add updateCart for checking when update order info on 20230602
                if (this.cart.shop != null && callUpdateCart) {
                    if (this.getCurrentOrderTypeSubfix == "1") {
                        if (!(this.info.order_temp_info.order_address == null)) {
                            this.updateCart();
                        }
                    }
                    else {
                        this.updateCart();
                    }
                }
            },
            MenuPageChangeOrderTypeConfirmShopListCheckingCB(reload_menu, callUpdateCart) {
                var app = this;
                app.info.loading = false;

                if (callUpdateCart) {
                    var LLshopInfo = app.getLLShopInfo(app.cart.shop.shopCode);
                    if (LLshopInfo == null) {
                        this.$router.replace("/");
                    }
                    else {
                        if (LLshopInfo.isOnline) {
                            this.SetOrderShopMenuTime();

                            if (!this.checkShoppingTypeAreaDistrict()) {
                                this.$router.replace("/");
                            }
                            else {
                                // reload the menu
                                if (reload_menu && this.info.currentPathName.startsWith("/menu")) {
                                    this.$router.replace("/menu");
                                    this.$router.go(this.$router.currentRoute);
                                }

                            }
                        }
                    }
                }
            },

            checkShoppingTypeAreaDistrict() {
                var app = this;
                if (app.$root.CheckOrderModeIsShopping && (this.$root.CheckOrderOrderTypeIdx(app.cart) == 2 || this.$root.CheckOrderOrderTypeIdx(app.cart) == 3)) {
                    if (app.cart.shopArea != "" && app.cart.shopDistrict != "") {
                        return true;
                    }
                    else {
                        //app.$router.replace("/");
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            getShopMenuTime(order_type, time_range_string) {
                var re = "00:00";

                if (this.cart.shop != null) {
                    var displayShop = this.getShopInfo(this.cart.shop.shopCode);

                    var check_time = moment();
                    if (time_range_string == "asap") {
                        /*
                        var LLshopInfo = this.getLLShopInfo(this.cart.shop.shopCode);
                        if (LLshopInfo != null)
                            check_time = check_time.add(LLshopInfo.quoteTime, 'minutes');

                        //if (order_type == "delivery") {
                            //check_time = check_time.add(shopInfo.quoteTime,'minutes');
                        //}
                        check_time = moment("2000-01-01 " + check_time.format("HH:mm"));
                        */

                        // use current time for asap
                        check_time = moment("2000-01-01 " + check_time.format("HH:mm"));
                    } else {
                        check_time = moment("2000-01-01 " + time_range_string.split('-')[0].replace(/ /g,''));
                    }

                    var time_arr = null;
                    var time_a = null;
                    var time_b = null;
                    for(var i=0; i<displayShop.menuTimeRange.length;i++) {
                        time_arr = displayShop.menuTimeRange[i].timeRange.split('-');
                        if (time_arr.length > 1) {
                            time_a = moment("2000-01-01 " + time_arr[0]);
                            time_b = moment("2000-01-01 " + time_arr[1]);
                        }
                        else {
                            time_a = moment("2000-01-01 " + time_arr[0]);
                            time_b = moment("2000-01-01 " + time_arr[0]);
                        }

                        //console.log("check_time",check_time);
                        //console.log("time_a",time_a);
                        //console.log("time_b",time_b);

                        //if (time_a <= check_time && check_time <= time_b) { // for check time is not end as 00 (eg: 11:59)
                        if (time_a <= check_time && check_time < time_b) { // for check time is end as 00 (eg: 12:00)
                            re = displayShop.menuTimeRange[i].menuTime;
                            break;
                        }
                    }
                }

                return re;
            },
            SetOrderDataAddressContactData(address_id, address_type, address_tag, address, contact_info) {
                this.info.order_temp_info.order_address_id = address_id;
                this.info.order_temp_info.order_address_type = address_type;
                this.info.order_temp_info.order_address_tag = address_tag;
                this.info.order_temp_info.order_address = (address == null ? null : JSON.parse(JSON.stringify(address)));
                this.info.order_temp_info.order_contact_info = (contact_info == null ? null : JSON.parse(JSON.stringify(contact_info)));
                this.setOrderTempInfoData();
            },
            ResetOrderTempInfoSearchType() {
                this.info.order_temp_info.order_address_id = "search";
                this.info.order_temp_info.order_address_type = "search";
                this.info.order_temp_info.order_address_tag = "";
                this.info.order_temp_info.order_contact_info = null; // for guest mode need keep contact info??

                var search_address_obj = { "address_id":"search", "address_type":"search", "address_tag": "", "address": (this.info.order_temp_info.order_address == null ? null : JSON.parse(JSON.stringify(this.info.order_temp_info.order_address))), "contact_info": null, isDefault:false, isSelect:true, isSave:false, isMemberSelect:false };
                //var search_address_obj = { "address_id": "search", "address_type": "search", "address_tag": "", "address": (this.info.order_temp_info.order_address == null ? null : JSON.parse(JSON.stringify(this.info.order_temp_info.order_address))), "contact_info": (this.info.order_temp_info.order_contact_info == null ? null : JSON.parse(JSON.stringify(this.info.order_temp_info.order_contact_info))), isDefault: false, isSelect: true, isSave: false, isMemberSelect: false };
                if (this.address_list.length > 0) {
                    this.address_list[0] = JSON.parse(JSON.stringify(search_address_obj));
                }
                else {
                    this.address_list.push(JSON.parse(JSON.stringify(search_address_obj)));
                }

                this.setOrderTempInfoData();
            },
            // for order data end

            // for member start
            sendMemberIDTokenLogin(accessToken, refreshToken, reRun) {
                var app = this;
                if (reRun == undefined || reRun == null) {
                    reRun = true;
                }

                this.info.loading = true;
                this.$root
                    .wsPostAsync(
                        this.info.wsUrl + "/Order/Login",
                        this.lang,
                        JSON.stringify({ data: { token: this.cart.token, accessToken: accessToken, refreshToken: refreshToken } }),
                        (data) => {
                            this.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                            //console.log("serverTimeDiff", this.$root.serverTimeDiff);
                            console.log("sendMemberIDTokenLogin", data);
                            const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";

                            if ((data.aToken != undefined && data.aToken != null && data.aToken != '') && (data.rToken != undefined && data.rToken != null && data.rToken != ''))
                                UpdateARToken(app.info.order_temp_info.order_device, data.aToken, data.rToken);
									
                            if (data.status == 0) {
                                this.cart.token = data.token;
                                $.extend(this.cart, data.cart);
                                //this.cart.updateCart();
                                this.cart.saveCart();

                                // update order contact info
                                if (this.info.order_temp_info.order_address_type == "search" && this.cart.member != null) {
                                    this.$root.FillMemberInfoToOrderContactInfo();
                                    this.$root.setOrderTempInfoData();
                                }

                                this.$root.GetMemberAddressList();
                                this.$root.GetMemberPreferShopList();

                                this.info.loading = false;
                            } else {
                                //this.$root.alert(data.message);

                                this.cart.member = null;
                                this.cart.saveCart();

                                this.info.loading = false;

                                // close webview when login fail
                                if (data_msg == "item.updated") {
                                    this.$root.alert(data.message);
                                } else {
                                    this.memberSessionNotFound(data.message);
                                }                                
                            }
                        }
                    )
                    .always(() => {
                        //this.info.loading = false;
                    })
                    .fail((e) => {
                        //this.$root.alert("Fail!");
                        //this.$root.alert("common_fail_message");

                        var isReRun = false;
                        if (!reRun) {
                            //this.$root.setConfirmMsg("sendMemberIDTokenLogin: " + JSON.stringify(e), undefined, undefined);
                            console.log(e);
                            this.$root.alert("common_fail_message");
                        }
                        try {
                            if (!(e.status == 0 && e.readyState == 0)) {
                                //this.$root.alert(e);
                                console.log(e);
                                this.$root.alert("common_fail_message");
                            }
                            else {
                                // try run the function once
                                if (reRun)
                                    this.sendMemberIDTokenLogin(accessToken, refreshToken, false);
                            }
                        }
                        catch {
                            //this.$root.alert(e);
                            console.log(e);
                            this.$root.alert("common_fail_message");
                        }

                        if (!isReRun) {
                            this.info.loading = false;
                        }
                    });
            },
            CommonFAQClick() {
                //this.$router.push("/page/sl/faq" + this.GetDefaultShopCodeValue());
                this.$router.push("/page/sl/faq");
                this.topShowMoreClose();
            },
            CommonAppDownloadPage() {
                //this.$router.push("/download");
                //this.topShowMoreClose();
                window.open("/download");
            },

            goToLoginPage(redirect_path, isReplace) {
                if (this.info.gt_login_page_url == "")
                    this.GetConfingJson();

                var login_url = "/guestlogin";
                //var login_url = this.info.gt_login_page_url + "/" + this.info.langws + "/login";                
                //login_url = login_url + "?clientId=" + encodeURIComponent(this.info.gt_clientId) + "&redirectPath=" + encodeURIComponent(redirect_path);
                //login_url = login_url + "?redirectPath=" + encodeURIComponent(redirect_path);
                //login_url = login_url + "?redirectPath=" + redirect_path;
                console.log("login_url", login_url);
                if (isReplace) {
                    window.location.replace(login_url);
                }
                else {
                    //window.open(login_url, "_self");
                    window.location.href = login_url;
                }                
            },
            goToLoginPageApp(redirect_path) {
                if (this.info.gt_login_page_url_app == "")
                    this.GetConfingJson();

                var login_url = this.info.gt_login_page_url_app;
                login_url = login_url + "?redirecturl=" + encodeURIComponent(redirect_path);
                //window.open(login_url, "_self");
                window.location.href = login_url;
            },
            LoginBtnClickGuestLoginPage() {
                this.topShowMoreClose();
                this.$root.page_after_login += (this.$root.page_after_login.includes('?') ? "&" : "?") + "device=" + this.info.order_temp_info.order_device;
                this.goToLoginPage(this.info.currentDomain + this.$root.page_after_login, true);
            },
            LoginBtnClick() {
                /*
                if (!this.info.currentPathName.startsWith("/guestlogin")) {
                    this.page_after_login = this.info.currentPathName;
                    this.$router.push("/guestlogin");
                }
                */
                this.topShowMoreClose();

                this.$root.page_after_login = this.info.currentPathName + "";
                this.$root.page_after_login += (this.$root.page_after_login.includes('?') ? "&" : "?") + "device=" + this.info.order_temp_info.order_device;

                if (this.info.order_temp_info.order_device == 'web') {
                    this.goToLoginPage(this.info.currentDomain + this.$root.page_after_login);
                }
                else {
                    this.goToLoginPage(this.info.currentDomain + this.$root.page_after_login);
                }
            },
            LogoutBtnClick() {
                var app = this;
                app.info.loading = true;
                app.$root
                    .wsPost(
                        app.info.wsUrl + "/Order/Logout?token=" + encodeURIComponent(this.cart.token),
                        app.lang,
                        JSON.stringify({}),
                        (data) => {
                            app.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                            //console.log("serverTimeDiff", this.$root.serverTimeDiff);
                            console.log("Logout", data);
                            if (data.status == 0) {
                                //app.topShowMoreClose();
                                app.cart.member = null;
                                app.cart.memberAddress = [];
                                $.extend(app.cart, data.cart);                                
                                this.cart.saveCart();

                                // reset address list and change current address type to search
                                app.ResetOrderTempInfoSearchType();
                                app.UpdateCurrentAddressList();

                                app.$router.go(app.$router.currentRoute);
                                
                            } else {
                                app.$root.alert(data.message);
                                app.info.loading = false;
                            }
                        }
                    )
                    .always(() => {
                        //this.info.loading = false;
                    })
                    .fail(() => {
                        //this.$root.alert("Fail!");
                        app.$root.alert("common_fail_message");
                        app.info.loading = false;
                    });
            },
            ReloadCurrentPage() {
                window.location.replace(window.location.href + "");
            },

            MemberProfileClick() {
                this.$router.push("/member/profile");
                this.topShowMoreClose();
            },
            MemberMyOrderClick() {
                this.$router.push("/member/orderhistory");
                this.topShowMoreClose();
            },
            GetMemberAddressList() {
                var app = this;
                if (app.cart.token != "" && app.cart.member != null) {
                    app.wsGetAsync(
                        app.info.wsUrl + "/Order/GetMemberAddress?token=" + encodeURIComponent(app.cart.token),
                        app.lang,
                        data => {
                            //console.log("GetMemberAddressList",data);

                            if (data.status == 0) {
                                // add isSelect field
                                $.each(data.address, (i, a) => {
                                    a["address_type"] = "member";
                                    a.isSave = true;
                                    a.isSelect = false; // change to true in address_list when order_address_type = member

                                    if (a.isDefault) {
                                        a.isMemberSelect = true; // for member address list itself
                                    }
                                    else {
                                        a.isMemberSelect = false;
                                    }

                                    a.contact_info["email"] = app.cart.member["email"];
                                });

                                app.cart.memberAddress = data.address;
                            }
                            else {
                                // reset data if session timeout
                                this.cart.resetSessionTimeout();
                                this.address_list = [];
                                this.ResetOrderTempInfoSearchType();
                            }
                            app.cart.saveCart();

                            // update current address list
                            this.UpdateCurrentAddressList(true);
                        }
                    );
                }
            },
            UpdateSaveMemberAddressList(save_address_list) {
                //console.log("UpdateSaveMemberAddressList", save_address_list);
                var re = true;
                var app = this;
                if (app.cart.token != "" && app.cart.member != null) {
                    app.$root
                    .wsPostAsync(
                        app.info.wsUrl + "/Order/UpdateMemberAddress",
                        app.lang,
                        JSON.stringify({
                            data: { addresses: save_address_list, token: app.cart.token },
                        }),
                        (data) => {
                            app.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                            //console.log("serverTimeDiff", this.$root.serverTimeDiff);
                            console.log("UpdateMemberAddressList", data);
                            const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";

                            if (data.status == 0) {
                            } else {
                                if (data_msg == "seesion.not.found") {
                                    this.$root.alert('session_timeout_label');
                                    re = false;

                                    this.modifyAddressClose();
                                    this.cart.resetSessionTimeout();
                                    this.address_list = [];
                                    this.ResetOrderTempInfoSearchType();
                                    this.$router.replace("/");
                                }
                                else {
                                    this.$root.alert(data.message);
                                    re = false;
                                }
                            }
                        }
                    )
                    .always(() => {
                    })
                    .fail(() => {
                        //this.$root.alert("Fail!");
                        this.$root.alert("common_fail_message");
                        re = false;
                    });
                }

                return re;
            },
            UpdateCurrentAddressList(get_address_list) {
                //console.log("get_address_list",get_address_list);
                // address_list seq are search address -> member address -> member not save address

                // keep the temp address
                var search_modify_address_list = this.modify_address_list.filter(a => a["address_type"] == "search");
                if (search_modify_address_list.length <= 0 && get_address_list) {
                    search_modify_address_list = this.address_list.filter(a => a["address_type"] == "search");
                }
                var nosave_modify_address_list = this.modify_address_list.filter(a => a["address_type"] == "member" && !a.isSave);
                if (nosave_modify_address_list.length <= 0 && get_address_list) {
                    nosave_modify_address_list = this.address_list.filter(a => a["address_type"] == "member" && !a.isSave);
                }
                var nosave_modify_address_list_isMemberSelect = nosave_modify_address_list.filter(a => a.isMemberSelect);
                //console.log("search_modify_address_list",search_modify_address_list);
                //console.log("nosave_modify_address_list",nosave_modify_address_list);
                //console.log("nosave_modify_address_list_isMemberSelect",nosave_modify_address_list_isMemberSelect.length);

                // check address_list contains isMemberSelect
                var address_list_isMemberSelect = [];
                if (get_address_list) {
                    address_list_isMemberSelect = this.address_list.filter(a => a.isMemberSelect);
                }

                // reset address_list
                this.address_list = [];

                // copy member address first
                if (this.cart.token != "" && this.cart.member != null) {
                    this.address_list = this.cart.memberAddress.slice();
                    //this.address_list = JSON.parse(JSON.stringify(this.cart.memberAddress));
                }

                var address_isSelect = false;
                if (this.address_list.length > 0) {

                    // check order_address_type = member
                    if (this.info.order_temp_info.order_address_type == "member") {
                        //this.address_list.filter(a => a.address_id == this.info.order_temp_info.order_address_id)[0].isSelect = true;
                        $.each(this.address_list, (i, a) => {
                            if (a["address_id"] == this.info.order_temp_info.order_address_id) {
                                address_isSelect = true;
                                a.isSelect = true;
                                a.isMemberSelect = true;
                                //return false;
                            }
                            else {
                                // update all member address isMemberSelect to false if member address is selected
                                if (nosave_modify_address_list_isMemberSelect.length > 0 || address_list_isMemberSelect.length > 0) {
                                    a.isMemberSelect = false;
                                }
                            }

                        });


                    }

                }

                if (search_modify_address_list <= 0) {
                    // create a empty "address_type":"search"
                    var search_obj = {"address_id":"search","address_type":"search","address_tag":""};
                    search_obj.address = JSON.parse(JSON.stringify(this.info.order_temp_info.order_address_sample));
                    search_obj.contact_info = JSON.parse(JSON.stringify(this.info.order_temp_info.order_contact_info_sample));
                    search_obj.isDefault = false;
                    search_obj.isSelect = (this.info.order_temp_info.order_address_type == "search" ? true : false);
                    address_isSelect = search_obj.isSelect;
                    search_obj.isSave = false;

                    // check order_address_type = search
                    if (this.info.order_temp_info.order_address_type == "search") {
                        search_obj.isSelect = true;
                        if (this.info.order_temp_info.order_address != null) {
                            /*
                            search_obj.address["address_full_zh"] = this.info.order_temp_info.order_address["address_full_zh"];
                            search_obj.address["address_full_en"] = this.info.order_temp_info.order_address["address_full_en"];
                            search_obj.address["address_full_sc"] = this.info.order_temp_info.order_address["address_full_sc"];
                            search_obj.address["address_zh"] = this.info.order_temp_info.order_address["address_zh"];
                            search_obj.address["address_en"] = this.info.order_temp_info.order_address["address_en"];
                            search_obj.address["address_sc"] = this.info.order_temp_info.order_address["address_sc"];
                            search_obj.address["block"] = this.info.order_temp_info.order_address["block"];
                            search_obj.address["floor"] = this.info.order_temp_info.order_address["floor"];
                            search_obj.address["flat"] = this.info.order_temp_info.order_address["flat"];
                            search_obj.address["location"] = this.info.order_temp_info.order_address["location"];
                            */
                            search_obj.address = JSON.parse(JSON.stringify(this.info.order_temp_info.order_address));
                        }
                        if (this.info.order_temp_info.order_contact_info != null) {
                            /*
                            search_obj.contact_info["name"] = this.info.order_temp_info.order_contact_info["name"];
                            search_obj.contact_info["tel"] = this.info.order_temp_info.order_contact_info["tel"];
                            search_obj.contact_info["tel_countryCode"] = this.info.order_temp_info.order_contact_info["tel_countryCode"];
                            search_obj.contact_info["tel2"] = this.info.order_temp_info.order_contact_info["tel2"];
                            search_obj.contact_info["tel2_countryCode"] = this.info.order_temp_info.order_contact_info["tel2_countryCode"];
                            search_obj.contact_info["email"] = this.info.order_temp_info.order_contact_info["email"];
                            */
                            search_obj.contact_info = JSON.parse(JSON.stringify(this.info.order_temp_info.order_contact_info));
                        }
                    }

                    // add search address to array top
                    this.address_list.splice(0,0,JSON.parse(JSON.stringify(search_obj)));
                }
                else {
                    // copy search address if modify address contain "search" address
                    this.address_list.splice(0,0,JSON.parse(JSON.stringify(search_modify_address_list[0])));
                }

                // append nosave address to address list
                //console.log("address_isSelect", address_isSelect);
                //console.log("nosave_modify_address_list",nosave_modify_address_list);
                $.each(nosave_modify_address_list, (i, a) => {
                    if (address_isSelect) {
                        a.isSelect = false;
                    }
                    this.address_list.push(JSON.parse(JSON.stringify(a)));
                });

                // reset isSelect
                $.each(this.$root.address_list, (i, a) => {
                    if (this.info.order_temp_info.order_address_type == "search") {
                        if (a.address_id == "search") {
                            a.isSelect = true;
                        }
                        else {
                            a.isSelect = false;
                        }
                    }
                    else {
                        if (a.address_id == this.info.order_temp_info.order_address_id) {
                            a.isSelect = true;
                        }
                        else {
                            a.isSelect = false;
                        }
                    }
                });

                //console.log("this.address_list",this.address_list);
                this.setCurrentAddressListStorage();
            },
            setCurrentAddressListStorage() {
                window.localStorage.setItem("CurrentAddressListStorage", JSON.stringify(this.address_list));
            },
            getCurrentAddressListStorage() {
                var p = window.localStorage.getItem("CurrentAddressListStorage") || "";
                if (p != "") {
                    this.address_list = JSON.parse(p);
                }
            },
            removeCurrentAddressListStorage() {
                this.address_list = [];
                window.localStorage.removeItem("CurrentAddressListStorage");
            },
            FillMemberInfoToOrderContactInfo() {
                this.info.order_temp_info.order_contact_info = JSON.parse(JSON.stringify(this.info.order_temp_info.order_contact_info_sample));
                this.info.order_temp_info.order_contact_info.name = this.cart.member.name;
                this.info.order_temp_info.order_contact_info.tel = this.cart.member.phone;
                this.info.order_temp_info.order_contact_info.tel_countryCode = this.cart.member.countryCode;
                this.info.order_temp_info.order_contact_info.email = this.cart.member.email;
                this.setOrderTempInfoData();

                // update address_list
                if (this.info.order_temp_info.order_address_type == "search") {
                    var s_add =  this.address_list.filter(a => a.address_type == "search");
                    if (s_add.length > 0) {
                        s_add[0].contact_info = (this.info.order_temp_info.order_contact_info == null ? null : JSON.parse(JSON.stringify(this.info.order_temp_info.order_contact_info)));
                    }
                    this.setCurrentAddressListStorage();
                }
            },
            GetMemberPreferShopList() {
                //console.log("GetMemberPreferShopList");
                var app = this;
                if (app.cart.token != "" && app.cart.member != null) {
                    app.wsGetAsync(
                        app.info.wsUrl + "/Order/GetMemberPreferShopList?token=" + encodeURIComponent(app.cart.token),
                        app.lang,
                        data => {
                            console.log("GetMemberPreferShopList",data);

                            if (data.status == 0) {
                                app.member_prefer_shop_list = data.shopList;
                                app.SetMemberPreferShopList();
                            }
                            else {
                                // reset data if session timeout
                                app.cart.resetSessionTimeout();
                                app.member_prefer_shop_list = [];
                                app.SetMemberPreferShopList();
                            }
                            app.cart.saveCart();
                        }
                    );
                }
            },
            UpdateMemberPreferShopList(setShopList) {
                //console.log("UpdateMemberPreferShopList");
                var re = true;
                var app = this;
                if (app.cart.token != "" && app.cart.member != null) {
                    app.info.loading = true;
                    app.$root
                        .wsPostAsync(
                            app.info.wsUrl + "/Order/UpdateMemberPreferShopList",
                            app.lang,
                            JSON.stringify({
                                data: { shopList: app.member_prefer_shop_list, token: app.cart.token },
                            }),
                            (data) => {
                                app.info.loading = false;
                                app.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                                //console.log("serverTimeDiff", this.$root.serverTimeDiff);
                                console.log("UpdateMemberPreferShopList", data);
                                const data_msg = (data.message != undefined && data.message != null) ? data.message.replace("EXMessage: ", "") : "";

                                if (data.status == 0) {
                                    app.member_prefer_shop_list = data.shopList;
                                    if (setShopList) app.SetMemberPreferShopList();
                                } else {
                                    if (data_msg == "seesion.not.found") {
                                        app.$root.alert('session_timeout_label');
                                        re = false;

                                        app.cart.resetSessionTimeout();
                                        app.member_prefer_shop_list = [];
                                        app.SetMemberPreferShopList();
                                        app.$router.replace("/");
                                    }
                                    else {
                                        app.$root.alert(data.message);
                                        re = false;
                                    }
                                }
                            }
                        )
                        .always(() => {
                        })
                        .fail(() => {
                            //this.$root.alert("Fail!");
                            this.$root.alert("common_fail_message");
                            re = false;
                        });
                }

                return re;
            },
            UpdateMemberPreferShopCode(shopCode, setShopList) {
                var app = this;                
                const idx = app.member_prefer_shop_list.indexOf(shopCode)
                if (idx >= 0) {
                    /*
                    app.setConfirmMsg("Confirm Remove?", function () {
                        app.member_prefer_shop_list.splice(idx, 1);
                        app.UpdateMemberPreferShopList(setShopList);
                    }, undefined);                    
                    */
                    app.member_prefer_shop_list.splice(idx, 1);
                    app.UpdateMemberPreferShopList(setShopList);
                }
                else {
                    /*
                    app.setConfirmMsg("Confirm Add?", function () {
                        app.member_prefer_shop_list.push(shopCode);
                        app.UpdateMemberPreferShopList(setShopList);
                    }, undefined);                      
                    */
                    app.member_prefer_shop_list.push(shopCode);
                    app.UpdateMemberPreferShopList(setShopList);
                }
            },
            CheckMemberPreferShopcontainsShopCode(shopCode) {
                var app = this;                
                const idx = app.member_prefer_shop_list.indexOf(shopCode)
                if (idx >= 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            SetMemberPreferShopList() {
                var app = this;
                app.memberPreferShopList = [];
                //console.log('SetMemberPreferShopList',app.member_prefer_shop_list);
                if (app.member_prefer_shop_list.length > 0) {
                    var temp_shop = [];
                    var o = null;
                    var check_date = moment(app.$root.OrderDateSelectMenuTime);
                    var check_time = check_date.hour() * 100 + check_date.minute();
                    //console.log('app.$root.LLShopList', app.$root.LLShopList);
                    $.each(app.member_prefer_shop_list, (i, s) => {                        
                        $.each(app.$root.LLShopList.filter(s1 => s1.shopCode == s), (i, s1) => {
                            temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType == app.$root.info.order_temp_info.order_mode && (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode)));
                            if (temp_shop.length > 0) {
                                o = temp_shop[0];
                                o.isOpen = false;
                                o.isOnline = s1.isOnline;
                                //if (o.visible != "y") o.isOnline = false; // not checking visible on tenren
                                o.distance = -1; // add distance on 20251217

                                if (o.isOnline) {
                                    o.isOpen = app.cart.getShopOpen(o, app.$root.OrderDateSelectIsHoliday, check_date, check_time);
                                }

                                app.memberPreferShopList.push(o);
                            }
                        });
                    });
                }

                app.memberPreferShopList = multiSort(app.memberPreferShopList, { "isOpen": "desc", "distance": "asc" });
            },

            openWhatsAppMessageURL(order) {
                var text = this.label['order_history_whatsapp_text_order_no'] + " " + order.orderNo + "\r\n" +
                            this.label['order_history_whatsapp_text_member_no'] + " " + order.member.memberCode + "\r\n" +
                            this.label['order_history_whatsapp_text_shop_name'] + " " + order.shop['name'+this.getItemSubfix()] + "\r\n" +
                            this.label['order_history_whatsapp_text_member_name'] + " " + order.member.name + "";
                
                if (this.info.order_temp_info.order_device == "web") {
                    //window.open(this.whatsappLinkWeb + "" + this.$root.whatsappNo + "?text=" + encodeURIComponent(text));
                     // for single webview
                    window.location.href = this.whatsappLinkWeb + "" + this.$root.whatsappNo + "?text=" + encodeURIComponent(text);
                }
                else {
                    if (this.NFExternalAppBrowser == "") {
                        //window.open(this.whatsappLink + "?phone=" + this.$root.whatsappNo + "&text=" + encodeURI(text));
                        //window.open(this.whatsappLinkWeb + "" + this.$root.whatsappNo + "?text=" + encodeURI(text));
                        // for single webview
                        window.location.href = this.whatsappLinkWeb + "" + this.$root.whatsappNo + "?text=" + encodeURI(text);
                    }
                    else {
                        //window.open(this.NFExternalAppBrowser + encodeURIComponent(this.whatsappLink + "?phone=" + this.$root.whatsappNo + "&text=" + encodeURI(text)));
                        // for single webview
                        window.location.href = this.NFExternalAppBrowser + encodeURIComponent(this.whatsappLink + "?phone=" + this.$root.whatsappNo + "&text=" + encodeURI(text));
                    }
                }
            },
            getCountryCodeList() {
                this.$root.wsGetAsync(
                    "/files/countryCode.json",
                    this.lang,
                    data => {
                        this.countryCodeList = data.list;
                    }
                );   
            },
            memberSessionNotFound(str) {
				str = (str != undefined && str != null) ? str.replace("EXMessage: ", "") : "member.seesion.not.found";
                str = (this.label[str] || str);
                this.cart.member = null;
                this.cart.name = "";
                this.cart.email = "";
                this.cart.phone = "";

                if (this.cart != null && this.cart.token != null && this.cart.token != "") {
                    this.updateCart();
                }

                this.$router.replace("/");
                if (this.info.order_temp_info.order_device == "web") {
                    this.info.alertMsg = str;
                }
                else {
                    if (str.indexOf("401") == 0) {
                        str = this.label['member.seesion.401'];
					}
                    CloseWebView(this.info.order_temp_info.order_device, str);
                }
            },
            pageCloseWebView() {
                CloseWebView(this.info.order_temp_info.order_device);
            },
            // for member end

            // FlowArrow start
            FlowArrowCheck() {
                if (window.innerWidth <= this.info.responsive_width) {
                    var checkout_flow_arrow = $("#checkout_flow_arrow");
                    //console.log("checkout_flow_arrow", checkout_flow_arrow.length);
                    if (checkout_flow_arrow.length > 0) {
                        checkout_flow_arrow.show();
                        let documentHeight = document.body.scrollHeight;
                        let currentScroll = window.scrollY + window.innerHeight;
                        if (currentScroll >= documentHeight) {
                            checkout_flow_arrow.removeClass("down").addClass("up");
                            return true;
                        }
                        else {
                            checkout_flow_arrow.removeClass("up").addClass("down");
                            return false;
                        }
                    }
                }
            },
            FlowArrowClick() {                
                if (this.FlowArrowCheck()) {
                    $("html, body").animate({ scrollTop: 0 }, 200);
                }
                else {
                    $("html, body").animate({ scrollTop: $(document).height() }, 200);
                }
            },
            // FlowArrow end

            // update cart shop info start
            UpdateCartShopInfo(shopObj) {
                if (this.cart != null && shopObj != null) {
                    this.cart.itemsLimit = shopObj.itemsLimit;
                }                
            },
            CheckPhoneFormat(phone) {
                /*
                if (phone.charAt(0) == "+") {
                    return (/^[+]\d+$/).test(phone);
                }
                else {
                    return (/^[0-9]{8,8}$/).test(phone);
                }
                */
                //return (/^\d+$/).test(phone);
                return (/^[0-9]{8,8}$/).test(phone);
            }
            // update cart shop info end


        } // end method
    };
</script>
